(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './skiko.mjs', './js-reexport-symbols.mjs', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./skiko.mjs'), require('./js-reexport-symbols.mjs'), require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['./skiko.mjs'] === 'undefined') {
      throw new Error("Error loading module 'skiko-kjs'. Its dependency './skiko.mjs' was not found. Please, check whether './skiko.mjs' is loaded prior to 'skiko-kjs'.");
    }
    if (typeof globalThis['./js-reexport-symbols.mjs'] === 'undefined') {
      throw new Error("Error loading module 'skiko-kjs'. Its dependency './js-reexport-symbols.mjs' was not found. Please, check whether './js-reexport-symbols.mjs' is loaded prior to 'skiko-kjs'.");
    }
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'skiko-kjs'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'skiko-kjs'.");
    }
    globalThis['skiko-kjs'] = factory(typeof globalThis['skiko-kjs'] === 'undefined' ? {} : globalThis['skiko-kjs'], globalThis['./skiko.mjs'], globalThis['./js-reexport-symbols.mjs'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, $module$__skiko_mjs_llxhfs, $module$__js_reexport_symbols_mjs_135kj8, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var _releaseLocalCallbackScope = $module$__skiko_mjs_llxhfs.skikoApi._releaseLocalCallbackScope;
  var awaitSkiko = $module$__js_reexport_symbols_mjs_135kj8.api.awaitSkiko;
  var enumEntries = kotlin_kotlin.$_$.ae;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var Enum = kotlin_kotlin.$_$.en;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var RuntimeException_init_$Create$ = kotlin_kotlin.$_$.j6;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var charCodeAt = kotlin_kotlin.$_$.jf;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x;
  var toShort = kotlin_kotlin.$_$.gh;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.o6;
  var compareTo = kotlin_kotlin.$_$.nf;
  var toBits = kotlin_kotlin.$_$.dp;
  var equals = kotlin_kotlin.$_$.sf;
  var hashCode = kotlin_kotlin.$_$.bg;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var isCharSequence = kotlin_kotlin.$_$.ng;
  var trim = kotlin_kotlin.$_$.mm;
  var split = kotlin_kotlin.$_$.cl;
  var getOrNull = kotlin_kotlin.$_$.t9;
  var toIntOrNull = kotlin_kotlin.$_$.xl;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.n1;
  var splitToSequence = kotlin_kotlin.$_$.al;
  var mapNotNull = kotlin_kotlin.$_$.fj;
  var toList = kotlin_kotlin.$_$.ij;
  var copyToArray = kotlin_kotlin.$_$.x8;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.o1;
  var uintCompare = kotlin_kotlin.$_$.jp;
  var UInt = kotlin_kotlin.$_$.xn;
  var isNaN_0 = kotlin_kotlin.$_$.qo;
  var numberToChar = kotlin_kotlin.$_$.ah;
  var charArrayOf = kotlin_kotlin.$_$.hf;
  var concatToString = kotlin_kotlin.$_$.lj;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var decodeToString = kotlin_kotlin.$_$.pj;
  var contentEquals = kotlin_kotlin.$_$.g8;
  var contentHashCode = kotlin_kotlin.$_$.k8;
  var contentHashCode_0 = kotlin_kotlin.$_$.j8;
  var NoSuchElementException_init_$Create$ = kotlin_kotlin.$_$.b6;
  var NotImplementedError = kotlin_kotlin.$_$.mn;
  var last = kotlin_kotlin.$_$.pa;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.v2;
  var floatFromBits = kotlin_kotlin.$_$.uf;
  var IllegalArgumentException_init_$Create$_0 = kotlin_kotlin.$_$.n5;
  var toRawBits = kotlin_kotlin.$_$.fp;
  var contentToString = kotlin_kotlin.$_$.l8;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var until = kotlin_kotlin.$_$.mi;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b8;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.z3;
  var toBits_0 = kotlin_kotlin.$_$.ep;
  var convertToInt = kotlin_kotlin.$_$.le;
  var shiftRightUnsigned = kotlin_kotlin.$_$.ye;
  var bitwiseXor = kotlin_kotlin.$_$.ie;
  var getNumberHashCode = kotlin_kotlin.$_$.xf;
  var RuntimeException = kotlin_kotlin.$_$.rn;
  var RuntimeException_init_$Init$ = kotlin_kotlin.$_$.k6;
  var captureStack = kotlin_kotlin.$_$.gf;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.a4;
  var defineProp = kotlin_kotlin.$_$.pf;
  var encodeToByteArray = kotlin_kotlin.$_$.tj;
  var copyOf = kotlin_kotlin.$_$.s8;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.u4;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var lazy = kotlin_kotlin.$_$.to;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var plus = kotlin_kotlin.$_$.vo;
  var toString_1 = kotlin_kotlin.$_$.cm;
  var numberToLong = kotlin_kotlin.$_$.we;
  var contains = kotlin_kotlin.$_$.nj;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(AnimationDisposalMode, 'AnimationDisposalMode', VOID, Enum);
  initMetadataForCompanion(Companion);
  initMetadataForClass(AnimationFrameInfo, 'AnimationFrameInfo');
  initMetadataForClass(Native, 'Native');
  initMetadataForClass(Managed, 'Managed', VOID, Native);
  initMetadataForClass(BBHFactory, 'BBHFactory', VOID, Managed);
  initMetadataForClass(RTreeFactory, 'RTreeFactory', RTreeFactory_init_$Create$, BBHFactory);
  initMetadataForObject(_FinalizerHolder, '_FinalizerHolder');
  initMetadataForCompanion(Companion_0);
  initMetadataForObject(_FinalizerHolder_0, '_FinalizerHolder');
  initMetadataForClass(BackendRenderTarget, 'BackendRenderTarget', VOID, Managed);
  initMetadataForCompanion(Companion_1);
  initMetadataForObject(_FinalizerHolder_1, '_FinalizerHolder');
  function get_width() {
    return this.y5h().m5i_1;
  }
  function get_height() {
    return this.y5h().n5i_1;
  }
  function get_colorType() {
    return this.y5h().l5i_1.o5i_1;
  }
  function get_colorSpace() {
    return this.y5h().l5i_1.q5i_1;
  }
  function get_isOpaque() {
    return this.y5h().l5i_1.x5i();
  }
  initMetadataForInterface(IHasImageInfo, 'IHasImageInfo');
  initMetadataForClass(Bitmap, 'Bitmap', Bitmap_init_$Create$, Managed, [IHasImageInfo]);
  initMetadataForClass(BlendMode, 'BlendMode', VOID, Enum);
  initMetadataForCompanion(Companion_2);
  initMetadataForObject(_FinalizerHolder_2, '_FinalizerHolder');
  initMetadataForClass(BreakIterator, 'BreakIterator', VOID, Managed);
  initMetadataForCompanion(Companion_3);
  initMetadataForObject(_FinalizerHolder_3, '_FinalizerHolder');
  initMetadataForClass(Canvas, 'Canvas', VOID, Managed);
  initMetadataForClass(ClipMode, 'ClipMode', VOID, Enum);
  initMetadataForCompanion(Companion_4);
  initMetadataForObject(_FinalizerHolder_4, '_FinalizerHolder');
  initMetadataForClass(Codec, 'Codec', VOID, Managed, [IHasImageInfo]);
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(Color4f, 'Color4f');
  initMetadataForClass(ColorAlphaType, 'ColorAlphaType', VOID, Enum);
  initMetadataForCompanion(Companion_6);
  initMetadataForClass(RefCnt, 'RefCnt', VOID, Managed);
  initMetadataForClass(ColorFilter, 'ColorFilter', VOID, RefCnt);
  initMetadataForCompanion(Companion_7);
  initMetadataForClass(ColorInfo, 'ColorInfo');
  initMetadataForCompanion(Companion_8);
  initMetadataForObject(_FinalizerHolder_5, '_FinalizerHolder');
  initMetadataForClass(ColorSpace, 'ColorSpace', VOID, Managed);
  initMetadataForCompanion(Companion_9);
  initMetadataForClass(ColorType, 'ColorType', VOID, Enum);
  initMetadataForClass(CubicResampler, 'CubicResampler');
  initMetadataForCompanion(Companion_10);
  initMetadataForObject(_FinalizerHolder_6, '_FinalizerHolder');
  initMetadataForClass(Data, 'Data', VOID, Managed);
  initMetadataForCompanion(Companion_11);
  initMetadataForClass(DirectContext, 'DirectContext', VOID, RefCnt);
  initMetadataForClass(EncodedImageFormat, 'EncodedImageFormat', VOID, Enum);
  initMetadataForClass(FilterMipmap, 'FilterMipmap');
  initMetadataForClass(FilterMode, 'FilterMode', VOID, Enum);
  initMetadataForClass(FilterTileMode, 'FilterTileMode', VOID, Enum);
  initMetadataForCompanion(Companion_12);
  initMetadataForObject(_FinalizerHolder_7, '_FinalizerHolder');
  initMetadataForClass(Font, 'Font', Font_init_$Create$, Managed);
  initMetadataForClass(FontEdging, 'FontEdging', VOID, Enum);
  initMetadataForCompanion(Companion_13);
  initMetadataForClass(FontFeature, 'FontFeature');
  initMetadataForClass(FontHinting, 'FontHinting', VOID, Enum);
  initMetadataForCompanion(Companion_14);
  initMetadataForClass(FontMetrics, 'FontMetrics');
  initMetadataForCompanion(Companion_15);
  initMetadataForClass(FontMgr, 'FontMgr', VOID, RefCnt);
  initMetadataForClass(FontMgrWithFallback, 'FontMgrWithFallback', VOID, FontMgr);
  initMetadataForClass(FontSlant, 'FontSlant', VOID, Enum);
  initMetadataForCompanion(Companion_16);
  initMetadataForClass(FontStyle, 'FontStyle');
  initMetadataForCompanion(Companion_17);
  initMetadataForClass(FontVariation, 'FontVariation');
  initMetadataForCompanion(Companion_18);
  initMetadataForCompanion(Companion_19);
  initMetadataForClass(GradientStyle, 'GradientStyle');
  initMetadataForCompanion(Companion_20);
  initMetadataForClass(IRange, 'IRange');
  initMetadataForCompanion(Companion_21);
  initMetadataForClass(IRect, 'IRect');
  initMetadataForCompanion(Companion_22);
  initMetadataForClass(Image, 'Image', VOID, RefCnt, [IHasImageInfo]);
  initMetadataForCompanion(Companion_23);
  initMetadataForClass(ImageInfo, 'ImageInfo');
  initMetadataForCompanion(Companion_24);
  initMetadataForObject(_FinalizerHolder_8, '_FinalizerHolder');
  initMetadataForClass(ManagedString, 'ManagedString', VOID, Managed);
  initMetadataForCompanion(Companion_25);
  initMetadataForClass(Matrix33, 'Matrix33');
  initMetadataForCompanion(Companion_26);
  initMetadataForClass(Matrix44, 'Matrix44');
  initMetadataForClass(MipmapMode, 'MipmapMode', VOID, Enum);
  initMetadataForCompanion(Companion_27);
  initMetadataForObject(_FinalizerHolder_9, '_FinalizerHolder');
  initMetadataForClass(Paint, 'Paint', Paint_init_$Create$, Managed);
  initMetadataForClass(PaintMode, 'PaintMode', VOID, Enum);
  initMetadataForClass(PaintStrokeCap, 'PaintStrokeCap', VOID, Enum);
  initMetadataForClass(PaintStrokeJoin, 'PaintStrokeJoin', VOID, Enum);
  initMetadataForCompanion(Companion_28);
  initMetadataForObject(_FinalizerHolder_10, '_FinalizerHolder');
  initMetadataForClass(Path, 'Path', Path_init_$Create$, Managed);
  initMetadataForClass(PathAddMode, 'PathAddMode', VOID, Enum);
  initMetadataForCompanion(Companion_29);
  initMetadataForObject(_FinalizerHolder_11, '_FinalizerHolder');
  initMetadataForClass(PathBuilder, 'PathBuilder', PathBuilder_init_$Create$, Managed);
  initMetadataForClass(PathDirection, 'PathDirection', VOID, Enum);
  initMetadataForClass(PathFillMode, 'PathFillMode', VOID, Enum);
  initMetadataForCompanion(Companion_30);
  initMetadataForObject(_FinalizerHolder_12, '_FinalizerHolder');
  initMetadataForClass(PathMeasure, 'PathMeasure', PathMeasure_init_$Create$, Managed);
  initMetadataForClass(PathOp, 'PathOp', VOID, Enum);
  initMetadataForClass(PathSegment, 'PathSegment', PathSegment);
  initMetadataForCompanion(Companion_31);
  initMetadataForClass(PathSegmentIterator, 'PathSegmentIterator', VOID, Managed);
  initMetadataForClass(PathVerb, 'PathVerb', VOID, Enum);
  initMetadataForCompanion(Companion_32);
  initMetadataForClass(Picture, 'Picture', VOID, RefCnt);
  initMetadataForCompanion(Companion_33);
  initMetadataForObject(_FinalizerHolder_13, '_FinalizerHolder');
  initMetadataForClass(PictureRecorder, 'PictureRecorder', PictureRecorder_init_$Create$, Managed);
  initMetadataForClass(PixelGeometry, 'PixelGeometry', VOID, Enum);
  initMetadataForCompanion(Companion_34);
  initMetadataForClass(Point, 'Point');
  initMetadataForClass(Point3, 'Point3');
  initMetadataForCompanion(Companion_35);
  initMetadataForClass(Rect, 'Rect');
  initMetadataForCompanion(Companion_36);
  initMetadataForCompanion(Companion_37);
  initMetadataForClass(Shader, 'Shader', VOID, RefCnt);
  initMetadataForObject(ShadowUtils, 'ShadowUtils');
  initMetadataForClass(ArrayDecoder, 'ArrayDecoder');
  initMetadataForCompanion(Companion_38);
  initMetadataForClass(Surface, 'Surface', VOID, RefCnt);
  initMetadataForClass(SurfaceColorFormat, 'SurfaceColorFormat', VOID, Enum);
  initMetadataForClass(SurfaceOrigin, 'SurfaceOrigin', VOID, Enum);
  initMetadataForClass(SurfaceProps, 'SurfaceProps', SurfaceProps);
  initMetadataForCompanion(Companion_39);
  initMetadataForClass(Typeface, 'Typeface', VOID, RefCnt);
  initMetadataForCompanion(Companion_40);
  initMetadataForObject(_FinalizerHolder_14, '_FinalizerHolder');
  initMetadataForClass(U16String, 'U16String', VOID, Managed);
  initMetadataForObject(CharProperties, 'CharProperties');
  initMetadataForObject(CharDirection, 'CharDirection');
  initMetadataForClass(Affinity, 'Affinity', VOID, Enum);
  initMetadataForClass(Alignment, 'Alignment', VOID, Enum);
  initMetadataForClass(BaselineMode, 'BaselineMode', VOID, Enum);
  initMetadataForClass(DecorationLineStyle, 'DecorationLineStyle', VOID, Enum);
  initMetadataForCompanion(Companion_41);
  initMetadataForClass(DecorationStyle, 'DecorationStyle');
  initMetadataForClass(Direction, 'Direction', VOID, Enum);
  initMetadataForCompanion(Companion_42);
  initMetadataForClass(FontCollection, 'FontCollection', FontCollection_init_$Create$, RefCnt);
  initMetadataForClass(HeightMode, 'HeightMode', VOID, Enum);
  initMetadataForCompanion(Companion_43);
  initMetadataForClass(LineMetrics, 'LineMetrics');
  initMetadataForCompanion(Companion_44);
  initMetadataForObject(_FinalizerHolder_15, '_FinalizerHolder');
  initMetadataForClass(Paragraph, 'Paragraph', VOID, Managed);
  initMetadataForCompanion(Companion_45);
  initMetadataForObject(_FinalizerHolder_16, '_FinalizerHolder');
  initMetadataForClass(ParagraphBuilder, 'ParagraphBuilder', VOID, Managed);
  initMetadataForCompanion(Companion_46);
  initMetadataForObject(_FinalizerHolder_17, '_FinalizerHolder');
  initMetadataForClass(ParagraphStyle, 'ParagraphStyle', ParagraphStyle, Managed);
  initMetadataForClass(PlaceholderAlignment, 'PlaceholderAlignment', VOID, Enum);
  initMetadataForClass(PlaceholderStyle, 'PlaceholderStyle');
  initMetadataForClass(PositionWithAffinity, 'PositionWithAffinity');
  initMetadataForClass(RectHeightMode, 'RectHeightMode', VOID, Enum);
  initMetadataForClass(RectWidthMode, 'RectWidthMode', VOID, Enum);
  initMetadataForCompanion(Companion_47);
  initMetadataForClass(Shadow, 'Shadow');
  initMetadataForCompanion(Companion_48);
  initMetadataForClass(TextBox, 'TextBox');
  initMetadataForClass(TextIndent, 'TextIndent', TextIndent);
  initMetadataForCompanion(Companion_49);
  initMetadataForObject(_FinalizerHolder_18, '_FinalizerHolder');
  initMetadataForClass(TextStyle, 'TextStyle', TextStyle_init_$Create$, Managed);
  initMetadataForCompanion(Companion_50);
  initMetadataForClass(TypefaceFontProvider, 'TypefaceFontProvider', TypefaceFontProvider_init_$Create$, FontMgr);
  initMetadataForCompanion(Companion_51);
  initMetadataForClass(TypefaceFontProviderWithFallback, 'TypefaceFontProviderWithFallback', TypefaceFontProviderWithFallback_init_$Create$, TypefaceFontProvider);
  initMetadataForCompanion(Companion_52);
  initMetadataForClass(SVGNode, 'SVGNode', VOID, RefCnt);
  initMetadataForClass(SVGTransformableNode, 'SVGTransformableNode', VOID, SVGNode);
  initMetadataForClass(SVGContainer, 'SVGContainer', VOID, SVGTransformableNode);
  initMetadataForCompanion(Companion_53);
  initMetadataForClass(SVGDOM, 'SVGDOM', VOID, RefCnt);
  initMetadataForCompanion(Companion_54);
  initMetadataForClass(SVGLength, 'SVGLength');
  initMetadataForClass(SVGLengthUnit, 'SVGLengthUnit', VOID, Enum);
  initMetadataForCompanion(Companion_55);
  initMetadataForCompanion(Companion_56);
  initMetadataForClass(SVGPreserveAspectRatio, 'SVGPreserveAspectRatio', SVGPreserveAspectRatio_init_$Create$);
  initMetadataForCompanion(Companion_57);
  initMetadataForClass(SVGPreserveAspectRatioAlign, 'SVGPreserveAspectRatioAlign', VOID, Enum);
  initMetadataForClass(SVGPreserveAspectRatioScale, 'SVGPreserveAspectRatioScale', VOID, Enum);
  initMetadataForCompanion(Companion_58);
  initMetadataForClass(SVGSVG, 'SVGSVG', VOID, SVGContainer);
  initMetadataForCompanion(Companion_59);
  initMetadataForClass(GraphicsApi, 'GraphicsApi', VOID, Enum);
  initMetadataForClass(OS, 'OS', VOID, Enum);
  initMetadataForClass(Arch, 'Arch', VOID, Enum);
  initMetadataForClass(RenderException, 'RenderException', RenderException, RuntimeException);
  initMetadataForInterface(SkikoRenderDelegate, 'SkikoRenderDelegate');
  initMetadataForClass(SystemTheme, 'SystemTheme', VOID, Enum);
  initMetadataForCompanion(Companion_60);
  initMetadataForClass(RenderNode, 'RenderNode', VOID, RefCnt);
  initMetadataForCompanion(Companion_61);
  initMetadataForClass(RenderNodeContext, 'RenderNodeContext', RenderNodeContext_init_$Create$, RefCnt);
  initMetadataForClass(InteropScope, 'InteropScope', InteropScope);
  initMetadataForClass(createWebGLContext$contextAttributes$1);
  initMetadataForClass(Pattern, 'Pattern');
  initMetadataForCompanion(Companion_62);
  initMetadataForClass(FinalizationThunk, 'FinalizationThunk');
  initMetadataForCompanion(Companion_63);
  initMetadataForCompanion(Companion_64);
  initMetadataForClass(NativePointerArray, 'NativePointerArray');
  initMetadataForObject(_FinalizerHolder_19, '_FinalizerHolder');
  initMetadataForObject(Stats, 'Stats');
  initMetadataForClass(CanvasRenderer, 'CanvasRenderer');
  initMetadataForClass(SkiaLayer$attachTo$1, VOID, VOID, CanvasRenderer);
  initMetadataForClass(SkiaLayer, 'SkiaLayer', SkiaLayer);
  //endregion
  var AnimationDisposalMode_UNUSED_instance;
  var AnimationDisposalMode_KEEP_instance;
  var AnimationDisposalMode_RESTORE_BG_COLOR_instance;
  var AnimationDisposalMode_RESTORE_PREVIOUS_instance;
  function values() {
    return [AnimationDisposalMode_UNUSED_getInstance(), AnimationDisposalMode_KEEP_getInstance(), AnimationDisposalMode_RESTORE_BG_COLOR_getInstance(), AnimationDisposalMode_RESTORE_PREVIOUS_getInstance()];
  }
  function get_entries() {
    if ($ENTRIES == null)
      $ENTRIES = enumEntries(values());
    return $ENTRIES;
  }
  var AnimationDisposalMode_entriesInitialized;
  function AnimationDisposalMode_initEntries() {
    if (AnimationDisposalMode_entriesInitialized)
      return Unit_instance;
    AnimationDisposalMode_entriesInitialized = true;
    AnimationDisposalMode_UNUSED_instance = new AnimationDisposalMode('UNUSED', 0);
    AnimationDisposalMode_KEEP_instance = new AnimationDisposalMode('KEEP', 1);
    AnimationDisposalMode_RESTORE_BG_COLOR_instance = new AnimationDisposalMode('RESTORE_BG_COLOR', 2);
    AnimationDisposalMode_RESTORE_PREVIOUS_instance = new AnimationDisposalMode('RESTORE_PREVIOUS', 3);
  }
  var $ENTRIES;
  function AnimationDisposalMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function AnimationDisposalMode_UNUSED_getInstance() {
    AnimationDisposalMode_initEntries();
    return AnimationDisposalMode_UNUSED_instance;
  }
  function AnimationDisposalMode_KEEP_getInstance() {
    AnimationDisposalMode_initEntries();
    return AnimationDisposalMode_KEEP_instance;
  }
  function AnimationDisposalMode_RESTORE_BG_COLOR_getInstance() {
    AnimationDisposalMode_initEntries();
    return AnimationDisposalMode_RESTORE_BG_COLOR_instance;
  }
  function AnimationDisposalMode_RESTORE_PREVIOUS_getInstance() {
    AnimationDisposalMode_initEntries();
    return AnimationDisposalMode_RESTORE_PREVIOUS_instance;
  }
  function fromIntArray($this, repr, index) {
    index = index === VOID ? 0 : index;
    var offset = imul(index, 11);
    return AnimationFrameInfo_init_$Create$(repr[offset + 0 | 0], repr[offset + 1 | 0], !(repr[offset + 2 | 0] === 0), repr[offset + 3 | 0], !(repr[offset + 4 | 0] === 0), repr[offset + 5 | 0], repr[offset + 6 | 0], new IRect(repr[offset + 7 | 0], repr[offset + 8 | 0], repr[offset + 9 | 0], repr[offset + 10 | 0]));
  }
  function Companion() {
    this.w5g_1 = 11;
  }
  protoOf(Companion).x5g = function (size, block) {
    // Inline function 'org.jetbrains.skia.impl.withResult' call
    var result = new Int32Array(imul(11, size));
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        var handle = $this$interopScope.a5h(result);
        block($this$interopScope, handle);
        $this$interopScope.b5h(handle, result);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    var repr = result;
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = Array(size);
    while (tmp < size) {
      var tmp_1 = tmp;
      tmp_0[tmp_1] = fromIntArray(Companion_instance, repr, tmp_1);
      tmp = tmp + 1 | 0;
    }
    return tmp_0;
  };
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function AnimationFrameInfo_init_$Init$(requiredFrame, duration, fullyReceived, alphaTypeOrdinal, hasAlphaWithinBounds, disposalMethodOrdinal, blendModeOrdinal, frameRect, $this) {
    AnimationFrameInfo.call($this, requiredFrame, duration, fullyReceived, get_entries_1().l1(alphaTypeOrdinal), hasAlphaWithinBounds, get_entries().l1(disposalMethodOrdinal), get_entries_0().l1(blendModeOrdinal), frameRect);
    return $this;
  }
  function AnimationFrameInfo_init_$Create$(requiredFrame, duration, fullyReceived, alphaTypeOrdinal, hasAlphaWithinBounds, disposalMethodOrdinal, blendModeOrdinal, frameRect) {
    return AnimationFrameInfo_init_$Init$(requiredFrame, duration, fullyReceived, alphaTypeOrdinal, hasAlphaWithinBounds, disposalMethodOrdinal, blendModeOrdinal, frameRect, objectCreate(protoOf(AnimationFrameInfo)));
  }
  function AnimationFrameInfo(requiredFrame, duration, isFullyReceived, alphaType, isHasAlphaWithinBounds, disposalMethod, blendMode, frameRect) {
    this.c5h_1 = requiredFrame;
    this.d5h_1 = duration;
    this.e5h_1 = isFullyReceived;
    this.f5h_1 = alphaType;
    this.g5h_1 = isHasAlphaWithinBounds;
    this.h5h_1 = disposalMethod;
    this.i5h_1 = blendMode;
    this.j5h_1 = frameRect;
  }
  protoOf(AnimationFrameInfo).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof AnimationFrameInfo))
      return false;
    if (!(this.c5h_1 === other.c5h_1))
      return false;
    if (!(this.d5h_1 === other.d5h_1))
      return false;
    if (!(this.e5h_1 === other.e5h_1))
      return false;
    if (!(this.g5h_1 === other.g5h_1))
      return false;
    if (!this.f5h_1.equals(other.f5h_1))
      return false;
    if (!this.h5h_1.equals(other.h5h_1))
      return false;
    if (!this.i5h_1.equals(other.i5h_1))
      return false;
    return this.j5h_1.equals(other.j5h_1);
  };
  protoOf(AnimationFrameInfo).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + this.c5h_1 | 0;
    result = imul(result, PRIME) + this.d5h_1 | 0;
    result = imul(result, PRIME) + (this.e5h_1 ? 79 : 97) | 0;
    result = imul(result, PRIME) + (this.g5h_1 ? 79 : 97) | 0;
    result = imul(result, PRIME) + this.f5h_1.hashCode() | 0;
    result = imul(result, PRIME) + this.h5h_1.hashCode() | 0;
    result = imul(result, PRIME) + this.i5h_1.hashCode() | 0;
    result = imul(result, PRIME) + this.j5h_1.hashCode() | 0;
    return result;
  };
  protoOf(AnimationFrameInfo).toString = function () {
    return 'AnimationFrameInfo(_requiredFrame=' + this.c5h_1 + ', _duration=' + this.d5h_1 + ', _fullyReceived=' + this.e5h_1 + ', _alphaType=' + this.f5h_1.toString() + ', _hasAlphaWithinBounds=' + this.g5h_1 + ', _disposalMethod=' + this.h5h_1.toString() + ', _blendMode=' + this.i5h_1.toString() + ', _frameRect=' + this.j5h_1.toString() + ')';
  };
  function RTreeFactory_init_$Init$($this) {
    BBHFactory.call($this, org_jetbrains_skia_RTreeFactory__1nMake());
    RTreeFactory.call($this);
    Stats_instance.k5h();
    return $this;
  }
  function RTreeFactory_init_$Create$() {
    return RTreeFactory_init_$Init$(objectCreate(protoOf(RTreeFactory)));
  }
  function RTreeFactory() {
  }
  function _FinalizerHolder() {
    _FinalizerHolder_instance = this;
    this.p5h_1 = org_jetbrains_skia_BBHFactory__1nGetFinalizer();
  }
  var _FinalizerHolder_instance;
  function _FinalizerHolder_getInstance() {
    if (_FinalizerHolder_instance == null)
      new _FinalizerHolder();
    return _FinalizerHolder_instance;
  }
  function BBHFactory(ptr) {
    Managed.call(this, ptr, _FinalizerHolder_getInstance().p5h_1);
  }
  function Companion_0() {
    Companion_instance_0 = this;
    Companion_instance_62.q5h();
  }
  protoOf(Companion_0).r5h = function (width, height, sampleCnt, stencilBits, fbId, fbFormat) {
    Stats_instance.k5h();
    var ptr = org_jetbrains_skia_BackendRenderTarget__1nMakeGL(width, height, sampleCnt, stencilBits, fbId, fbFormat);
    if (ptr === Companion_instance_63.s5h())
      throw new RenderException("Can't create OpenGL BackendRenderTarget");
    return new BackendRenderTarget(ptr);
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function _FinalizerHolder_0() {
    _FinalizerHolder_instance_0 = this;
    this.t5h_1 = org_jetbrains_skia_BackendRenderTarget__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_0;
  function _FinalizerHolder_getInstance_0() {
    if (_FinalizerHolder_instance_0 == null)
      new _FinalizerHolder_0();
    return _FinalizerHolder_instance_0;
  }
  function BackendRenderTarget(ptr) {
    Companion_getInstance_0();
    Managed.call(this, ptr, _FinalizerHolder_getInstance_0().t5h_1);
  }
  function Companion_1() {
    Companion_instance_1 = this;
    Companion_instance_62.q5h();
  }
  protoOf(Companion_1).u5h = function (image) {
    var bitmap = Bitmap_init_$Create$();
    bitmap.c5i(image.y5h());
    var tmp;
    if (image.d5i(bitmap)) {
      tmp = bitmap;
    } else {
      bitmap.j4();
      throw RuntimeException_init_$Create$('Failed to readPixels from ' + image.toString());
    }
    return tmp;
  };
  var Companion_instance_1;
  function Companion_getInstance_1() {
    if (Companion_instance_1 == null)
      new Companion_1();
    return Companion_instance_1;
  }
  function Bitmap_init_$Init$($this) {
    Bitmap.call($this, org_jetbrains_skia_Bitmap__1nMake());
    Stats_instance.k5h();
    return $this;
  }
  function Bitmap_init_$Create$() {
    return Bitmap_init_$Init$(objectCreate(protoOf(Bitmap)));
  }
  function _FinalizerHolder_1() {
    _FinalizerHolder_instance_1 = this;
    this.e5i_1 = org_jetbrains_skia_Bitmap__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_1;
  function _FinalizerHolder_getInstance_1() {
    if (_FinalizerHolder_instance_1 == null)
      new _FinalizerHolder_1();
    return _FinalizerHolder_instance_1;
  }
  function _nGetImageInfo$ref() {
    return constructCallableReference(function (p0, p1, p2) {
      org_jetbrains_skia_Bitmap__1nGetImageInfo(p0, p1, p2);
      return Unit_instance;
    }, 3, 0, 19, '_nGetImageInfo');
  }
  function Bitmap(ptr) {
    Companion_getInstance_1();
    Managed.call(this, ptr, _FinalizerHolder_getInstance_1().e5i_1);
    this.b5i_1 = null;
  }
  protoOf(Bitmap).y5h = function () {
    var tmp;
    try {
      if (this.b5i_1 == null) {
        var tmp_0 = this;
        var tmp_1 = Companion_getInstance_23();
        var tmp_2 = this.n5h_1;
        tmp_0.b5i_1 = tmp_1.g5i(tmp_2, _nGetImageInfo$ref());
      }
      tmp = ensureNotNull(this.b5i_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Bitmap).h5i = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_Bitmap__1nComputeByteSize(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Bitmap).i5i = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_Bitmap__1nIsImmutable(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Bitmap).j5i = function () {
    Stats_instance.k5h();
    org_jetbrains_skia_Bitmap__1nSetImmutable(this.n5h_1);
    return this;
  };
  protoOf(Bitmap).k5i = function (info, rowBytes) {
    var tmp;
    try {
      this.b5i_1 = null;
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_Bitmap__1nAllocPixelsRowBytes(this.n5h_1, info.m5i_1, info.n5i_1, info.l5i_1.o5i_1.a1_1, info.l5i_1.p5i_1.a1_1, getPtr(info.l5i_1.q5i_1), rowBytes);
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(info.l5i_1.q5i_1);
    }
    return tmp;
  };
  protoOf(Bitmap).c5i = function (imageInfo) {
    return this.k5i(imageInfo, imageInfo.r5i());
  };
  protoOf(Bitmap).s5i = function (width, height, opaque) {
    return this.c5i(Companion_getInstance_23().t5i(width, height, opaque ? ColorAlphaType_OPAQUE_getInstance() : ColorAlphaType_PREMUL_getInstance()));
  };
  protoOf(Bitmap).u5i = function (width, height, opaque, $super) {
    opaque = opaque === VOID ? false : opaque;
    return $super === VOID ? this.s5i(width, height, opaque) : $super.s5i.call(this, width, height, opaque);
  };
  var BlendMode_CLEAR_instance;
  var BlendMode_SRC_instance;
  var BlendMode_DST_instance;
  var BlendMode_SRC_OVER_instance;
  var BlendMode_DST_OVER_instance;
  var BlendMode_SRC_IN_instance;
  var BlendMode_DST_IN_instance;
  var BlendMode_SRC_OUT_instance;
  var BlendMode_DST_OUT_instance;
  var BlendMode_SRC_ATOP_instance;
  var BlendMode_DST_ATOP_instance;
  var BlendMode_XOR_instance;
  var BlendMode_PLUS_instance;
  var BlendMode_MODULATE_instance;
  var BlendMode_SCREEN_instance;
  var BlendMode_OVERLAY_instance;
  var BlendMode_DARKEN_instance;
  var BlendMode_LIGHTEN_instance;
  var BlendMode_COLOR_DODGE_instance;
  var BlendMode_COLOR_BURN_instance;
  var BlendMode_HARD_LIGHT_instance;
  var BlendMode_SOFT_LIGHT_instance;
  var BlendMode_DIFFERENCE_instance;
  var BlendMode_EXCLUSION_instance;
  var BlendMode_MULTIPLY_instance;
  var BlendMode_HUE_instance;
  var BlendMode_SATURATION_instance;
  var BlendMode_COLOR_instance;
  var BlendMode_LUMINOSITY_instance;
  function values_0() {
    return [BlendMode_CLEAR_getInstance(), BlendMode_SRC_getInstance(), BlendMode_DST_getInstance(), BlendMode_SRC_OVER_getInstance(), BlendMode_DST_OVER_getInstance(), BlendMode_SRC_IN_getInstance(), BlendMode_DST_IN_getInstance(), BlendMode_SRC_OUT_getInstance(), BlendMode_DST_OUT_getInstance(), BlendMode_SRC_ATOP_getInstance(), BlendMode_DST_ATOP_getInstance(), BlendMode_XOR_getInstance(), BlendMode_PLUS_getInstance(), BlendMode_MODULATE_getInstance(), BlendMode_SCREEN_getInstance(), BlendMode_OVERLAY_getInstance(), BlendMode_DARKEN_getInstance(), BlendMode_LIGHTEN_getInstance(), BlendMode_COLOR_DODGE_getInstance(), BlendMode_COLOR_BURN_getInstance(), BlendMode_HARD_LIGHT_getInstance(), BlendMode_SOFT_LIGHT_getInstance(), BlendMode_DIFFERENCE_getInstance(), BlendMode_EXCLUSION_getInstance(), BlendMode_MULTIPLY_getInstance(), BlendMode_HUE_getInstance(), BlendMode_SATURATION_getInstance(), BlendMode_COLOR_getInstance(), BlendMode_LUMINOSITY_getInstance()];
  }
  function get_entries_0() {
    if ($ENTRIES_0 == null)
      $ENTRIES_0 = enumEntries(values_0());
    return $ENTRIES_0;
  }
  var BlendMode_entriesInitialized;
  function BlendMode_initEntries() {
    if (BlendMode_entriesInitialized)
      return Unit_instance;
    BlendMode_entriesInitialized = true;
    BlendMode_CLEAR_instance = new BlendMode('CLEAR', 0);
    BlendMode_SRC_instance = new BlendMode('SRC', 1);
    BlendMode_DST_instance = new BlendMode('DST', 2);
    BlendMode_SRC_OVER_instance = new BlendMode('SRC_OVER', 3);
    BlendMode_DST_OVER_instance = new BlendMode('DST_OVER', 4);
    BlendMode_SRC_IN_instance = new BlendMode('SRC_IN', 5);
    BlendMode_DST_IN_instance = new BlendMode('DST_IN', 6);
    BlendMode_SRC_OUT_instance = new BlendMode('SRC_OUT', 7);
    BlendMode_DST_OUT_instance = new BlendMode('DST_OUT', 8);
    BlendMode_SRC_ATOP_instance = new BlendMode('SRC_ATOP', 9);
    BlendMode_DST_ATOP_instance = new BlendMode('DST_ATOP', 10);
    BlendMode_XOR_instance = new BlendMode('XOR', 11);
    BlendMode_PLUS_instance = new BlendMode('PLUS', 12);
    BlendMode_MODULATE_instance = new BlendMode('MODULATE', 13);
    BlendMode_SCREEN_instance = new BlendMode('SCREEN', 14);
    BlendMode_OVERLAY_instance = new BlendMode('OVERLAY', 15);
    BlendMode_DARKEN_instance = new BlendMode('DARKEN', 16);
    BlendMode_LIGHTEN_instance = new BlendMode('LIGHTEN', 17);
    BlendMode_COLOR_DODGE_instance = new BlendMode('COLOR_DODGE', 18);
    BlendMode_COLOR_BURN_instance = new BlendMode('COLOR_BURN', 19);
    BlendMode_HARD_LIGHT_instance = new BlendMode('HARD_LIGHT', 20);
    BlendMode_SOFT_LIGHT_instance = new BlendMode('SOFT_LIGHT', 21);
    BlendMode_DIFFERENCE_instance = new BlendMode('DIFFERENCE', 22);
    BlendMode_EXCLUSION_instance = new BlendMode('EXCLUSION', 23);
    BlendMode_MULTIPLY_instance = new BlendMode('MULTIPLY', 24);
    BlendMode_HUE_instance = new BlendMode('HUE', 25);
    BlendMode_SATURATION_instance = new BlendMode('SATURATION', 26);
    BlendMode_COLOR_instance = new BlendMode('COLOR', 27);
    BlendMode_LUMINOSITY_instance = new BlendMode('LUMINOSITY', 28);
  }
  var $ENTRIES_0;
  function BlendMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function BlendMode_CLEAR_getInstance() {
    BlendMode_initEntries();
    return BlendMode_CLEAR_instance;
  }
  function BlendMode_SRC_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SRC_instance;
  }
  function BlendMode_DST_getInstance() {
    BlendMode_initEntries();
    return BlendMode_DST_instance;
  }
  function BlendMode_SRC_OVER_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SRC_OVER_instance;
  }
  function BlendMode_DST_OVER_getInstance() {
    BlendMode_initEntries();
    return BlendMode_DST_OVER_instance;
  }
  function BlendMode_SRC_IN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SRC_IN_instance;
  }
  function BlendMode_DST_IN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_DST_IN_instance;
  }
  function BlendMode_SRC_OUT_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SRC_OUT_instance;
  }
  function BlendMode_DST_OUT_getInstance() {
    BlendMode_initEntries();
    return BlendMode_DST_OUT_instance;
  }
  function BlendMode_SRC_ATOP_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SRC_ATOP_instance;
  }
  function BlendMode_DST_ATOP_getInstance() {
    BlendMode_initEntries();
    return BlendMode_DST_ATOP_instance;
  }
  function BlendMode_XOR_getInstance() {
    BlendMode_initEntries();
    return BlendMode_XOR_instance;
  }
  function BlendMode_PLUS_getInstance() {
    BlendMode_initEntries();
    return BlendMode_PLUS_instance;
  }
  function BlendMode_MODULATE_getInstance() {
    BlendMode_initEntries();
    return BlendMode_MODULATE_instance;
  }
  function BlendMode_SCREEN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SCREEN_instance;
  }
  function BlendMode_OVERLAY_getInstance() {
    BlendMode_initEntries();
    return BlendMode_OVERLAY_instance;
  }
  function BlendMode_DARKEN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_DARKEN_instance;
  }
  function BlendMode_LIGHTEN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_LIGHTEN_instance;
  }
  function BlendMode_COLOR_DODGE_getInstance() {
    BlendMode_initEntries();
    return BlendMode_COLOR_DODGE_instance;
  }
  function BlendMode_COLOR_BURN_getInstance() {
    BlendMode_initEntries();
    return BlendMode_COLOR_BURN_instance;
  }
  function BlendMode_HARD_LIGHT_getInstance() {
    BlendMode_initEntries();
    return BlendMode_HARD_LIGHT_instance;
  }
  function BlendMode_SOFT_LIGHT_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SOFT_LIGHT_instance;
  }
  function BlendMode_DIFFERENCE_getInstance() {
    BlendMode_initEntries();
    return BlendMode_DIFFERENCE_instance;
  }
  function BlendMode_EXCLUSION_getInstance() {
    BlendMode_initEntries();
    return BlendMode_EXCLUSION_instance;
  }
  function BlendMode_MULTIPLY_getInstance() {
    BlendMode_initEntries();
    return BlendMode_MULTIPLY_instance;
  }
  function BlendMode_HUE_getInstance() {
    BlendMode_initEntries();
    return BlendMode_HUE_instance;
  }
  function BlendMode_SATURATION_getInstance() {
    BlendMode_initEntries();
    return BlendMode_SATURATION_instance;
  }
  function BlendMode_COLOR_getInstance() {
    BlendMode_initEntries();
    return BlendMode_COLOR_instance;
  }
  function BlendMode_LUMINOSITY_getInstance() {
    BlendMode_initEntries();
    return BlendMode_LUMINOSITY_instance;
  }
  function BreakIterator$Companion$makeCharacterInstance$lambda($locale) {
    return function ($this$withErrorGuard, it) {
      return org_jetbrains_skia_BreakIterator__1nMake(0, $this$withErrorGuard.y5i($locale), it);
    };
  }
  function Companion_2() {
    Companion_instance_2 = this;
    this.z5i_1 = -1;
    this.a5j_1 = 0;
    this.b5j_1 = 100;
    this.c5j_1 = 100;
    this.d5j_1 = 200;
    this.e5j_1 = 200;
    this.f5j_1 = 300;
    this.g5j_1 = 300;
    this.h5j_1 = 400;
    this.i5j_1 = 400;
    this.j5j_1 = 500;
    Companion_instance_62.q5h();
  }
  protoOf(Companion_2).k5j = function (locale) {
    Stats_instance.k5h();
    return new BreakIterator(withErrorGuard('Failed to create character iterator', BreakIterator$Companion$makeCharacterInstance$lambda(locale)));
  };
  protoOf(Companion_2).l5j = function (locale, $super) {
    locale = locale === VOID ? null : locale;
    return $super === VOID ? this.k5j(locale) : $super.k5j.call(this, locale);
  };
  var Companion_instance_2;
  function Companion_getInstance_2() {
    if (Companion_instance_2 == null)
      new Companion_2();
    return Companion_instance_2;
  }
  function _FinalizerHolder_2() {
    _FinalizerHolder_instance_2 = this;
    this.m5j_1 = org_jetbrains_skia_BreakIterator__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_2;
  function _FinalizerHolder_getInstance_2() {
    if (_FinalizerHolder_instance_2 == null)
      new _FinalizerHolder_2();
    return _FinalizerHolder_instance_2;
  }
  function BreakIterator$setText$lambda(this$0, $text) {
    return function ($this$withErrorGuard, it) {
      var tmp = this$0.n5h_1;
      var tmp_0;
      if ($text == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_1 = 0;
        var tmp_2 = $text.length;
        var tmp_3 = new Int16Array(tmp_2);
        while (tmp_1 < tmp_2) {
          var tmp_4 = tmp_1;
          // Inline function 'kotlin.code' call
          var this_0 = charCodeAt($text, tmp_4);
          var tmp$ret$3 = Char__toInt_impl_vasixd(this_0);
          tmp_3[tmp_4] = toShort(tmp$ret$3);
          tmp_1 = tmp_1 + 1 | 0;
        }
        tmp_0 = tmp_3;
      }
      var tmp_5 = $this$withErrorGuard.n5j(tmp_0);
      var tmp1_safe_receiver = $text;
      var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      return org_jetbrains_skia_BreakIterator__1nSetText(tmp, tmp_5, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs, it);
    };
  }
  function BreakIterator(ptr) {
    Companion_getInstance_2();
    Managed.call(this, ptr, _FinalizerHolder_getInstance_2().m5j_1);
    this.q5j_1 = null;
  }
  protoOf(BreakIterator).j4 = function () {
    protoOf(Managed).j4.call(this);
    var tmp0_safe_receiver = this.q5j_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.j4();
    }
  };
  protoOf(BreakIterator).r5j = function (offset) {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_BreakIterator__1nPreceding(this.n5h_1, offset);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(BreakIterator).s5j = function (offset) {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_BreakIterator__1nFollowing(this.n5h_1, offset);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(BreakIterator).t5j = function (text) {
    try {
      Stats_instance.k5h();
      var tmp0_safe_receiver = this.q5j_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.j4();
      }
      var tmp = this;
      tmp.q5j_1 = new U16String(withErrorGuard('Failed to setText', BreakIterator$setText$lambda(this, text)));
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(this.q5j_1);
    }
  };
  function withErrorGuard(message, block) {
    var errorCode = new Int32Array(1);
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        var handle = $this$interopScope.u5j(errorCode);
        var res = block($this$interopScope, handle);
        $this$interopScope.b5h(handle, errorCode);
        if (errorCode[0] > 0) {
          throw RuntimeException_init_$Create$(message + '; operation failed with status ' + toString(errorCode));
        }
        if (res === Companion_instance_63.s5h()) {
          throw IllegalArgumentException_init_$Create$(message);
        }
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return res;
  }
  function Companion_3() {
    Companion_instance_3 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_3;
  function Companion_getInstance_3() {
    if (Companion_instance_3 == null)
      new Companion_3();
    return Companion_instance_3;
  }
  function Canvas_init_$Init$(bitmap, surfaceProps, $this) {
    surfaceProps = surfaceProps === VOID ? new SurfaceProps() : surfaceProps;
    Canvas.call($this, org_jetbrains_skia_Canvas__1nMakeFromBitmap(bitmap.n5h_1, surfaceProps.x5j(), surfaceProps.w5j_1.a1_1), true, bitmap);
    Stats_instance.k5h();
    reachabilityBarrier(bitmap);
    return $this;
  }
  function Canvas_init_$Create$(bitmap, surfaceProps) {
    return Canvas_init_$Init$(bitmap, surfaceProps, objectCreate(protoOf(Canvas)));
  }
  function _FinalizerHolder_3() {
    _FinalizerHolder_instance_3 = this;
    this.y5j_1 = org_jetbrains_skia_Canvas__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_3;
  function _FinalizerHolder_getInstance_3() {
    if (_FinalizerHolder_instance_3 == null)
      new _FinalizerHolder_3();
    return _FinalizerHolder_instance_3;
  }
  function Canvas(ptr, managed, _owner) {
    Companion_getInstance_3();
    Managed.call(this, ptr, _FinalizerHolder_getInstance_3().y5j_1, managed);
    this.b5k_1 = _owner;
  }
  protoOf(Canvas).c5k = function (x0, y0, x1, y1, paint) {
    Stats_instance.k5h();
    try {
      org_jetbrains_skia_Canvas__1nDrawLine(this.n5h_1, x0, y0, x1, y1, getPtr(paint));
    }finally {
      reachabilityBarrier(paint);
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(Canvas).d5k = function (left, top, right, bottom, startAngle, sweepAngle, includeCenter, paint) {
    Stats_instance.k5h();
    try {
      org_jetbrains_skia_Canvas__1nDrawArc(this.n5h_1, left, top, right, bottom, startAngle, sweepAngle, includeCenter, getPtr(paint));
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(paint);
    }
    return this;
  };
  protoOf(Canvas).e5k = function (left, top, right, bottom, paint) {
    Stats_instance.k5h();
    try {
      org_jetbrains_skia_Canvas__1nDrawRect(this.n5h_1, left, top, right, bottom, getPtr(paint));
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(paint);
    }
    return this;
  };
  protoOf(Canvas).f5k = function (x, y, radius, paint) {
    Stats_instance.k5h();
    try {
      org_jetbrains_skia_Canvas__1nDrawOval(this.n5h_1, x - radius, y - radius, x + radius, y + radius, getPtr(paint));
    }finally {
      reachabilityBarrier(paint);
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(Canvas).g5k = function (left, top, right, bottom, radii, paint) {
    Stats_instance.k5h();
    try {
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          org_jetbrains_skia_Canvas__1nDrawRRect(this.n5h_1, left, top, right, bottom, $this$interopScope.h5k(radii), radii.length, getPtr(paint));
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
    }finally {
      reachabilityBarrier(paint);
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(Canvas).i5k = function (path, paint) {
    Stats_instance.k5h();
    try {
      org_jetbrains_skia_Canvas__1nDrawPath(this.n5h_1, getPtr(path), getPtr(paint));
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(path);
      reachabilityBarrier(paint);
    }
    return this;
  };
  protoOf(Canvas).j5k = function (image, src, dst) {
    return this.s5k(image, src.k5k_1, src.l5k_1, src.m5k_1, src.n5k_1, dst.k5k_1, dst.l5k_1, dst.m5k_1, dst.n5k_1, Companion_getInstance_36().o5k_1, null, true);
  };
  protoOf(Canvas).s5k = function (image, srcLeft, srcTop, srcRight, srcBottom, dstLeft, dstTop, dstRight, dstBottom, samplingMode, paint, strict) {
    Stats_instance.k5h();
    try {
      org_jetbrains_skia_Canvas__1nDrawImageRect(this.n5h_1, getPtr(image), srcLeft, srcTop, srcRight, srcBottom, dstLeft, dstTop, dstRight, dstBottom, samplingMode.t5k(), samplingMode.u5k(), getPtr(paint), strict);
    }finally {
      reachabilityBarrier(image);
      reachabilityBarrier(paint);
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(Canvas).v5k = function (image, src, dst, samplingMode, paint, strict) {
    return this.s5k(image, src.k5k_1, src.l5k_1, src.m5k_1, src.n5k_1, dst.k5k_1, dst.l5k_1, dst.m5k_1, dst.n5k_1, samplingMode, paint, strict);
  };
  protoOf(Canvas).w5k = function (picture, matrix, paint) {
    Stats_instance.k5h();
    try {
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          var tmp = this.n5h_1;
          var tmp_0 = getPtr(picture);
          org_jetbrains_skia_Canvas__1nDrawPicture(tmp, tmp_0, $this$interopScope.h5k(matrix == null ? null : matrix.x5k_1), getPtr(paint));
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(picture);
      reachabilityBarrier(paint);
    }
    return this;
  };
  protoOf(Canvas).m3p = function (color) {
    Stats_instance.k5h();
    try {
      org_jetbrains_skia_Canvas__1nClear(this.n5h_1, color);
    }finally {
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(Canvas).y5k = function () {
    Stats_instance.k5h();
    org_jetbrains_skia_Canvas__1nResetMatrix(this.n5h_1);
    return this;
  };
  protoOf(Canvas).z5k = function (left, top, right, bottom, mode, antiAlias) {
    Stats_instance.k5h();
    org_jetbrains_skia_Canvas__1nClipRect(this.n5h_1, left, top, right, bottom, mode.a1_1, antiAlias);
    return this;
  };
  protoOf(Canvas).a5l = function (left, top, right, bottom, radii, mode, antiAlias) {
    Stats_instance.k5h();
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        org_jetbrains_skia_Canvas__1nClipRRect(this.n5h_1, left, top, right, bottom, $this$interopScope.h5k(radii), radii.length, mode.a1_1, antiAlias);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return this;
  };
  protoOf(Canvas).b5l = function (p, mode, antiAlias) {
    Stats_instance.k5h();
    try {
      org_jetbrains_skia_Canvas__1nClipPath(this.n5h_1, getPtr(p), mode.a1_1, antiAlias);
    }finally {
      reachabilityBarrier(p);
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(Canvas).q5d = function (dx, dy) {
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        Stats_instance.k5h();
        org_jetbrains_skia_Canvas__1nTranslate(this.n5h_1, dx, dy);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return this;
  };
  protoOf(Canvas).c5l = function (sx, sy) {
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        Stats_instance.k5h();
        org_jetbrains_skia_Canvas__1nScale(this.n5h_1, sx, sy);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return this;
  };
  protoOf(Canvas).d5l = function (deg) {
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        Stats_instance.k5h();
        org_jetbrains_skia_Canvas__1nRotate(this.n5h_1, deg, 0.0, 0.0);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return this;
  };
  protoOf(Canvas).e5l = function (matrix) {
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        Stats_instance.k5h();
        org_jetbrains_skia_Canvas__1nConcat44(this.n5h_1, $this$interopScope.h5k(matrix.f5l_1));
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return this;
  };
  protoOf(Canvas).g5l = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_Canvas__1nSave(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Canvas).h5l = function (left, top, right, bottom, paint) {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_Canvas__1nSaveLayerRect(this.n5h_1, left, top, right, bottom, getPtr(paint));
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(paint);
    }
    return tmp;
  };
  protoOf(Canvas).i5l = function () {
    Stats_instance.k5h();
    org_jetbrains_skia_Canvas__1nRestore(this.n5h_1);
    return this;
  };
  var ClipMode_DIFFERENCE_instance;
  var ClipMode_INTERSECT_instance;
  var ClipMode_entriesInitialized;
  function ClipMode_initEntries() {
    if (ClipMode_entriesInitialized)
      return Unit_instance;
    ClipMode_entriesInitialized = true;
    ClipMode_DIFFERENCE_instance = new ClipMode('DIFFERENCE', 0);
    ClipMode_INTERSECT_instance = new ClipMode('INTERSECT', 1);
  }
  function ClipMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ClipMode_DIFFERENCE_getInstance() {
    ClipMode_initEntries();
    return ClipMode_DIFFERENCE_instance;
  }
  function ClipMode_INTERSECT_getInstance() {
    ClipMode_initEntries();
    return ClipMode_INTERSECT_instance;
  }
  function Companion_4() {
    Companion_instance_4 = this;
    Companion_instance_62.q5h();
  }
  protoOf(Companion_4).j5l = function (data) {
    var tmp;
    try {
      Stats_instance.k5h();
      var ptr = org_jetbrains_skia_Codec__1nMakeFromData(getPtr(data));
      // Inline function 'kotlin.require' call
      if (!!(ptr === Companion_instance_63.s5h())) {
        var message = 'Unsupported format';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      tmp = new Codec(ptr);
    }finally {
      reachabilityBarrier(data);
    }
    return tmp;
  };
  protoOf(Companion_4).k5l = function (result) {
    switch (result) {
      case 1:
        throw IllegalArgumentException_init_$Create$('Incomplete input: A partial image was generated.');
      case 2:
        throw IllegalArgumentException_init_$Create$('Error in input');
      case 3:
        throw IllegalArgumentException_init_$Create$('Invalid conversion: The generator cannot convert to match the request, ignoring dimensions');
      case 4:
        throw IllegalArgumentException_init_$Create$('Invalid scale: The generator cannot scale to requested size');
      case 5:
        throw IllegalArgumentException_init_$Create$('Invalid parameter: Parameters (besides info) are invalid. e.g. NULL pixels, rowBytes too small, etc');
      case 6:
        throw IllegalArgumentException_init_$Create$('Invalid input: The input did not contain a valid image');
      case 7:
        throw UnsupportedOperationException_init_$Create$('Could not rewind: Fulfilling this request requires rewinding the input, which is not supported for this input');
      case 8:
        throw RuntimeException_init_$Create$('Internal error');
      case 9:
        throw UnsupportedOperationException_init_$Create$('Unimplemented: This method is not implemented by this codec');
    }
  };
  var Companion_instance_4;
  function Companion_getInstance_4() {
    if (Companion_instance_4 == null)
      new Companion_4();
    return Companion_instance_4;
  }
  function _FinalizerHolder_4() {
    _FinalizerHolder_instance_4 = this;
    this.l5l_1 = org_jetbrains_skia_Codec__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_4;
  function _FinalizerHolder_getInstance_4() {
    if (_FinalizerHolder_instance_4 == null)
      new _FinalizerHolder_4();
    return _FinalizerHolder_instance_4;
  }
  function Codec_nGetImageInfo$ref() {
    return constructCallableReference(function (p0, p1, p2) {
      org_jetbrains_skia_Codec__1nGetImageInfo(p0, p1, p2);
      return Unit_instance;
    }, 3, 0, 20, 'Codec_nGetImageInfo');
  }
  function Codec$_get_framesInfo_$lambda_a68fga($buffer) {
    return function ($this$fromInteropArrayPointer, it) {
      org_jetbrains_skia_Codec__1nFramesInfo_GetInfos($buffer, it);
      return Unit_instance;
    };
  }
  function Codec(ptr) {
    Companion_getInstance_4();
    Managed.call(this, ptr, _FinalizerHolder_getInstance_4().l5l_1);
    this.o5l_1 = null;
  }
  protoOf(Codec).y5h = function () {
    var tmp;
    try {
      if (this.o5l_1 == null) {
        var tmp_0 = this;
        var tmp_1 = Companion_getInstance_23();
        var tmp_2 = this.n5h_1;
        tmp_0.o5l_1 = tmp_1.g5i(tmp_2, Codec_nGetImageInfo$ref());
      }
      tmp = ensureNotNull(this.o5l_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Codec).p5l = function (bitmap, frame, priorFrame) {
    var tmp;
    try {
      Stats_instance.k5h();
      Companion_getInstance_4().k5l(org_jetbrains_skia_Codec__1nReadPixels(this.n5h_1, getPtr(bitmap), frame, priorFrame));
      tmp = this;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(bitmap);
    }
    return tmp;
  };
  protoOf(Codec).q5l = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      var buffer = org_jetbrains_skia_Codec__1nGetFramesInfo(this.n5h_1);
      var size = org_jetbrains_skia_Codec__1nFramesInfo_GetSize(buffer);
      var tmp_0;
      if (size > 0) {
        var tmp_1 = Companion_instance;
        tmp_0 = tmp_1.x5g(size, Codec$_get_framesInfo_$lambda_a68fga(buffer));
      } else {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = [];
      }
      // Inline function 'kotlin.also' call
      var this_0 = tmp_0;
      org_jetbrains_skia_Codec__1nFramesInfo_Delete(buffer);
      tmp = this_0;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  function Color4f_init_$Init$(rgba, $this) {
    Color4f.call($this, rgba[0], rgba[1], rgba[2], rgba[3]);
    return $this;
  }
  function Color4f_init_$Create$(rgba) {
    return Color4f_init_$Init$(rgba, objectCreate(protoOf(Color4f)));
  }
  function Companion_5() {
  }
  var Companion_instance_5;
  function Companion_getInstance_5() {
    return Companion_instance_5;
  }
  function Color4f(r, g, b, a) {
    a = a === VOID ? 1.0 : a;
    this.r5l_1 = r;
    this.s5l_1 = g;
    this.t5l_1 = b;
    this.u5l_1 = a;
  }
  protoOf(Color4f).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Color4f))
      return false;
    if (!(compareTo(this.r5l_1, other.r5l_1) === 0))
      return false;
    if (!(compareTo(this.s5l_1, other.s5l_1) === 0))
      return false;
    if (!(compareTo(this.t5l_1, other.t5l_1) === 0))
      return false;
    return compareTo(this.u5l_1, other.u5l_1) === 0;
  };
  protoOf(Color4f).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + toBits(this.r5l_1) | 0;
    result = imul(result, PRIME) + toBits(this.s5l_1) | 0;
    result = imul(result, PRIME) + toBits(this.t5l_1) | 0;
    result = imul(result, PRIME) + toBits(this.u5l_1) | 0;
    return result;
  };
  protoOf(Color4f).toString = function () {
    return 'Color4f(_r=' + this.r5l_1 + ', _g=' + this.s5l_1 + ', _b=' + this.t5l_1 + ', _a=' + this.u5l_1 + ')';
  };
  protoOf(Color4f).v5l = function (_a) {
    return this.u5l_1 === _a ? this : new Color4f(this.r5l_1, this.s5l_1, this.t5l_1, _a);
  };
  var ColorAlphaType_UNKNOWN_instance;
  var ColorAlphaType_OPAQUE_instance;
  var ColorAlphaType_PREMUL_instance;
  var ColorAlphaType_UNPREMUL_instance;
  function values_1() {
    return [ColorAlphaType_UNKNOWN_getInstance(), ColorAlphaType_OPAQUE_getInstance(), ColorAlphaType_PREMUL_getInstance(), ColorAlphaType_UNPREMUL_getInstance()];
  }
  function get_entries_1() {
    if ($ENTRIES_1 == null)
      $ENTRIES_1 = enumEntries(values_1());
    return $ENTRIES_1;
  }
  var ColorAlphaType_entriesInitialized;
  function ColorAlphaType_initEntries() {
    if (ColorAlphaType_entriesInitialized)
      return Unit_instance;
    ColorAlphaType_entriesInitialized = true;
    ColorAlphaType_UNKNOWN_instance = new ColorAlphaType('UNKNOWN', 0);
    ColorAlphaType_OPAQUE_instance = new ColorAlphaType('OPAQUE', 1);
    ColorAlphaType_PREMUL_instance = new ColorAlphaType('PREMUL', 2);
    ColorAlphaType_UNPREMUL_instance = new ColorAlphaType('UNPREMUL', 3);
  }
  var $ENTRIES_1;
  function ColorAlphaType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function ColorAlphaType_UNKNOWN_getInstance() {
    ColorAlphaType_initEntries();
    return ColorAlphaType_UNKNOWN_instance;
  }
  function ColorAlphaType_OPAQUE_getInstance() {
    ColorAlphaType_initEntries();
    return ColorAlphaType_OPAQUE_instance;
  }
  function ColorAlphaType_PREMUL_getInstance() {
    ColorAlphaType_initEntries();
    return ColorAlphaType_PREMUL_instance;
  }
  function ColorAlphaType_UNPREMUL_getInstance() {
    ColorAlphaType_initEntries();
    return ColorAlphaType_UNPREMUL_instance;
  }
  function Companion_6() {
    Companion_instance_6 = this;
    Companion_instance_62.q5h();
    this.w5l_1 = ColorFilter_init_$Create$_0(org_jetbrains_skia_ColorFilter__1nGetSRGBToLinearGamma(), false);
    this.x5l_1 = ColorFilter_init_$Create$_0(org_jetbrains_skia_ColorFilter__1nGetLuma(), false);
  }
  protoOf(Companion_6).y5l = function (color, mode) {
    Stats_instance.k5h();
    return ColorFilter_init_$Create$(org_jetbrains_skia_ColorFilter__1nMakeBlend(color, mode.a1_1));
  };
  protoOf(Companion_6).z5l = function (matrix) {
    Stats_instance.k5h();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        tmp$ret$0 = org_jetbrains_skia_ColorFilter__1nMakeMatrix($this$interopScope.h5k(_ColorMatrix___get_mat__impl__i2eagq(matrix)));
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return ColorFilter_init_$Create$(tmp$ret$0);
  };
  var Companion_instance_6;
  function Companion_getInstance_6() {
    if (Companion_instance_6 == null)
      new Companion_6();
    return Companion_instance_6;
  }
  function ColorFilter_init_$Init$(ptr, $this) {
    RefCnt_init_$Init$(ptr, $this);
    ColorFilter.call($this);
    return $this;
  }
  function ColorFilter_init_$Create$(ptr) {
    return ColorFilter_init_$Init$(ptr, objectCreate(protoOf(ColorFilter)));
  }
  function ColorFilter_init_$Init$_0(ptr, allowClose, $this) {
    RefCnt_init_$Init$_0(ptr, allowClose, $this);
    ColorFilter.call($this);
    return $this;
  }
  function ColorFilter_init_$Create$_0(ptr, allowClose) {
    return ColorFilter_init_$Init$_0(ptr, allowClose, objectCreate(protoOf(ColorFilter)));
  }
  function ColorFilter() {
    Companion_getInstance_6();
  }
  function Companion_7() {
    Companion_instance_7 = this;
    this.d5m_1 = new ColorInfo(ColorType_UNKNOWN_getInstance(), ColorAlphaType_UNKNOWN_getInstance(), null);
  }
  var Companion_instance_7;
  function Companion_getInstance_7() {
    if (Companion_instance_7 == null)
      new Companion_7();
    return Companion_instance_7;
  }
  function ColorInfo(colorType, alphaType, colorSpace) {
    Companion_getInstance_7();
    this.o5i_1 = colorType;
    this.p5i_1 = alphaType;
    this.q5i_1 = colorSpace;
  }
  protoOf(ColorInfo).x5i = function () {
    return this.p5i_1.equals(ColorAlphaType_OPAQUE_getInstance()) || this.o5i_1.g5m();
  };
  protoOf(ColorInfo).h5m = function () {
    return this.o5i_1.h5m();
  };
  protoOf(ColorInfo).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof ColorInfo))
      return false;
    if (!this.o5i_1.equals(other.o5i_1))
      return false;
    if (!this.p5i_1.equals(other.p5i_1))
      return false;
    return equals(this.q5i_1, other.q5i_1);
  };
  protoOf(ColorInfo).hashCode = function () {
    var prime = 59;
    var result = 1;
    result = imul(result, prime) + this.o5i_1.hashCode() | 0;
    result = imul(result, prime) + this.p5i_1.hashCode() | 0;
    var tmp = imul(result, prime);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.q5i_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    return result;
  };
  protoOf(ColorInfo).toString = function () {
    return 'ColorInfo(_colorType=' + this.o5i_1.toString() + ', _alphaType=' + this.p5i_1.toString() + ', _colorSpace=' + toString_0(this.q5i_1) + ')';
  };
  function _ColorMatrix___init__impl__3gytx1(mat) {
    // Inline function 'kotlin.require' call
    if (!(_ColorMatrix___get_mat__impl__i2eagq(mat).length === 20)) {
      var message = 'Expected 20 elements, got ' + _ColorMatrix___get_mat__impl__i2eagq(mat).length;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return mat;
  }
  function _ColorMatrix___get_mat__impl__i2eagq($this) {
    return $this;
  }
  function Companion_8() {
    Companion_instance_8 = this;
    Companion_instance_62.q5h();
    this.i5m_1 = ColorSpace_init_$Create$_0(org_jetbrains_skia_ColorSpace__1nMakeSRGB(), false);
    this.j5m_1 = ColorSpace_init_$Create$_0(org_jetbrains_skia_ColorSpace__1nMakeSRGBLinear(), false);
    this.k5m_1 = ColorSpace_init_$Create$_0(org_jetbrains_skia_ColorSpace__1nMakeDisplayP3(), false);
  }
  var Companion_instance_8;
  function Companion_getInstance_8() {
    if (Companion_instance_8 == null)
      new Companion_8();
    return Companion_instance_8;
  }
  function ColorSpace_init_$Init$(ptr, $this) {
    Managed.call($this, ptr, _FinalizerHolder_getInstance_5().l5m_1, true);
    ColorSpace.call($this);
    return $this;
  }
  function ColorSpace_init_$Create$(ptr) {
    return ColorSpace_init_$Init$(ptr, objectCreate(protoOf(ColorSpace)));
  }
  function ColorSpace_init_$Init$_0(ptr, managed, $this) {
    Managed.call($this, ptr, _FinalizerHolder_getInstance_5().l5m_1, managed);
    ColorSpace.call($this);
    return $this;
  }
  function ColorSpace_init_$Create$_0(ptr, managed) {
    return ColorSpace_init_$Init$_0(ptr, managed, objectCreate(protoOf(ColorSpace)));
  }
  function _FinalizerHolder_5() {
    _FinalizerHolder_instance_5 = this;
    this.l5m_1 = org_jetbrains_skia_ColorSpace__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_5;
  function _FinalizerHolder_getInstance_5() {
    if (_FinalizerHolder_instance_5 == null)
      new _FinalizerHolder_5();
    return _FinalizerHolder_instance_5;
  }
  function ColorSpace() {
    Companion_getInstance_8();
  }
  var ColorType_UNKNOWN_instance;
  var ColorType_ALPHA_8_instance;
  var ColorType_RGB_565_instance;
  var ColorType_ARGB_4444_instance;
  var ColorType_RGBA_8888_instance;
  var ColorType_RGB_888X_instance;
  var ColorType_BGRA_8888_instance;
  var ColorType_RGBA_1010102_instance;
  var ColorType_BGRA_1010102_instance;
  var ColorType_RGB_101010X_instance;
  var ColorType_BGR_101010X_instance;
  var ColorType_BGR_101010X_XR_instance;
  var ColorType_BGRA_10101010_XR_instance;
  var ColorType_RGBA_10x6_instance;
  var ColorType_GRAY_8_instance;
  var ColorType_RGBA_F16NORM_instance;
  var ColorType_RGBA_F16_instance;
  var ColorType_RGBA_F32_instance;
  var ColorType_R8G8_UNORM_instance;
  var ColorType_A16_FLOAT_instance;
  var ColorType_R16G16_FLOAT_instance;
  var ColorType_A16_UNORM_instance;
  var ColorType_R16G16_UNORM_instance;
  var ColorType_R16G16B16A16_UNORM_instance;
  function Companion_9() {
    Companion_instance_9 = this;
    this.m5m_1 = ColorType_BGRA_8888_getInstance();
  }
  var Companion_instance_9;
  function Companion_getInstance_9() {
    ColorType_initEntries();
    if (Companion_instance_9 == null)
      new Companion_9();
    return Companion_instance_9;
  }
  function values_2() {
    return [ColorType_UNKNOWN_getInstance(), ColorType_ALPHA_8_getInstance(), ColorType_RGB_565_getInstance(), ColorType_ARGB_4444_getInstance(), ColorType_RGBA_8888_getInstance(), ColorType_RGB_888X_getInstance(), ColorType_BGRA_8888_getInstance(), ColorType_RGBA_1010102_getInstance(), ColorType_BGRA_1010102_getInstance(), ColorType_RGB_101010X_getInstance(), ColorType_BGR_101010X_getInstance(), ColorType_BGR_101010X_XR_getInstance(), ColorType_BGRA_10101010_XR_getInstance(), ColorType_RGBA_10x6_getInstance(), ColorType_GRAY_8_getInstance(), ColorType_RGBA_F16NORM_getInstance(), ColorType_RGBA_F16_getInstance(), ColorType_RGBA_F32_getInstance(), ColorType_R8G8_UNORM_getInstance(), ColorType_A16_FLOAT_getInstance(), ColorType_R16G16_FLOAT_getInstance(), ColorType_A16_UNORM_getInstance(), ColorType_R16G16_UNORM_getInstance(), ColorType_R16G16B16A16_UNORM_getInstance()];
  }
  function get_entries_2() {
    if ($ENTRIES_2 == null)
      $ENTRIES_2 = enumEntries(values_2());
    return $ENTRIES_2;
  }
  var ColorType_entriesInitialized;
  function ColorType_initEntries() {
    if (ColorType_entriesInitialized)
      return Unit_instance;
    ColorType_entriesInitialized = true;
    ColorType_UNKNOWN_instance = new ColorType('UNKNOWN', 0);
    ColorType_ALPHA_8_instance = new ColorType('ALPHA_8', 1);
    ColorType_RGB_565_instance = new ColorType('RGB_565', 2);
    ColorType_ARGB_4444_instance = new ColorType('ARGB_4444', 3);
    ColorType_RGBA_8888_instance = new ColorType('RGBA_8888', 4);
    ColorType_RGB_888X_instance = new ColorType('RGB_888X', 5);
    ColorType_BGRA_8888_instance = new ColorType('BGRA_8888', 6);
    ColorType_RGBA_1010102_instance = new ColorType('RGBA_1010102', 7);
    ColorType_BGRA_1010102_instance = new ColorType('BGRA_1010102', 8);
    ColorType_RGB_101010X_instance = new ColorType('RGB_101010X', 9);
    ColorType_BGR_101010X_instance = new ColorType('BGR_101010X', 10);
    ColorType_BGR_101010X_XR_instance = new ColorType('BGR_101010X_XR', 11);
    ColorType_BGRA_10101010_XR_instance = new ColorType('BGRA_10101010_XR', 12);
    ColorType_RGBA_10x6_instance = new ColorType('RGBA_10x6', 13);
    ColorType_GRAY_8_instance = new ColorType('GRAY_8', 14);
    ColorType_RGBA_F16NORM_instance = new ColorType('RGBA_F16NORM', 15);
    ColorType_RGBA_F16_instance = new ColorType('RGBA_F16', 16);
    ColorType_RGBA_F32_instance = new ColorType('RGBA_F32', 17);
    ColorType_R8G8_UNORM_instance = new ColorType('R8G8_UNORM', 18);
    ColorType_A16_FLOAT_instance = new ColorType('A16_FLOAT', 19);
    ColorType_R16G16_FLOAT_instance = new ColorType('R16G16_FLOAT', 20);
    ColorType_A16_UNORM_instance = new ColorType('A16_UNORM', 21);
    ColorType_R16G16_UNORM_instance = new ColorType('R16G16_UNORM', 22);
    ColorType_R16G16B16A16_UNORM_instance = new ColorType('R16G16B16A16_UNORM', 23);
    Companion_getInstance_9();
  }
  var $ENTRIES_2;
  function ColorType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  protoOf(ColorType).h5m = function () {
    var tmp;
    switch (this.a1_1) {
      case 0:
        tmp = 0;
        break;
      case 1:
        tmp = 1;
        break;
      case 2:
        tmp = 2;
        break;
      case 3:
        tmp = 2;
        break;
      case 4:
        tmp = 4;
        break;
      case 6:
        tmp = 4;
        break;
      case 5:
        tmp = 4;
        break;
      case 7:
        tmp = 4;
        break;
      case 9:
        tmp = 4;
        break;
      case 8:
        tmp = 4;
        break;
      case 10:
        tmp = 4;
        break;
      case 11:
        tmp = 4;
        break;
      case 12:
        tmp = 4;
        break;
      case 13:
        tmp = 8;
        break;
      case 14:
        tmp = 1;
        break;
      case 15:
        tmp = 8;
        break;
      case 16:
        tmp = 8;
        break;
      case 17:
        tmp = 16;
        break;
      case 18:
        tmp = 2;
        break;
      case 21:
        tmp = 2;
        break;
      case 22:
        tmp = 4;
        break;
      case 19:
        tmp = 2;
        break;
      case 20:
        tmp = 4;
        break;
      case 23:
        tmp = 8;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  };
  protoOf(ColorType).g5m = function () {
    return org_jetbrains_skia_ColorType__1nIsAlwaysOpaque(this.a1_1);
  };
  function ColorType_UNKNOWN_getInstance() {
    ColorType_initEntries();
    return ColorType_UNKNOWN_instance;
  }
  function ColorType_ALPHA_8_getInstance() {
    ColorType_initEntries();
    return ColorType_ALPHA_8_instance;
  }
  function ColorType_RGB_565_getInstance() {
    ColorType_initEntries();
    return ColorType_RGB_565_instance;
  }
  function ColorType_ARGB_4444_getInstance() {
    ColorType_initEntries();
    return ColorType_ARGB_4444_instance;
  }
  function ColorType_RGBA_8888_getInstance() {
    ColorType_initEntries();
    return ColorType_RGBA_8888_instance;
  }
  function ColorType_RGB_888X_getInstance() {
    ColorType_initEntries();
    return ColorType_RGB_888X_instance;
  }
  function ColorType_BGRA_8888_getInstance() {
    ColorType_initEntries();
    return ColorType_BGRA_8888_instance;
  }
  function ColorType_RGBA_1010102_getInstance() {
    ColorType_initEntries();
    return ColorType_RGBA_1010102_instance;
  }
  function ColorType_BGRA_1010102_getInstance() {
    ColorType_initEntries();
    return ColorType_BGRA_1010102_instance;
  }
  function ColorType_RGB_101010X_getInstance() {
    ColorType_initEntries();
    return ColorType_RGB_101010X_instance;
  }
  function ColorType_BGR_101010X_getInstance() {
    ColorType_initEntries();
    return ColorType_BGR_101010X_instance;
  }
  function ColorType_BGR_101010X_XR_getInstance() {
    ColorType_initEntries();
    return ColorType_BGR_101010X_XR_instance;
  }
  function ColorType_BGRA_10101010_XR_getInstance() {
    ColorType_initEntries();
    return ColorType_BGRA_10101010_XR_instance;
  }
  function ColorType_RGBA_10x6_getInstance() {
    ColorType_initEntries();
    return ColorType_RGBA_10x6_instance;
  }
  function ColorType_GRAY_8_getInstance() {
    ColorType_initEntries();
    return ColorType_GRAY_8_instance;
  }
  function ColorType_RGBA_F16NORM_getInstance() {
    ColorType_initEntries();
    return ColorType_RGBA_F16NORM_instance;
  }
  function ColorType_RGBA_F16_getInstance() {
    ColorType_initEntries();
    return ColorType_RGBA_F16_instance;
  }
  function ColorType_RGBA_F32_getInstance() {
    ColorType_initEntries();
    return ColorType_RGBA_F32_instance;
  }
  function ColorType_R8G8_UNORM_getInstance() {
    ColorType_initEntries();
    return ColorType_R8G8_UNORM_instance;
  }
  function ColorType_A16_FLOAT_getInstance() {
    ColorType_initEntries();
    return ColorType_A16_FLOAT_instance;
  }
  function ColorType_R16G16_FLOAT_getInstance() {
    ColorType_initEntries();
    return ColorType_R16G16_FLOAT_instance;
  }
  function ColorType_A16_UNORM_getInstance() {
    ColorType_initEntries();
    return ColorType_A16_UNORM_instance;
  }
  function ColorType_R16G16_UNORM_getInstance() {
    ColorType_initEntries();
    return ColorType_R16G16_UNORM_instance;
  }
  function ColorType_R16G16B16A16_UNORM_getInstance() {
    ColorType_initEntries();
    return ColorType_R16G16B16A16_UNORM_instance;
  }
  function CubicResampler(b, c) {
    this.n5m_1 = b;
    this.o5m_1 = c;
  }
  protoOf(CubicResampler).t5k = function () {
    return toBits(this.n5m_1) | -2147483648;
  };
  protoOf(CubicResampler).u5k = function () {
    return toBits(this.o5m_1);
  };
  protoOf(CubicResampler).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof CubicResampler))
      return false;
    if (!(compareTo(this.n5m_1, other.n5m_1) === 0))
      return false;
    return compareTo(this.o5m_1, other.o5m_1) === 0;
  };
  protoOf(CubicResampler).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + toBits(this.n5m_1) | 0;
    result = imul(result, PRIME) + toBits(this.o5m_1) | 0;
    return result;
  };
  protoOf(CubicResampler).toString = function () {
    return 'CubicResampler(_B=' + this.n5m_1 + ', _C=' + this.o5m_1 + ')';
  };
  function Companion_10() {
    Companion_instance_10 = this;
    Companion_instance_62.q5h();
  }
  protoOf(Companion_10).p5m = function (bytes, offset, length) {
    Stats_instance.k5h();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        tmp$ret$0 = org_jetbrains_skia_Data__1nMakeFromBytes($this$interopScope.q5m(bytes), offset, length);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return new Data(tmp$ret$0);
  };
  protoOf(Companion_10).r5m = function (bytes, offset, length, $super) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? bytes.length : length;
    return $super === VOID ? this.p5m(bytes, offset, length) : $super.p5m.call(this, bytes, offset, length);
  };
  var Companion_instance_10;
  function Companion_getInstance_10() {
    if (Companion_instance_10 == null)
      new Companion_10();
    return Companion_instance_10;
  }
  function _FinalizerHolder_6() {
    _FinalizerHolder_instance_6 = this;
    this.s5m_1 = org_jetbrains_skia_Data__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_6;
  function _FinalizerHolder_getInstance_6() {
    if (_FinalizerHolder_instance_6 == null)
      new _FinalizerHolder_6();
    return _FinalizerHolder_instance_6;
  }
  function Data(ptr) {
    Companion_getInstance_10();
    Managed.call(this, ptr, _FinalizerHolder_getInstance_6().s5m_1);
    this.v5m_1 = null;
  }
  protoOf(Data).n1 = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_Data__1nSize(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Data).w5m = function () {
    return this.x5m(0, this.n1());
  };
  protoOf(Data).x5m = function (offset, length) {
    var tmp;
    try {
      Stats_instance.k5h();
      // Inline function 'kotlin.check' call
      if (!(org_jetbrains_skia_Data__1nSize(this.n5h_1) >= (offset + length | 0))) {
        var message = 'Data=' + this.n5h_1 + ": Can't getBytes with offset=" + offset + ' and length=' + length;
        throw IllegalStateException_init_$Create$(toString(message));
      }
      // Inline function 'org.jetbrains.skia.impl.withResult' call
      var result = new Int8Array(length);
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          var handle = $this$interopScope.y5m(result);
          org_jetbrains_skia_Data__1nBytes(this.n5h_1, offset, length, handle);
          $this$interopScope.z5m(handle, result);
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
      tmp = result;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Data).equals = function (other) {
    var tmp0_elvis_lhs = other instanceof Data ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var otherData = tmp;
    return this.o5h(otherData);
  };
  protoOf(Data).o5h = function (other) {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_Data__1nEquals(this.n5h_1, getPtr(other));
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(other);
    }
    return tmp;
  };
  function Companion_11() {
    Companion_instance_11 = this;
    Companion_instance_62.q5h();
  }
  protoOf(Companion_11).a5n = function () {
    Stats_instance.k5h();
    loadOpenGLLibrary();
    var ptr = org_jetbrains_skia_DirectContext__1nMakeGL();
    if (ptr === Companion_instance_63.s5h())
      throw new RenderException("Can't create OpenGL DirectContext");
    return new DirectContext(ptr);
  };
  var Companion_instance_11;
  function Companion_getInstance_11() {
    if (Companion_instance_11 == null)
      new Companion_11();
    return Companion_instance_11;
  }
  function DirectContext(ptr) {
    Companion_getInstance_11();
    RefCnt_init_$Init$(ptr, this);
  }
  protoOf(DirectContext).d5n = function () {
    Stats_instance.k5h();
    org_jetbrains_skia_DirectContext__1nFlushDefault(this.n5h_1);
    return this;
  };
  protoOf(DirectContext).e5n = function (surface, syncCpu) {
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_DirectContext__1nFlushAndSubmit(this.n5h_1, surface.n5h_1, syncCpu);
    }finally {
      reachabilityBarrier(this);
    }
  };
  protoOf(DirectContext).f5n = function (surface, syncCpu, $super) {
    syncCpu = syncCpu === VOID ? false : syncCpu;
    var tmp;
    if ($super === VOID) {
      this.e5n(surface, syncCpu);
      tmp = Unit_instance;
    } else {
      tmp = $super.e5n.call(this, surface, syncCpu);
    }
    return tmp;
  };
  var EncodedImageFormat_BMP_instance;
  var EncodedImageFormat_GIF_instance;
  var EncodedImageFormat_ICO_instance;
  var EncodedImageFormat_JPEG_instance;
  var EncodedImageFormat_PNG_instance;
  var EncodedImageFormat_WBMP_instance;
  var EncodedImageFormat_WEBP_instance;
  var EncodedImageFormat_PKM_instance;
  var EncodedImageFormat_KTX_instance;
  var EncodedImageFormat_ASTC_instance;
  var EncodedImageFormat_DNG_instance;
  var EncodedImageFormat_HEIF_instance;
  var EncodedImageFormat_entriesInitialized;
  function EncodedImageFormat_initEntries() {
    if (EncodedImageFormat_entriesInitialized)
      return Unit_instance;
    EncodedImageFormat_entriesInitialized = true;
    EncodedImageFormat_BMP_instance = new EncodedImageFormat('BMP', 0);
    EncodedImageFormat_GIF_instance = new EncodedImageFormat('GIF', 1);
    EncodedImageFormat_ICO_instance = new EncodedImageFormat('ICO', 2);
    EncodedImageFormat_JPEG_instance = new EncodedImageFormat('JPEG', 3);
    EncodedImageFormat_PNG_instance = new EncodedImageFormat('PNG', 4);
    EncodedImageFormat_WBMP_instance = new EncodedImageFormat('WBMP', 5);
    EncodedImageFormat_WEBP_instance = new EncodedImageFormat('WEBP', 6);
    EncodedImageFormat_PKM_instance = new EncodedImageFormat('PKM', 7);
    EncodedImageFormat_KTX_instance = new EncodedImageFormat('KTX', 8);
    EncodedImageFormat_ASTC_instance = new EncodedImageFormat('ASTC', 9);
    EncodedImageFormat_DNG_instance = new EncodedImageFormat('DNG', 10);
    EncodedImageFormat_HEIF_instance = new EncodedImageFormat('HEIF', 11);
  }
  function EncodedImageFormat(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function EncodedImageFormat_JPEG_getInstance() {
    EncodedImageFormat_initEntries();
    return EncodedImageFormat_JPEG_instance;
  }
  function EncodedImageFormat_PNG_getInstance() {
    EncodedImageFormat_initEntries();
    return EncodedImageFormat_PNG_instance;
  }
  function FilterMipmap(filterMode, mipmapMode) {
    mipmapMode = mipmapMode === VOID ? MipmapMode_NONE_getInstance() : mipmapMode;
    this.g5n_1 = filterMode;
    this.h5n_1 = mipmapMode;
  }
  protoOf(FilterMipmap).t5k = function () {
    return this.g5n_1.a1_1;
  };
  protoOf(FilterMipmap).u5k = function () {
    return this.h5n_1.a1_1;
  };
  protoOf(FilterMipmap).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof FilterMipmap))
      return false;
    if (!this.g5n_1.equals(other.g5n_1))
      return false;
    return this.h5n_1.equals(other.h5n_1);
  };
  protoOf(FilterMipmap).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + this.g5n_1.hashCode() | 0;
    result = imul(result, PRIME) + this.h5n_1.hashCode() | 0;
    return result;
  };
  protoOf(FilterMipmap).toString = function () {
    return 'FilterMipmap(_filterMode=' + this.g5n_1.toString() + ', _mipmapMode=' + this.h5n_1.toString() + ')';
  };
  var FilterMode_NEAREST_instance;
  var FilterMode_LINEAR_instance;
  var FilterMode_entriesInitialized;
  function FilterMode_initEntries() {
    if (FilterMode_entriesInitialized)
      return Unit_instance;
    FilterMode_entriesInitialized = true;
    FilterMode_NEAREST_instance = new FilterMode('NEAREST', 0);
    FilterMode_LINEAR_instance = new FilterMode('LINEAR', 1);
  }
  function FilterMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function FilterMode_NEAREST_getInstance() {
    FilterMode_initEntries();
    return FilterMode_NEAREST_instance;
  }
  function FilterMode_LINEAR_getInstance() {
    FilterMode_initEntries();
    return FilterMode_LINEAR_instance;
  }
  var FilterTileMode_CLAMP_instance;
  var FilterTileMode_REPEAT_instance;
  var FilterTileMode_MIRROR_instance;
  var FilterTileMode_DECAL_instance;
  var FilterTileMode_entriesInitialized;
  function FilterTileMode_initEntries() {
    if (FilterTileMode_entriesInitialized)
      return Unit_instance;
    FilterTileMode_entriesInitialized = true;
    FilterTileMode_CLAMP_instance = new FilterTileMode('CLAMP', 0);
    FilterTileMode_REPEAT_instance = new FilterTileMode('REPEAT', 1);
    FilterTileMode_MIRROR_instance = new FilterTileMode('MIRROR', 2);
    FilterTileMode_DECAL_instance = new FilterTileMode('DECAL', 3);
  }
  function FilterTileMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function FilterTileMode_CLAMP_getInstance() {
    FilterTileMode_initEntries();
    return FilterTileMode_CLAMP_instance;
  }
  function FilterTileMode_REPEAT_getInstance() {
    FilterTileMode_initEntries();
    return FilterTileMode_REPEAT_instance;
  }
  function FilterTileMode_MIRROR_getInstance() {
    FilterTileMode_initEntries();
    return FilterTileMode_MIRROR_instance;
  }
  function FilterTileMode_DECAL_getInstance() {
    FilterTileMode_initEntries();
    return FilterTileMode_DECAL_instance;
  }
  function Companion_12() {
    Companion_instance_12 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_12;
  function Companion_getInstance_12() {
    if (Companion_instance_12 == null)
      new Companion_12();
    return Companion_instance_12;
  }
  function Font_init_$Init$(ptr, $this) {
    Managed.call($this, ptr, _FinalizerHolder_getInstance_7().i5n_1);
    Font.call($this);
    return $this;
  }
  function Font_init_$Init$_0($this) {
    Font_init_$Init$(org_jetbrains_skia_Font__1nMakeDefault(), $this);
    Stats_instance.k5h();
    return $this;
  }
  function Font_init_$Create$() {
    return Font_init_$Init$_0(objectCreate(protoOf(Font)));
  }
  function Font_init_$Init$_1(typeface, size, $this) {
    Font_init_$Init$(org_jetbrains_skia_Font__1nMakeTypefaceSize(getPtr(typeface), size), $this);
    Stats_instance.k5h();
    reachabilityBarrier(typeface);
    return $this;
  }
  function Font_init_$Create$_0(typeface, size) {
    return Font_init_$Init$_1(typeface, size, objectCreate(protoOf(Font)));
  }
  function _FinalizerHolder_7() {
    _FinalizerHolder_instance_7 = this;
    this.i5n_1 = org_jetbrains_skia_Font__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_7;
  function _FinalizerHolder_getInstance_7() {
    if (_FinalizerHolder_instance_7 == null)
      new _FinalizerHolder_7();
    return _FinalizerHolder_instance_7;
  }
  function Font$_get_metrics_$lambda_bxy7iq(this$0) {
    return function ($this$fromInteropPointer, it) {
      org_jetbrains_skia_Font__1nGetMetrics(this$0.n5h_1, it);
      return Unit_instance;
    };
  }
  protoOf(Font).o5h = function (other) {
    var tmp;
    try {
      tmp = org_jetbrains_skia_Font__1nEquals(this.n5h_1, getPtr(other));
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(other);
    }
    return tmp;
  };
  protoOf(Font).l5n = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      var tmp_0 = Companion_instance_14;
      tmp = fromInteropPointer(tmp_0, Font$_get_metrics_$lambda_bxy7iq(this));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  function Font() {
    Companion_getInstance_12();
  }
  var FontEdging_ALIAS_instance;
  var FontEdging_ANTI_ALIAS_instance;
  var FontEdging_SUBPIXEL_ANTI_ALIAS_instance;
  var FontEdging_entriesInitialized;
  function FontEdging_initEntries() {
    if (FontEdging_entriesInitialized)
      return Unit_instance;
    FontEdging_entriesInitialized = true;
    FontEdging_ALIAS_instance = new FontEdging('ALIAS', 0);
    FontEdging_ANTI_ALIAS_instance = new FontEdging('ANTI_ALIAS', 1);
    FontEdging_SUBPIXEL_ANTI_ALIAS_instance = new FontEdging('SUBPIXEL_ANTI_ALIAS', 2);
  }
  function FontEdging(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function FontEdging_ALIAS_getInstance() {
    FontEdging_initEntries();
    return FontEdging_ALIAS_instance;
  }
  function FontEdging_ANTI_ALIAS_getInstance() {
    FontEdging_initEntries();
    return FontEdging_ANTI_ALIAS_instance;
  }
  function FontEdging_SUBPIXEL_ANTI_ALIAS_getInstance() {
    FontEdging_initEntries();
    return FontEdging_SUBPIXEL_ANTI_ALIAS_instance;
  }
  function FontFeature$Companion$parseW3$lambda(it) {
    // Inline function 'kotlin.text.trim' call
    var tmp$ret$0 = toString(trim(isCharSequence(it) ? it : THROW_CCE()));
    var parts = split(tmp$ret$0, [' ']);
    var name = parts.l1(0);
    var value = getOrNull(parts, 1);
    var tmp;
    switch (value) {
      case 'on':
      case null:
        tmp = 1;
        break;
      case 'off':
        tmp = 0;
        break;
      default:
        var tmp0_elvis_lhs = toIntOrNull(value);
        tmp = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
        break;
    }
    var value_0 = tmp;
    return name.length === 4 ? FontFeature_init_$Create$(name, value_0) : null;
  }
  function FontFeature_init_$Init$(feature, value, $this) {
    FontFeature.call($this, Companion_instance_18.m5n(feature), value, _UInt___init__impl__l7qpdl(0), _UInt___init__impl__l7qpdl(-1));
    return $this;
  }
  function FontFeature_init_$Create$(feature, value) {
    return FontFeature_init_$Init$(feature, value, objectCreate(protoOf(FontFeature)));
  }
  function Companion_13() {
    Companion_instance_13 = this;
    this.n5n_1 = _UInt___init__impl__l7qpdl(0);
    this.o5n_1 = _UInt___init__impl__l7qpdl(-1);
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.p5n_1 = Array(0);
    this.q5n_1 = compilePattern('\\s+');
    this.r5n_1 = compilePattern('([-+])?([a-z0-9]{4})(?:\\[(\\d+)?:(\\d+)?\\])?(?:=(\\d+))?');
    this.s5n_1 = 1;
    this.t5n_1 = 2;
    this.u5n_1 = 3;
    this.v5n_1 = 4;
    this.w5n_1 = 5;
  }
  protoOf(Companion_13).x5n = function (str) {
    var tmp = splitToSequence(str, [',']);
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = toList(mapNotNull(tmp, FontFeature$Companion$parseW3$lambda));
    return copyToArray(this_0);
  };
  var Companion_instance_13;
  function Companion_getInstance_13() {
    if (Companion_instance_13 == null)
      new Companion_13();
    return Companion_instance_13;
  }
  function FontFeature(_tag, value, start, end) {
    Companion_getInstance_13();
    this.y5n_1 = _tag;
    this.z5n_1 = value;
    this.a5o_1 = start;
    this.b5o_1 = end;
  }
  protoOf(FontFeature).c5o = function () {
    return Companion_instance_18.d5o(this.y5n_1);
  };
  protoOf(FontFeature).toString = function () {
    var range = '';
    var tmp;
    var tmp0 = this.a5o_1;
    // Inline function 'kotlin.UInt.compareTo' call
    var other = _UInt___init__impl__l7qpdl(0);
    if (uintCompare(_UInt___get_data__impl__f0vqqw(tmp0), _UInt___get_data__impl__f0vqqw(other)) > 0) {
      tmp = true;
    } else {
      var tmp0_0 = this.b5o_1;
      // Inline function 'kotlin.UInt.compareTo' call
      var other_0 = _UInt___init__impl__l7qpdl(-1);
      tmp = uintCompare(_UInt___get_data__impl__f0vqqw(tmp0_0), _UInt___get_data__impl__f0vqqw(other_0)) < 0;
    }
    if (tmp) {
      var tmp_0;
      var tmp0_1 = this.a5o_1;
      // Inline function 'kotlin.UInt.compareTo' call
      var other_1 = _UInt___init__impl__l7qpdl(0);
      if (uintCompare(_UInt___get_data__impl__f0vqqw(tmp0_1), _UInt___get_data__impl__f0vqqw(other_1)) > 0) {
        tmp_0 = new UInt(this.a5o_1);
      } else {
        tmp_0 = '';
      }
      var tmp_1 = '[' + tmp_0 + ':';
      var tmp_2;
      var tmp0_2 = this.b5o_1;
      // Inline function 'kotlin.UInt.compareTo' call
      var other_2 = _UInt___init__impl__l7qpdl(-1);
      if (uintCompare(_UInt___get_data__impl__f0vqqw(tmp0_2), _UInt___get_data__impl__f0vqqw(other_2)) < 0) {
        tmp_2 = new UInt(this.b5o_1);
      } else {
        tmp_2 = '';
      }
      range = tmp_1 + toString(tmp_2) + ']';
    }
    var valuePrefix = '';
    var valueSuffix = '';
    if (this.z5n_1 === 0)
      valuePrefix = '-';
    else if (this.z5n_1 === 1)
      valuePrefix = '+';
    else
      valueSuffix = '=' + this.z5n_1;
    return 'FontFeature(' + valuePrefix + this.y5n_1 + range + valueSuffix + ')';
  };
  protoOf(FontFeature).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof FontFeature))
      return false;
    if (!(this.c5o() === other.c5o()))
      return false;
    if (!(this.z5n_1 === other.z5n_1))
      return false;
    if (!(this.a5o_1 === other.a5o_1))
      return false;
    return this.b5o_1 === other.b5o_1;
  };
  protoOf(FontFeature).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + this.y5n_1 | 0;
    result = imul(result, PRIME) + this.z5n_1 | 0;
    var tmp = imul(result, PRIME);
    // Inline function 'kotlin.UInt.shr' call
    var this_0 = this.a5o_1;
    var tmp0 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_0) >>> 16 | 0);
    // Inline function 'kotlin.UInt.xor' call
    var other = this.a5o_1;
    // Inline function 'kotlin.UInt.toInt' call
    var this_1 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0) ^ _UInt___get_data__impl__f0vqqw(other));
    result = tmp + _UInt___get_data__impl__f0vqqw(this_1) | 0;
    var tmp_0 = imul(result, PRIME);
    // Inline function 'kotlin.UInt.shr' call
    var this_2 = this.b5o_1;
    var tmp0_0 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_2) >>> 16 | 0);
    // Inline function 'kotlin.UInt.xor' call
    var other_0 = this.b5o_1;
    // Inline function 'kotlin.UInt.toInt' call
    var this_3 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(tmp0_0) ^ _UInt___get_data__impl__f0vqqw(other_0));
    result = tmp_0 + _UInt___get_data__impl__f0vqqw(this_3) | 0;
    return result;
  };
  var FontHinting_NONE_instance;
  var FontHinting_SLIGHT_instance;
  var FontHinting_NORMAL_instance;
  var FontHinting_FULL_instance;
  var FontHinting_entriesInitialized;
  function FontHinting_initEntries() {
    if (FontHinting_entriesInitialized)
      return Unit_instance;
    FontHinting_entriesInitialized = true;
    FontHinting_NONE_instance = new FontHinting('NONE', 0);
    FontHinting_SLIGHT_instance = new FontHinting('SLIGHT', 1);
    FontHinting_NORMAL_instance = new FontHinting('NORMAL', 2);
    FontHinting_FULL_instance = new FontHinting('FULL', 3);
  }
  function FontHinting(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function FontHinting_NONE_getInstance() {
    FontHinting_initEntries();
    return FontHinting_NONE_instance;
  }
  function FontHinting_SLIGHT_getInstance() {
    FontHinting_initEntries();
    return FontHinting_SLIGHT_instance;
  }
  function FontHinting_NORMAL_getInstance() {
    FontHinting_initEntries();
    return FontHinting_NORMAL_instance;
  }
  function FontHinting_FULL_getInstance() {
    FontHinting_initEntries();
    return FontHinting_FULL_instance;
  }
  function Companion_14() {
  }
  var Companion_instance_14;
  function Companion_getInstance_14() {
    return Companion_instance_14;
  }
  function FontMetrics(top, ascent, descent, bottom, leading, avgCharWidth, maxCharWidth, xMin, xMax, xHeight, capHeight, underlineThickness, underlinePosition, strikeoutThickness, strikeoutPosition) {
    this.e5o_1 = top;
    this.f5o_1 = ascent;
    this.g5o_1 = descent;
    this.h5o_1 = bottom;
    this.i5o_1 = leading;
    this.j5o_1 = avgCharWidth;
    this.k5o_1 = maxCharWidth;
    this.l5o_1 = xMin;
    this.m5o_1 = xMax;
    this.n5o_1 = xHeight;
    this.o5o_1 = capHeight;
    this.p5o_1 = underlineThickness;
    this.q5o_1 = underlinePosition;
    this.r5o_1 = strikeoutThickness;
    this.s5o_1 = strikeoutPosition;
  }
  protoOf(FontMetrics).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    if (!(compareTo(this.e5o_1, other.e5o_1) === 0))
      return false;
    if (!(compareTo(this.f5o_1, other.f5o_1) === 0))
      return false;
    if (!(compareTo(this.g5o_1, other.g5o_1) === 0))
      return false;
    if (!(compareTo(this.h5o_1, other.h5o_1) === 0))
      return false;
    if (!(compareTo(this.i5o_1, other.i5o_1) === 0))
      return false;
    if (!(compareTo(this.j5o_1, other.j5o_1) === 0))
      return false;
    if (!(compareTo(this.k5o_1, other.k5o_1) === 0))
      return false;
    if (!(compareTo(this.l5o_1, other.l5o_1) === 0))
      return false;
    if (!(compareTo(this.m5o_1, other.m5o_1) === 0))
      return false;
    if (!(compareTo(this.n5o_1, other.n5o_1) === 0))
      return false;
    if (!(compareTo(this.o5o_1, other.o5o_1) === 0))
      return false;
    if (this.p5o_1 == null ? !(other.p5o_1 == null) : !(this.p5o_1 == other.p5o_1))
      return false;
    if (this.q5o_1 == null ? !(other.q5o_1 == null) : !(this.q5o_1 == other.q5o_1))
      return false;
    if (this.r5o_1 == null ? !(other.r5o_1 == null) : !(this.r5o_1 == other.r5o_1))
      return false;
    return !(this.s5o_1 == null ? !(other.s5o_1 == null) : !(this.s5o_1 == other.s5o_1));
  };
  protoOf(FontMetrics).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + toBits(this.e5o_1) | 0;
    result = imul(result, PRIME) + toBits(this.f5o_1) | 0;
    result = imul(result, PRIME) + toBits(this.g5o_1) | 0;
    result = imul(result, PRIME) + toBits(this.h5o_1) | 0;
    result = imul(result, PRIME) + toBits(this.i5o_1) | 0;
    result = imul(result, PRIME) + toBits(this.j5o_1) | 0;
    result = imul(result, PRIME) + toBits(this.k5o_1) | 0;
    result = imul(result, PRIME) + toBits(this.l5o_1) | 0;
    result = imul(result, PRIME) + toBits(this.m5o_1) | 0;
    result = imul(result, PRIME) + toBits(this.n5o_1) | 0;
    result = imul(result, PRIME) + toBits(this.o5o_1) | 0;
    var tmp = imul(result, PRIME);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.p5o_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    var tmp_0 = imul(result, PRIME);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_0 = this.q5o_1;
    var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
    result = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    var tmp_1 = imul(result, PRIME);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_1 = this.r5o_1;
    var tmp1_elvis_lhs_1 = tmp0_safe_receiver_1 == null ? null : hashCode(tmp0_safe_receiver_1);
    result = tmp_1 + (tmp1_elvis_lhs_1 == null ? 0 : tmp1_elvis_lhs_1) | 0;
    var tmp_2 = imul(result, PRIME);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver_2 = this.s5o_1;
    var tmp1_elvis_lhs_2 = tmp0_safe_receiver_2 == null ? null : hashCode(tmp0_safe_receiver_2);
    result = tmp_2 + (tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2) | 0;
    return result;
  };
  protoOf(FontMetrics).toString = function () {
    return 'FontMetrics(_top=' + this.e5o_1 + ', _ascent=' + this.f5o_1 + ', _descent=' + this.g5o_1 + ', _bottom=' + this.h5o_1 + ', _leading=' + this.i5o_1 + ', _avgCharWidth=' + this.j5o_1 + ', _maxCharWidth=' + this.k5o_1 + ', _xMin=' + this.l5o_1 + ', _xMax=' + this.m5o_1 + ', _xHeight=' + this.n5o_1 + ', _capHeight=' + this.o5o_1 + ', _underlineThickness=' + this.p5o_1 + ', _underlinePosition=' + this.q5o_1 + ', _strikeoutThickness=' + this.r5o_1 + ', _strikeoutPosition=' + this.s5o_1 + ')';
  };
  function fromInteropPointer(_this__u8e3s4, block) {
    // Inline function 'org.jetbrains.skia.impl.withResult' call
    var result = new Float32Array(15);
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        var handle = $this$interopScope.t5o(result);
        block($this$interopScope, handle);
        $this$interopScope.u5o(handle, result);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return fromRawData(_this__u8e3s4, result);
  }
  function fromRawData(_this__u8e3s4, rawData) {
    var tmp = rawData[0];
    var tmp_0 = rawData[1];
    var tmp_1 = rawData[2];
    var tmp_2 = rawData[3];
    var tmp_3 = rawData[4];
    var tmp_4 = rawData[5];
    var tmp_5 = rawData[6];
    var tmp_6 = rawData[7];
    var tmp_7 = rawData[8];
    var tmp_8 = rawData[9];
    var tmp_9 = rawData[10];
    // Inline function 'org.jetbrains.skia.asNumberOrNull' call
    var this_0 = rawData[11];
    var tmp_10 = isNaN_0(this_0) ? null : this_0;
    // Inline function 'org.jetbrains.skia.asNumberOrNull' call
    var this_1 = rawData[12];
    var tmp_11 = isNaN_0(this_1) ? null : this_1;
    // Inline function 'org.jetbrains.skia.asNumberOrNull' call
    var this_2 = rawData[13];
    var tmp_12 = isNaN_0(this_2) ? null : this_2;
    // Inline function 'org.jetbrains.skia.asNumberOrNull' call
    var this_3 = rawData[14];
    var tmp$ret$3 = isNaN_0(this_3) ? null : this_3;
    return new FontMetrics(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp$ret$3);
  }
  function Companion_15() {
    Companion_instance_15 = this;
    Companion_instance_62.q5h();
    this.v5o_1 = FontMgr_init_$Create$(org_jetbrains_skia_FontMgr__1nDefault(), false);
  }
  var Companion_instance_15;
  function Companion_getInstance_15() {
    if (Companion_instance_15 == null)
      new Companion_15();
    return Companion_instance_15;
  }
  function FontMgr_init_$Init$(ptr, $this) {
    RefCnt_init_$Init$(ptr, $this);
    FontMgr.call($this);
    return $this;
  }
  function FontMgr_init_$Init$_0(ptr, allowClose, $this) {
    RefCnt_init_$Init$_0(ptr, allowClose, $this);
    FontMgr.call($this);
    return $this;
  }
  function FontMgr_init_$Create$(ptr, allowClose) {
    return FontMgr_init_$Init$_0(ptr, allowClose, objectCreate(protoOf(FontMgr)));
  }
  protoOf(FontMgr).y5o = function (data, ttcIndex) {
    var tmp;
    try {
      Stats_instance.k5h();
      var ptr = org_jetbrains_skia_FontMgr__1nMakeFromData(this.n5h_1, getPtr(data), ttcIndex);
      tmp = ptr === Companion_instance_63.s5h() ? null : new Typeface(ptr);
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(data);
    }
    return tmp;
  };
  protoOf(FontMgr).z5o = function (data, ttcIndex, $super) {
    ttcIndex = ttcIndex === VOID ? 0 : ttcIndex;
    return $super === VOID ? this.y5o(data, ttcIndex) : $super.y5o.call(this, data, ttcIndex);
  };
  protoOf(FontMgr).a5p = function (name, style) {
    var tmp;
    try {
      Stats_instance.k5h();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          tmp$ret$0 = org_jetbrains_skia_FontMgr__1nLegacyMakeTypeface(this.n5h_1, $this$interopScope.y5i(name), style.b5p_1);
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
      var ptr = tmp$ret$0;
      tmp = ptr === Companion_instance_63.s5h() ? null : new Typeface(ptr);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  function FontMgr() {
    Companion_getInstance_15();
  }
  function FontMgrWithFallback(fallbackProvider) {
    FontMgr_init_$Init$(org_jetbrains_skia_FontMgrWithFallback__1nDefaultWithFallbackFontProvider(fallbackProvider.n5h_1), this);
  }
  var FontSlant_UPRIGHT_instance;
  var FontSlant_ITALIC_instance;
  var FontSlant_OBLIQUE_instance;
  function values_3() {
    return [FontSlant_UPRIGHT_getInstance(), FontSlant_ITALIC_getInstance(), FontSlant_OBLIQUE_getInstance()];
  }
  function get_entries_3() {
    if ($ENTRIES_3 == null)
      $ENTRIES_3 = enumEntries(values_3());
    return $ENTRIES_3;
  }
  var FontSlant_entriesInitialized;
  function FontSlant_initEntries() {
    if (FontSlant_entriesInitialized)
      return Unit_instance;
    FontSlant_entriesInitialized = true;
    FontSlant_UPRIGHT_instance = new FontSlant('UPRIGHT', 0);
    FontSlant_ITALIC_instance = new FontSlant('ITALIC', 1);
    FontSlant_OBLIQUE_instance = new FontSlant('OBLIQUE', 2);
  }
  var $ENTRIES_3;
  function FontSlant(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function FontSlant_UPRIGHT_getInstance() {
    FontSlant_initEntries();
    return FontSlant_UPRIGHT_instance;
  }
  function FontSlant_ITALIC_getInstance() {
    FontSlant_initEntries();
    return FontSlant_ITALIC_instance;
  }
  function FontSlant_OBLIQUE_getInstance() {
    FontSlant_initEntries();
    return FontSlant_OBLIQUE_instance;
  }
  function FontStyle_init_$Init$(weight, width, slant, $this) {
    FontStyle.call($this);
    $this.b5p_1 = weight & 65535 | (width & 255) << 16 | slant.a1_1 << 24;
    return $this;
  }
  function FontStyle_init_$Create$(weight, width, slant) {
    return FontStyle_init_$Init$(weight, width, slant, objectCreate(protoOf(FontStyle)));
  }
  function FontStyle_init_$Init$_0(value, $this) {
    FontStyle.call($this);
    $this.b5p_1 = value;
    return $this;
  }
  function FontStyle_init_$Create$_0(value) {
    return FontStyle_init_$Init$_0(value, objectCreate(protoOf(FontStyle)));
  }
  function Companion_16() {
    Companion_instance_16 = this;
    this.c5p_1 = FontStyle_init_$Create$(400, 5, FontSlant_UPRIGHT_getInstance());
    this.d5p_1 = FontStyle_init_$Create$(700, 5, FontSlant_UPRIGHT_getInstance());
    this.e5p_1 = FontStyle_init_$Create$(400, 5, FontSlant_ITALIC_getInstance());
    this.f5p_1 = FontStyle_init_$Create$(700, 5, FontSlant_ITALIC_getInstance());
  }
  var Companion_instance_16;
  function Companion_getInstance_16() {
    if (Companion_instance_16 == null)
      new Companion_16();
    return Companion_instance_16;
  }
  protoOf(FontStyle).g5p = function () {
    return this.b5p_1 & 65535;
  };
  protoOf(FontStyle).h5p = function (weight) {
    return FontStyle_init_$Create$(weight, this.h5e(), this.i5p());
  };
  protoOf(FontStyle).h5e = function () {
    return this.b5p_1 >> 16 & 255;
  };
  protoOf(FontStyle).i5p = function () {
    return get_entries_3().l1(this.b5p_1 >> 24 & 255);
  };
  protoOf(FontStyle).toString = function () {
    return 'FontStyle(weight=' + this.g5p() + ', width=' + this.h5e() + ', slant=' + this.i5p().toString() + ')';
  };
  protoOf(FontStyle).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof FontStyle))
      return false;
    return this.b5p_1 === other.b5p_1;
  };
  protoOf(FontStyle).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + this.b5p_1 | 0;
    return result;
  };
  function FontStyle() {
    Companion_getInstance_16();
  }
  function FontVariation_init_$Init$(feature, value, $this) {
    FontVariation.call($this, Companion_instance_18.m5n(feature), value);
    return $this;
  }
  function FontVariation_init_$Create$(feature, value) {
    return FontVariation_init_$Init$(feature, value, objectCreate(protoOf(FontVariation)));
  }
  function Companion_17() {
    Companion_instance_17 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.j5p_1 = Array(0);
    this.k5p_1 = compilePattern('\\s+');
    this.l5p_1 = compilePattern('([a-z0-9]{4})=(\\d+)');
    this.m5p_1 = 1;
    this.n5p_1 = 2;
  }
  var Companion_instance_17;
  function Companion_getInstance_17() {
    if (Companion_instance_17 == null)
      new Companion_17();
    return Companion_instance_17;
  }
  function FontVariation(_tag, value) {
    Companion_getInstance_17();
    this.o5p_1 = _tag;
    this.p5p_1 = value;
  }
  protoOf(FontVariation).c5o = function () {
    return Companion_instance_18.d5o(this.o5p_1);
  };
  protoOf(FontVariation).toString = function () {
    return this.c5o() + '=' + this.p5p_1;
  };
  protoOf(FontVariation).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof FontVariation))
      return false;
    if (!(this.c5o() === other.c5o()))
      return false;
    return compareTo(this.p5p_1, other.p5p_1) === 0;
  };
  protoOf(FontVariation).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + this.o5p_1 | 0;
    result = imul(result, PRIME) + toBits(this.p5p_1) | 0;
    return result;
  };
  function Companion_18() {
  }
  protoOf(Companion_18).m5n = function (name) {
    // Inline function 'kotlin.require' call
    if (!(name.length === 4)) {
      var message = "Name must be exactly 4 symbols, got: '" + name + "'";
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.code' call
    var this_0 = charCodeAt(name, 0);
    var tmp = (Char__toInt_impl_vasixd(this_0) & 255) << 24;
    // Inline function 'kotlin.code' call
    var this_1 = charCodeAt(name, 1);
    var tmp_0 = tmp | (Char__toInt_impl_vasixd(this_1) & 255) << 16;
    // Inline function 'kotlin.code' call
    var this_2 = charCodeAt(name, 2);
    var tmp_1 = tmp_0 | (Char__toInt_impl_vasixd(this_2) & 255) << 8;
    // Inline function 'kotlin.code' call
    var this_3 = charCodeAt(name, 3);
    return tmp_1 | Char__toInt_impl_vasixd(this_3) & 255;
  };
  protoOf(Companion_18).d5o = function (tag) {
    // Inline function 'kotlin.charArrayOf' call
    var tmp$ret$0 = charArrayOf([numberToChar(tag >> 24 & 255), numberToChar(tag >> 16 & 255), numberToChar(tag >> 8 & 255), numberToChar(tag & 255)]);
    return concatToString(tmp$ret$0);
  };
  var Companion_instance_18;
  function Companion_getInstance_18() {
    return Companion_instance_18;
  }
  function Companion_19() {
    Companion_instance_19 = this;
    this.q5p_1 = 1;
    this.r5p_1 = new GradientStyle(FilterTileMode_CLAMP_getInstance(), true, null);
  }
  var Companion_instance_19;
  function Companion_getInstance_19() {
    if (Companion_instance_19 == null)
      new Companion_19();
    return Companion_instance_19;
  }
  function GradientStyle(tileMode, isPremul, localMatrix) {
    Companion_getInstance_19();
    this.s5p_1 = tileMode;
    this.t5p_1 = isPremul;
    this.u5p_1 = localMatrix;
  }
  protoOf(GradientStyle).v5p = function () {
    return 0 | (this.t5p_1 ? Companion_getInstance_19().q5p_1 : 0);
  };
  protoOf(GradientStyle).w5p = function () {
    var tmp0_safe_receiver = this.u5p_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x5k_1;
  };
  protoOf(GradientStyle).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof GradientStyle))
      return false;
    if (!(this.t5p_1 === other.t5p_1))
      return false;
    if (!this.s5p_1.equals(other.s5p_1))
      return false;
    return !(this.u5p_1 == null ? !(other.u5p_1 == null) : !equals(this.u5p_1, other.u5p_1));
  };
  protoOf(GradientStyle).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + (this.t5p_1 ? 79 : 97) | 0;
    result = imul(result, PRIME) + this.s5p_1.hashCode() | 0;
    var tmp = imul(result, PRIME);
    var tmp0_safe_receiver = this.u5p_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    result = tmp + (tmp1_elvis_lhs == null ? 43 : tmp1_elvis_lhs) | 0;
    return result;
  };
  protoOf(GradientStyle).toString = function () {
    return 'GradientStyle(_tileMode=' + this.s5p_1.toString() + ', _premul=' + this.t5p_1 + ', _localMatrix=' + toString_0(this.u5p_1) + ')';
  };
  function IHasImageInfo() {
  }
  function Companion_20() {
  }
  var Companion_instance_20;
  function Companion_getInstance_20() {
    return Companion_instance_20;
  }
  function IRange(start, end) {
    this.x5p_1 = start;
    this.y5p_1 = end;
  }
  protoOf(IRange).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof IRange))
      return false;
    if (!(this.x5p_1 === other.x5p_1))
      return false;
    return this.y5p_1 === other.y5p_1;
  };
  protoOf(IRange).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + this.x5p_1 | 0;
    result = imul(result, PRIME) + this.y5p_1 | 0;
    return result;
  };
  protoOf(IRange).toString = function () {
    return 'IRange(_start=' + this.x5p_1 + ', _end=' + this.y5p_1 + ')';
  };
  function fromInteropPointer_0(_this__u8e3s4, block) {
    // Inline function 'org.jetbrains.skia.impl.withResult' call
    var result = new Int32Array(2);
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        var handle = $this$interopScope.a5h(result);
        block($this$interopScope, handle);
        $this$interopScope.b5h(handle, result);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    var result_0 = result;
    return new IRange(result_0[0], result_0[1]);
  }
  function Companion_21() {
  }
  var Companion_instance_21;
  function Companion_getInstance_21() {
    return Companion_instance_21;
  }
  function IRect(left, top, right, bottom) {
    this.z5p_1 = left;
    this.a5q_1 = top;
    this.b5q_1 = right;
    this.c5q_1 = bottom;
  }
  protoOf(IRect).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof IRect))
      return false;
    if (!(this.z5p_1 === other.z5p_1))
      return false;
    if (!(this.a5q_1 === other.a5q_1))
      return false;
    if (!(this.b5q_1 === other.b5q_1))
      return false;
    return this.c5q_1 === other.c5q_1;
  };
  protoOf(IRect).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + this.z5p_1 | 0;
    result = imul(result, PRIME) + this.a5q_1 | 0;
    result = imul(result, PRIME) + this.b5q_1 | 0;
    result = imul(result, PRIME) + this.c5q_1 | 0;
    return result;
  };
  protoOf(IRect).toString = function () {
    return 'IRect(_left=' + this.z5p_1 + ', _top=' + this.a5q_1 + ', _right=' + this.b5q_1 + ', _bottom=' + this.c5q_1 + ')';
  };
  function Companion_22() {
    Companion_instance_22 = this;
    Companion_instance_62.q5h();
  }
  protoOf(Companion_22).d5q = function (bitmap) {
    var tmp;
    try {
      Stats_instance.k5h();
      var ptr = org_jetbrains_skia_Image__1nMakeFromBitmap(getPtr(bitmap));
      if (ptr === Companion_instance_63.s5h())
        throw RuntimeException_init_$Create$('Failed to Image::makeFromBitmap ' + bitmap.toString());
      tmp = new Image(ptr);
    }finally {
      reachabilityBarrier(bitmap);
    }
    return tmp;
  };
  protoOf(Companion_22).e5q = function (bytes) {
    Stats_instance.k5h();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        tmp$ret$0 = org_jetbrains_skia_Image__1nMakeFromEncoded($this$interopScope.q5m(bytes), bytes.length);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    var ptr = tmp$ret$0;
    // Inline function 'kotlin.require' call
    if (!!(ptr === Companion_instance_63.s5h())) {
      var message = 'Failed to Image::makeFromEncoded';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return new Image(ptr);
  };
  var Companion_instance_22;
  function Companion_getInstance_22() {
    if (Companion_instance_22 == null)
      new Companion_22();
    return Companion_instance_22;
  }
  function Image_nGetImageInfo$ref() {
    return constructCallableReference(function (p0, p1, p2) {
      org_jetbrains_skia_Image__1nGetImageInfo(p0, p1, p2);
      return Unit_instance;
    }, 3, 0, 21, 'Image_nGetImageInfo');
  }
  function Image$_get_imageInfo_$lambda_c2a05w(this$0) {
    return function () {
      var tmp;
      if (this$0.x5h_1 == null) {
        var tmp_0 = this$0;
        var tmp_1 = Companion_getInstance_23();
        var tmp_2 = this$0.n5h_1;
        tmp_0.x5h_1 = tmp_1.g5i(tmp_2, Image_nGetImageInfo$ref());
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function Image(ptr) {
    Companion_getInstance_22();
    RefCnt_init_$Init$(ptr, this);
    this.x5h_1 = null;
  }
  protoOf(Image).y5h = function () {
    var tmp;
    try {
      if (this.x5h_1 == null) {
        commonSynchronized(this, Image$_get_imageInfo_$lambda_c2a05w(this));
      }
      tmp = ensureNotNull(this.x5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Image).f5q = function (format, quality) {
    var tmp;
    try {
      Stats_instance.k5h();
      var ptr = org_jetbrains_skia_Image__1nEncodeToData(this.n5h_1, format.a1_1, quality);
      tmp = ptr === Companion_instance_63.s5h() ? null : new Data(ptr);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Image).g5q = function (format, quality, $super) {
    format = format === VOID ? EncodedImageFormat_PNG_getInstance() : format;
    quality = quality === VOID ? 100 : quality;
    return $super === VOID ? this.f5q(format, quality) : $super.f5q.call(this, format, quality);
  };
  protoOf(Image).d5i = function (dst) {
    return this.h5q(null, dst, 0, 0, false);
  };
  protoOf(Image).h5q = function (context, dst, srcX, srcY, cache) {
    var tmp;
    try {
      tmp = org_jetbrains_skia_Image__1nReadPixelsBitmap(this.n5h_1, getPtr(context), getPtr(dst), srcX, srcY, cache);
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(context);
      reachabilityBarrier(dst);
    }
    return tmp;
  };
  function ImageInfo_init_$Init$(width, height, colorType, alphaType, colorSpace, $this) {
    ImageInfo.call($this, new ColorInfo(colorType, alphaType, colorSpace), width, height);
    return $this;
  }
  function ImageInfo_init_$Init$_0(width, height, colorType, alphaType, colorSpace, $this) {
    ImageInfo_init_$Init$(width, height, get_entries_2().l1(colorType), get_entries_1().l1(alphaType), colorSpace === Companion_instance_63.s5h() ? null : ColorSpace_init_$Create$(colorSpace), $this);
    return $this;
  }
  function ImageInfo_init_$Create$(width, height, colorType, alphaType, colorSpace) {
    return ImageInfo_init_$Init$_0(width, height, colorType, alphaType, colorSpace, objectCreate(protoOf(ImageInfo)));
  }
  function Companion_23() {
    Companion_instance_23 = this;
    this.f5i_1 = new ImageInfo(Companion_getInstance_7().d5m_1, 0, 0);
  }
  protoOf(Companion_23).t5i = function (width, height, alphaType) {
    return new ImageInfo(new ColorInfo(Companion_getInstance_9().m5m_1, alphaType, null), width, height);
  };
  protoOf(Companion_23).g5i = function (_ptr, _nGetImageInfo) {
    Stats_instance.k5h();
    var colorSpacePtr = null;
    // Inline function 'org.jetbrains.skia.impl.withResult' call
    var result = new Int32Array(4);
    $l$block_0: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        var handle = $this$interopScope.a5h(result);
        // Inline function 'org.jetbrains.skia.impl.withResult' call
        var result_0 = new NativePointerArray(1);
        $l$block: {
          // Inline function 'org.jetbrains.skia.impl.interopScope' call
          try {
            var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
            access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 + 1 | 0);
            var $this$interopScope_0 = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
            var handle_0 = $this$interopScope_0.i5q(result_0);
            _nGetImageInfo(_ptr, handle, handle_0);
            $this$interopScope_0.j5q(handle_0, result_0);
            break $l$block;
          }finally {
            var _unary__edvuaz_1 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
            access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_1 - 1 | 0);
            if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
              access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
            }
          }
        }
        colorSpacePtr = result_0.l1(0);
        $this$interopScope.b5h(handle, result);
        break $l$block_0;
      }finally {
        var _unary__edvuaz_2 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_2 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    // Inline function 'kotlin.let' call
    return ImageInfo_init_$Create$(result[0], result[1], result[2], result[3], ensureNotNull(colorSpacePtr));
  };
  var Companion_instance_23;
  function Companion_getInstance_23() {
    if (Companion_instance_23 == null)
      new Companion_23();
    return Companion_instance_23;
  }
  function ImageInfo(colorInfo, width, height) {
    Companion_getInstance_23();
    this.l5i_1 = colorInfo;
    this.m5i_1 = width;
    this.n5i_1 = height;
  }
  protoOf(ImageInfo).r5i = function () {
    return imul(this.m5i_1, this.h5m());
  };
  protoOf(ImageInfo).h5m = function () {
    return this.l5i_1.h5m();
  };
  protoOf(ImageInfo).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof ImageInfo))
      return false;
    if (!(this.m5i_1 === other.m5i_1))
      return false;
    if (!(this.n5i_1 === other.n5i_1))
      return false;
    return this.l5i_1.equals(other.l5i_1);
  };
  protoOf(ImageInfo).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + this.m5i_1 | 0;
    result = imul(result, PRIME) + this.n5i_1 | 0;
    result = imul(result, PRIME) + this.l5i_1.hashCode() | 0;
    return result;
  };
  protoOf(ImageInfo).toString = function () {
    return 'ImageInfo(_colorInfo=' + this.l5i_1.toString() + ', _width=' + this.m5i_1 + ', _height=' + this.n5i_1 + ')';
  };
  function Companion_24() {
    Companion_instance_24 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_24;
  function Companion_getInstance_24() {
    if (Companion_instance_24 == null)
      new Companion_24();
    return Companion_instance_24;
  }
  function ManagedString_init_$Init$(s, $this) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        tmp$ret$0 = org_jetbrains_skia_ManagedString__1nMake($this$interopScope.y5i(s));
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    ManagedString.call($this, tmp$ret$0);
    Stats_instance.k5h();
    return $this;
  }
  function ManagedString_init_$Create$(s) {
    return ManagedString_init_$Init$(s, objectCreate(protoOf(ManagedString)));
  }
  function _FinalizerHolder_8() {
    _FinalizerHolder_instance_8 = this;
    this.l5q_1 = org_jetbrains_skia_ManagedString__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_8;
  function _FinalizerHolder_getInstance_8() {
    if (_FinalizerHolder_instance_8 == null)
      new _FinalizerHolder_8();
    return _FinalizerHolder_instance_8;
  }
  function ManagedString(ptr, managed) {
    Companion_getInstance_24();
    managed = managed === VOID ? true : managed;
    Managed.call(this, ptr, _FinalizerHolder_getInstance_8().l5q_1, managed);
  }
  protoOf(ManagedString).toString = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      var size = org_jetbrains_skia_ManagedString__nStringSize(this.n5h_1);
      // Inline function 'org.jetbrains.skia.impl.withResult' call
      var result = new Int8Array(size);
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          var handle = $this$interopScope.y5m(result);
          org_jetbrains_skia_ManagedString__nStringData(this.n5h_1, handle, size);
          $this$interopScope.z5m(handle, result);
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
      tmp = decodeToString(result);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(ManagedString).o5q = function (s) {
    Stats_instance.k5h();
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        org_jetbrains_skia_ManagedString__1nAppend(this.n5h_1, $this$interopScope.y5i(s));
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return this;
  };
  function Companion_25() {
    Companion_instance_25 = this;
    this.p5q_1 = this.q5q(0.0, 0.0);
  }
  protoOf(Companion_25).q5q = function (dx, dy) {
    return new Matrix33(new Float32Array([1.0, 0.0, dx, 0.0, 1.0, dy, 0.0, 0.0, 1.0]));
  };
  var Companion_instance_25;
  function Companion_getInstance_25() {
    if (Companion_instance_25 == null)
      new Companion_25();
    return Companion_instance_25;
  }
  function Matrix33(mat) {
    Companion_getInstance_25();
    // Inline function 'kotlin.require' call
    if (!(mat.length === 9)) {
      var message = 'Expected 9 elements, got ' + mat.length;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    this.x5k_1 = mat;
  }
  protoOf(Matrix33).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Matrix33))
      return false;
    return contentEquals(this.x5k_1, other.x5k_1);
  };
  protoOf(Matrix33).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + contentHashCode(this.x5k_1) | 0;
    return result;
  };
  protoOf(Matrix33).toString = function () {
    return 'Matrix33(_mat=' + toString(this.x5k_1) + ')';
  };
  function Companion_26() {
    Companion_instance_26 = this;
    this.r5q_1 = new Matrix44(new Float32Array([1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0]));
  }
  var Companion_instance_26;
  function Companion_getInstance_26() {
    if (Companion_instance_26 == null)
      new Companion_26();
    return Companion_instance_26;
  }
  function Matrix44(mat) {
    Companion_getInstance_26();
    // Inline function 'kotlin.require' call
    if (!(mat.length === 16)) {
      var message = 'Expected 16 elements, got ' + mat.length;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    this.f5l_1 = mat;
  }
  protoOf(Matrix44).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Matrix44))
      return false;
    return contentEquals(this.f5l_1, other.f5l_1);
  };
  protoOf(Matrix44).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + contentHashCode(this.f5l_1) | 0;
    return result;
  };
  protoOf(Matrix44).toString = function () {
    return 'Matrix44(_mat=' + toString(this.f5l_1) + ')';
  };
  var MipmapMode_NONE_instance;
  var MipmapMode_NEAREST_instance;
  var MipmapMode_LINEAR_instance;
  var MipmapMode_entriesInitialized;
  function MipmapMode_initEntries() {
    if (MipmapMode_entriesInitialized)
      return Unit_instance;
    MipmapMode_entriesInitialized = true;
    MipmapMode_NONE_instance = new MipmapMode('NONE', 0);
    MipmapMode_NEAREST_instance = new MipmapMode('NEAREST', 1);
    MipmapMode_LINEAR_instance = new MipmapMode('LINEAR', 2);
  }
  function MipmapMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function MipmapMode_NONE_getInstance() {
    MipmapMode_initEntries();
    return MipmapMode_NONE_instance;
  }
  function MipmapMode_NEAREST_getInstance() {
    MipmapMode_initEntries();
    return MipmapMode_NEAREST_instance;
  }
  function Companion_27() {
    Companion_instance_27 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_27;
  function Companion_getInstance_27() {
    if (Companion_instance_27 == null)
      new Companion_27();
    return Companion_instance_27;
  }
  function _FinalizerHolder_9() {
    _FinalizerHolder_instance_9 = this;
    this.s5q_1 = org_jetbrains_skia_Paint__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_9;
  function _FinalizerHolder_getInstance_9() {
    if (_FinalizerHolder_instance_9 == null)
      new _FinalizerHolder_9();
    return _FinalizerHolder_instance_9;
  }
  function Paint_init_$Init$($this) {
    Managed.call($this, org_jetbrains_skia_Paint__1nMake(), _FinalizerHolder_getInstance_9().s5q_1);
    Paint.call($this);
    Stats_instance.k5h();
    return $this;
  }
  function Paint_init_$Create$() {
    return Paint_init_$Init$(objectCreate(protoOf(Paint)));
  }
  protoOf(Paint).o5h = function (other) {
    var tmp;
    try {
      tmp = org_jetbrains_skia_Paint__1nEquals(this.n5h_1, getPtr(other));
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(other);
    }
    return tmp;
  };
  protoOf(Paint).v5q = function () {
    Stats_instance.k5h();
    org_jetbrains_skia_Paint__1nReset(this.n5h_1);
    return this;
  };
  protoOf(Paint).w5q = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_Paint__1nSetAntiAlias(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).x5q = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_Paint__1nSetMode(this.n5h_1, value.a1_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).y5q = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = get_entries_4().l1(org_jetbrains_skia_Paint__1nGetMode(this.n5h_1));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).z5q = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_Paint__1nSetColor(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).a5r = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_Paint__1nGetColor(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).b5r = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      // Inline function 'org.jetbrains.skia.impl.withResult' call
      var result = new Float32Array(4);
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          var handle = $this$interopScope.t5o(result);
          org_jetbrains_skia_Paint__1nGetColor4f(this.n5h_1, handle);
          $this$interopScope.u5o(handle, result);
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
      tmp = Color4f_init_$Create$(result);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).c5r = function (color, colorSpace) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_Paint__1nSetColor4f(this.n5h_1, color.r5l_1, color.s5l_1, color.t5l_1, color.u5l_1, getPtr(colorSpace));
      tmp = this;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(colorSpace);
    }
    return tmp;
  };
  protoOf(Paint).d5r = function (a) {
    this.c5r(this.b5r().v5l(a), null);
    return this;
  };
  protoOf(Paint).e5r = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_Paint__1nSetStrokeWidth(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).f5r = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_Paint__1nGetStrokeWidth(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).g5r = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_Paint__1nSetStrokeMiter(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).h5r = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_Paint__1nSetStrokeCap(this.n5h_1, value.a1_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).i5r = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_Paint__1nSetStrokeJoin(this.n5h_1, value.a1_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).j5r = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_Paint__1nSetShader(this.n5h_1, getPtr(value));
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(value);
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).k5r = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      var shaderPtr = org_jetbrains_skia_Paint__1nGetShader(this.n5h_1);
      tmp = shaderPtr === Companion_instance_63.s5h() ? null : new Shader(shaderPtr);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).l5r = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_Paint__1nSetColorFilter(this.n5h_1, getPtr(value));
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(value);
    }
    return tmp;
  };
  protoOf(Paint).m5r = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_Paint__1nSetBlendMode(this.n5h_1, value.a1_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).n5r = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = get_entries_0().l1(org_jetbrains_skia_Paint__1nGetBlendMode(this.n5h_1));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paint).o5r = function () {
    return this.n5r().equals(BlendMode_SRC_OVER_getInstance());
  };
  protoOf(Paint).p5r = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_Paint__1nSetPathEffect(this.n5h_1, getPtr(value));
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(value);
    }
    return tmp;
  };
  protoOf(Paint).q5r = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_Paint__1nSetImageFilter(this.n5h_1, getPtr(value));
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(value);
    }
    return tmp;
  };
  function Paint() {
    Companion_getInstance_27();
  }
  var PaintMode_FILL_instance;
  var PaintMode_STROKE_instance;
  var PaintMode_STROKE_AND_FILL_instance;
  function values_4() {
    return [PaintMode_FILL_getInstance(), PaintMode_STROKE_getInstance(), PaintMode_STROKE_AND_FILL_getInstance()];
  }
  function get_entries_4() {
    if ($ENTRIES_4 == null)
      $ENTRIES_4 = enumEntries(values_4());
    return $ENTRIES_4;
  }
  var PaintMode_entriesInitialized;
  function PaintMode_initEntries() {
    if (PaintMode_entriesInitialized)
      return Unit_instance;
    PaintMode_entriesInitialized = true;
    PaintMode_FILL_instance = new PaintMode('FILL', 0);
    PaintMode_STROKE_instance = new PaintMode('STROKE', 1);
    PaintMode_STROKE_AND_FILL_instance = new PaintMode('STROKE_AND_FILL', 2);
  }
  var $ENTRIES_4;
  function PaintMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PaintMode_FILL_getInstance() {
    PaintMode_initEntries();
    return PaintMode_FILL_instance;
  }
  function PaintMode_STROKE_getInstance() {
    PaintMode_initEntries();
    return PaintMode_STROKE_instance;
  }
  function PaintMode_STROKE_AND_FILL_getInstance() {
    PaintMode_initEntries();
    return PaintMode_STROKE_AND_FILL_instance;
  }
  var PaintStrokeCap_BUTT_instance;
  var PaintStrokeCap_ROUND_instance;
  var PaintStrokeCap_SQUARE_instance;
  var PaintStrokeCap_entriesInitialized;
  function PaintStrokeCap_initEntries() {
    if (PaintStrokeCap_entriesInitialized)
      return Unit_instance;
    PaintStrokeCap_entriesInitialized = true;
    PaintStrokeCap_BUTT_instance = new PaintStrokeCap('BUTT', 0);
    PaintStrokeCap_ROUND_instance = new PaintStrokeCap('ROUND', 1);
    PaintStrokeCap_SQUARE_instance = new PaintStrokeCap('SQUARE', 2);
  }
  function PaintStrokeCap(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PaintStrokeCap_BUTT_getInstance() {
    PaintStrokeCap_initEntries();
    return PaintStrokeCap_BUTT_instance;
  }
  function PaintStrokeCap_ROUND_getInstance() {
    PaintStrokeCap_initEntries();
    return PaintStrokeCap_ROUND_instance;
  }
  function PaintStrokeCap_SQUARE_getInstance() {
    PaintStrokeCap_initEntries();
    return PaintStrokeCap_SQUARE_instance;
  }
  var PaintStrokeJoin_MITER_instance;
  var PaintStrokeJoin_ROUND_instance;
  var PaintStrokeJoin_BEVEL_instance;
  var PaintStrokeJoin_entriesInitialized;
  function PaintStrokeJoin_initEntries() {
    if (PaintStrokeJoin_entriesInitialized)
      return Unit_instance;
    PaintStrokeJoin_entriesInitialized = true;
    PaintStrokeJoin_MITER_instance = new PaintStrokeJoin('MITER', 0);
    PaintStrokeJoin_ROUND_instance = new PaintStrokeJoin('ROUND', 1);
    PaintStrokeJoin_BEVEL_instance = new PaintStrokeJoin('BEVEL', 2);
  }
  function PaintStrokeJoin(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PaintStrokeJoin_MITER_getInstance() {
    PaintStrokeJoin_initEntries();
    return PaintStrokeJoin_MITER_instance;
  }
  function PaintStrokeJoin_ROUND_getInstance() {
    PaintStrokeJoin_initEntries();
    return PaintStrokeJoin_ROUND_instance;
  }
  function PaintStrokeJoin_BEVEL_getInstance() {
    PaintStrokeJoin_initEntries();
    return PaintStrokeJoin_BEVEL_instance;
  }
  function Companion_28() {
    Companion_instance_28 = this;
    Companion_instance_62.q5h();
  }
  protoOf(Companion_28).r5r = function (one, two, op) {
    var tmp;
    try {
      Stats_instance.k5h();
      var ptr = org_jetbrains_skia_Path__1nMakeCombining(getPtr(one), getPtr(two), op.a1_1);
      tmp = ptr === Companion_instance_63.s5h() ? null : new Path(ptr);
    }finally {
      reachabilityBarrier(one);
      reachabilityBarrier(two);
    }
    return tmp;
  };
  var Companion_instance_28;
  function Companion_getInstance_28() {
    if (Companion_instance_28 == null)
      new Companion_28();
    return Companion_instance_28;
  }
  function _FinalizerHolder_10() {
    _FinalizerHolder_instance_10 = this;
    this.s5r_1 = org_jetbrains_skia_Path__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_10;
  function _FinalizerHolder_getInstance_10() {
    if (_FinalizerHolder_instance_10 == null)
      new _FinalizerHolder_10();
    return _FinalizerHolder_instance_10;
  }
  function Path_init_$Init$($this) {
    Path.call($this, org_jetbrains_skia_Path__1nMake());
    Stats_instance.k5h();
    return $this;
  }
  function Path_init_$Create$() {
    return Path_init_$Init$(objectCreate(protoOf(Path)));
  }
  function Path$_get_bounds_$lambda_qr8ora(this$0) {
    return function ($this$fromInteropPointer, it) {
      org_jetbrains_skia_Path__1nGetBounds(this$0.n5h_1, it);
      return Unit_instance;
    };
  }
  function Path(ptr) {
    Companion_getInstance_28();
    Managed.call(this, ptr, _FinalizerHolder_getInstance_10().s5r_1);
  }
  protoOf(Path).o5h = function (other) {
    var tmp;
    try {
      tmp = org_jetbrains_skia_Path__1nEquals(this.n5h_1, getPtr(other));
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(other);
    }
    return tmp;
  };
  protoOf(Path).v5r = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = get_entries_5().l1(org_jetbrains_skia_Path__1nGetFillMode(this.n5h_1));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Path).oy = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_Path__1nIsEmpty(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Path).w5r = function (other) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_Path__1nSwap(this.n5h_1, getPtr(other));
      tmp = this;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(other);
    }
    return tmp;
  };
  protoOf(Path).x5r = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      var tmp_0 = Companion_instance_35;
      tmp = tmp_0.y5r(Path$_get_bounds_$lambda_qr8ora(this));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Path).t = function () {
    return this.z5r(false);
  };
  protoOf(Path).z5r = function (forceClose) {
    return Companion_getInstance_31().a5s(this, forceClose);
  };
  protoOf(Path).b5s = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_Path__1nGetGenerationId(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  var PathAddMode_APPEND_instance;
  var PathAddMode_EXTEND_instance;
  var PathAddMode_entriesInitialized;
  function PathAddMode_initEntries() {
    if (PathAddMode_entriesInitialized)
      return Unit_instance;
    PathAddMode_entriesInitialized = true;
    PathAddMode_APPEND_instance = new PathAddMode('APPEND', 0);
    PathAddMode_EXTEND_instance = new PathAddMode('EXTEND', 1);
  }
  function PathAddMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PathAddMode_APPEND_getInstance() {
    PathAddMode_initEntries();
    return PathAddMode_APPEND_instance;
  }
  function Companion_29() {
    Companion_instance_29 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_29;
  function Companion_getInstance_29() {
    if (Companion_instance_29 == null)
      new Companion_29();
    return Companion_instance_29;
  }
  function _FinalizerHolder_11() {
    _FinalizerHolder_instance_11 = this;
    this.c5s_1 = org_jetbrains_skia_PathBuilder__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_11;
  function _FinalizerHolder_getInstance_11() {
    if (_FinalizerHolder_instance_11 == null)
      new _FinalizerHolder_11();
    return _FinalizerHolder_instance_11;
  }
  function PathBuilder_init_$Init$($this) {
    PathBuilder.call($this, org_jetbrains_skia_PathBuilder__1nMake());
    return $this;
  }
  function PathBuilder_init_$Create$() {
    return PathBuilder_init_$Init$(objectCreate(protoOf(PathBuilder)));
  }
  function PathBuilder_init_$Init$_0(path, $this) {
    // Inline function 'kotlin.also' call
    var this_0 = org_jetbrains_skia_PathBuilder__1nMakeFromPath(getPtr(path));
    reachabilityBarrier(path);
    PathBuilder.call($this, this_0);
    return $this;
  }
  function PathBuilder_init_$Create$_0(path) {
    return PathBuilder_init_$Init$_0(path, objectCreate(protoOf(PathBuilder)));
  }
  function PathBuilder(ptr) {
    Companion_getInstance_29();
    Managed.call(this, ptr, _FinalizerHolder_getInstance_11().c5s_1);
  }
  protoOf(PathBuilder).f5s = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = new Path(org_jetbrains_skia_PathBuilder__1nSnapshot(this.n5h_1));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).g5s = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = new Path(org_jetbrains_skia_PathBuilder__1nDetach(this.n5h_1));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).h5s = function (fillType) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathBuilder__1nSetFillType(this.n5h_1, fillType.a1_1);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).v5q = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathBuilder__1nReset(this.n5h_1);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).i5s = function (x, y) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathBuilder__1nMoveTo(this.n5h_1, x, y);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).j5s = function (dx, dy) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathBuilder__1nRMoveTo(this.n5h_1, dx, dy);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).k5s = function (x, y) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathBuilder__1nLineTo(this.n5h_1, x, y);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).l5s = function (dx, dy) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathBuilder__1nRLineTo(this.n5h_1, dx, dy);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).m5s = function (x1, y1, x2, y2) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathBuilder__1nQuadTo(this.n5h_1, x1, y1, x2, y2);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).n5s = function (dx1, dy1, dx2, dy2) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathBuilder__1nRQuadTo(this.n5h_1, dx1, dy1, dx2, dy2);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).o5s = function (x1, y1, x2, y2, x3, y3) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathBuilder__1nCubicTo(this.n5h_1, x1, y1, x2, y2, x3, y3);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).p5s = function (dx1, dy1, dx2, dy2, dx3, dy3) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathBuilder__1nRCubicTo(this.n5h_1, dx1, dy1, dx2, dy2, dx3, dy3);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).q5s = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathBuilder__1nClosePath(this.n5h_1);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).r5s = function (left, top, right, bottom, dir, start) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathBuilder__1nAddRect(this.n5h_1, left, top, right, bottom, dir.a1_1, start);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).s5s = function (left, top, right, bottom, dir, start, $super) {
    dir = dir === VOID ? PathDirection_CLOCKWISE_getInstance() : dir;
    start = start === VOID ? 0 : start;
    return $super === VOID ? this.r5s(left, top, right, bottom, dir, start) : $super.r5s.call(this, left, top, right, bottom, dir, start);
  };
  protoOf(PathBuilder).t5s = function (left, top, right, bottom, radii, dir, start) {
    var tmp;
    try {
      Stats_instance.k5h();
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          org_jetbrains_skia_PathBuilder__1nAddRRect(this.n5h_1, left, top, right, bottom, $this$interopScope.h5k(radii), radii.length, dir.a1_1, start);
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
      tmp = this;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).u5s = function (left, top, right, bottom, radii, dir, start, $super) {
    dir = dir === VOID ? PathDirection_CLOCKWISE_getInstance() : dir;
    start = start === VOID ? 6 : start;
    return $super === VOID ? this.t5s(left, top, right, bottom, radii, dir, start) : $super.t5s.call(this, left, top, right, bottom, radii, dir, start);
  };
  protoOf(PathBuilder).v5s = function (src, dx, dy, mode) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathBuilder__1nAddPathOffset(this.n5h_1, getPtr(src), dx, dy, mode.a1_1);
      tmp = this;
    }finally {
      reachabilityBarrier(src);
    }
    return tmp;
  };
  protoOf(PathBuilder).w5s = function (src, dx, dy, mode, $super) {
    mode = mode === VOID ? PathAddMode_APPEND_getInstance() : mode;
    return $super === VOID ? this.v5s(src, dx, dy, mode) : $super.v5s.call(this, src, dx, dy, mode);
  };
  protoOf(PathBuilder).x5s = function (dx, dy) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathBuilder__1nOffset(this.n5h_1, dx, dy);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathBuilder).y5s = function (matrix) {
    var tmp;
    try {
      Stats_instance.k5h();
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          org_jetbrains_skia_PathBuilder__1nTransform(this.n5h_1, $this$interopScope.h5k(matrix.x5k_1));
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
      tmp = this;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(matrix);
    }
    return tmp;
  };
  var PathDirection_CLOCKWISE_instance;
  var PathDirection_COUNTER_CLOCKWISE_instance;
  var PathDirection_entriesInitialized;
  function PathDirection_initEntries() {
    if (PathDirection_entriesInitialized)
      return Unit_instance;
    PathDirection_entriesInitialized = true;
    PathDirection_CLOCKWISE_instance = new PathDirection('CLOCKWISE', 0);
    PathDirection_COUNTER_CLOCKWISE_instance = new PathDirection('COUNTER_CLOCKWISE', 1);
  }
  function PathDirection(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PathDirection_CLOCKWISE_getInstance() {
    PathDirection_initEntries();
    return PathDirection_CLOCKWISE_instance;
  }
  function PathDirection_COUNTER_CLOCKWISE_getInstance() {
    PathDirection_initEntries();
    return PathDirection_COUNTER_CLOCKWISE_instance;
  }
  var PathFillMode_WINDING_instance;
  var PathFillMode_EVEN_ODD_instance;
  var PathFillMode_INVERSE_WINDING_instance;
  var PathFillMode_INVERSE_EVEN_ODD_instance;
  function values_5() {
    return [PathFillMode_WINDING_getInstance(), PathFillMode_EVEN_ODD_getInstance(), PathFillMode_INVERSE_WINDING_getInstance(), PathFillMode_INVERSE_EVEN_ODD_getInstance()];
  }
  function get_entries_5() {
    if ($ENTRIES_5 == null)
      $ENTRIES_5 = enumEntries(values_5());
    return $ENTRIES_5;
  }
  var PathFillMode_entriesInitialized;
  function PathFillMode_initEntries() {
    if (PathFillMode_entriesInitialized)
      return Unit_instance;
    PathFillMode_entriesInitialized = true;
    PathFillMode_WINDING_instance = new PathFillMode('WINDING', 0);
    PathFillMode_EVEN_ODD_instance = new PathFillMode('EVEN_ODD', 1);
    PathFillMode_INVERSE_WINDING_instance = new PathFillMode('INVERSE_WINDING', 2);
    PathFillMode_INVERSE_EVEN_ODD_instance = new PathFillMode('INVERSE_EVEN_ODD', 3);
  }
  var $ENTRIES_5;
  function PathFillMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PathFillMode_WINDING_getInstance() {
    PathFillMode_initEntries();
    return PathFillMode_WINDING_instance;
  }
  function PathFillMode_EVEN_ODD_getInstance() {
    PathFillMode_initEntries();
    return PathFillMode_EVEN_ODD_instance;
  }
  function PathFillMode_INVERSE_WINDING_getInstance() {
    PathFillMode_initEntries();
    return PathFillMode_INVERSE_WINDING_instance;
  }
  function PathFillMode_INVERSE_EVEN_ODD_getInstance() {
    PathFillMode_initEntries();
    return PathFillMode_INVERSE_EVEN_ODD_instance;
  }
  function Companion_30() {
    Companion_instance_30 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_30;
  function Companion_getInstance_30() {
    if (Companion_instance_30 == null)
      new Companion_30();
    return Companion_instance_30;
  }
  function PathMeasure_init_$Init$($this) {
    PathMeasure.call($this, org_jetbrains_skia_PathMeasure__1nMake());
    return $this;
  }
  function PathMeasure_init_$Create$() {
    return PathMeasure_init_$Init$(objectCreate(protoOf(PathMeasure)));
  }
  function _FinalizerHolder_12() {
    _FinalizerHolder_instance_12 = this;
    this.z5s_1 = org_jetbrains_skia_PathMeasure__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_12;
  function _FinalizerHolder_getInstance_12() {
    if (_FinalizerHolder_instance_12 == null)
      new _FinalizerHolder_12();
    return _FinalizerHolder_instance_12;
  }
  function PathMeasure(ptr) {
    Companion_getInstance_30();
    Managed.call(this, ptr, _FinalizerHolder_getInstance_12().z5s_1);
  }
  protoOf(PathMeasure).c5t = function (path, forceClosed) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_PathMeasure__1nSetPath(this.n5h_1, getPtr(path), forceClosed);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(path);
    }
    return tmp;
  };
  protoOf(PathMeasure).a = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_PathMeasure__1nGetLength(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathMeasure).d5t = function (startD, endD, dst, startWithMoveTo) {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_PathMeasure__1nGetSegment(this.n5h_1, startD, endD, getPtr(dst), startWithMoveTo);
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(dst);
    }
    return tmp;
  };
  var PathOp_DIFFERENCE_instance;
  var PathOp_INTERSECT_instance;
  var PathOp_UNION_instance;
  var PathOp_XOR_instance;
  var PathOp_REVERSE_DIFFERENCE_instance;
  var PathOp_entriesInitialized;
  function PathOp_initEntries() {
    if (PathOp_entriesInitialized)
      return Unit_instance;
    PathOp_entriesInitialized = true;
    PathOp_DIFFERENCE_instance = new PathOp('DIFFERENCE', 0);
    PathOp_INTERSECT_instance = new PathOp('INTERSECT', 1);
    PathOp_UNION_instance = new PathOp('UNION', 2);
    PathOp_XOR_instance = new PathOp('XOR', 3);
    PathOp_REVERSE_DIFFERENCE_instance = new PathOp('REVERSE_DIFFERENCE', 4);
  }
  function PathOp(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PathOp_DIFFERENCE_getInstance() {
    PathOp_initEntries();
    return PathOp_DIFFERENCE_instance;
  }
  function PathOp_INTERSECT_getInstance() {
    PathOp_initEntries();
    return PathOp_INTERSECT_instance;
  }
  function PathOp_UNION_getInstance() {
    PathOp_initEntries();
    return PathOp_UNION_instance;
  }
  function PathOp_XOR_getInstance() {
    PathOp_initEntries();
    return PathOp_XOR_instance;
  }
  function PathOp_REVERSE_DIFFERENCE_getInstance() {
    PathOp_initEntries();
    return PathOp_REVERSE_DIFFERENCE_instance;
  }
  function PathSegment_init_$Init$(verbOrdinal, x0, y0, isClosedContour, $this) {
    PathSegment.call($this, get_entries_6().l1(verbOrdinal), new Point(x0, y0), null, null, null, 0.0, false, isClosedContour);
    // Inline function 'kotlin.require' call
    if (!(verbOrdinal === PathVerb_MOVE_getInstance().a1_1 || verbOrdinal === PathVerb_CLOSE_getInstance().a1_1)) {
      // Inline function 'kotlin.collections.toTypedArray' call
      var this_0 = get_entries_6();
      var message = 'Expected MOVE or CLOSE, got ' + copyToArray(this_0)[verbOrdinal].toString();
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return $this;
  }
  function PathSegment_init_$Create$(verbOrdinal, x0, y0, isClosedContour) {
    return PathSegment_init_$Init$(verbOrdinal, x0, y0, isClosedContour, objectCreate(protoOf(PathSegment)));
  }
  function PathSegment_init_$Init$_0(x0, y0, x1, y1, isCloseLine, isClosedContour, $this) {
    PathSegment.call($this, PathVerb_LINE_getInstance(), new Point(x0, y0), new Point(x1, y1), null, null, 0.0, isCloseLine, isClosedContour);
    return $this;
  }
  function PathSegment_init_$Create$_0(x0, y0, x1, y1, isCloseLine, isClosedContour) {
    return PathSegment_init_$Init$_0(x0, y0, x1, y1, isCloseLine, isClosedContour, objectCreate(protoOf(PathSegment)));
  }
  function PathSegment_init_$Init$_1(x0, y0, x1, y1, x2, y2, isClosedContour, $this) {
    PathSegment.call($this, PathVerb_QUAD_getInstance(), new Point(x0, y0), new Point(x1, y1), new Point(x2, y2), null, 0.0, false, isClosedContour);
    return $this;
  }
  function PathSegment_init_$Create$_1(x0, y0, x1, y1, x2, y2, isClosedContour) {
    return PathSegment_init_$Init$_1(x0, y0, x1, y1, x2, y2, isClosedContour, objectCreate(protoOf(PathSegment)));
  }
  function PathSegment_init_$Init$_2(x0, y0, x1, y1, x2, y2, conicWeight, isClosedContour, $this) {
    PathSegment.call($this, PathVerb_CONIC_getInstance(), new Point(x0, y0), new Point(x1, y1), new Point(x2, y2), null, conicWeight, false, isClosedContour);
    return $this;
  }
  function PathSegment_init_$Create$_2(x0, y0, x1, y1, x2, y2, conicWeight, isClosedContour) {
    return PathSegment_init_$Init$_2(x0, y0, x1, y1, x2, y2, conicWeight, isClosedContour, objectCreate(protoOf(PathSegment)));
  }
  function PathSegment_init_$Init$_3(x0, y0, x1, y1, x2, y2, x3, y3, isClosedContour, $this) {
    PathSegment.call($this, PathVerb_CUBIC_getInstance(), new Point(x0, y0), new Point(x1, y1), new Point(x2, y2), new Point(x3, y3), 0.0, false, isClosedContour);
    return $this;
  }
  function PathSegment_init_$Create$_3(x0, y0, x1, y1, x2, y2, x3, y3, isClosedContour) {
    return PathSegment_init_$Init$_3(x0, y0, x1, y1, x2, y2, x3, y3, isClosedContour, objectCreate(protoOf(PathSegment)));
  }
  function PathSegment(verb, p0, p1, p2, p3, conicWeight, isCloseLine, isClosedContour) {
    verb = verb === VOID ? PathVerb_DONE_getInstance() : verb;
    p0 = p0 === VOID ? null : p0;
    p1 = p1 === VOID ? null : p1;
    p2 = p2 === VOID ? null : p2;
    p3 = p3 === VOID ? null : p3;
    conicWeight = conicWeight === VOID ? 0.0 : conicWeight;
    isCloseLine = isCloseLine === VOID ? false : isCloseLine;
    isClosedContour = isClosedContour === VOID ? false : isClosedContour;
    this.e5t_1 = verb;
    this.f5t_1 = p0;
    this.g5t_1 = p1;
    this.h5t_1 = p2;
    this.i5t_1 = p3;
    this.j5t_1 = conicWeight;
    this.k5t_1 = isCloseLine;
    this.l5t_1 = isClosedContour;
  }
  protoOf(PathSegment).toString = function () {
    return 'Segment(verb=' + this.e5t_1.toString() + (!this.e5t_1.equals(PathVerb_DONE_getInstance()) ? ', p0=' + toString_0(this.f5t_1) : '') + (this.e5t_1.equals(PathVerb_LINE_getInstance()) || this.e5t_1.equals(PathVerb_QUAD_getInstance()) || this.e5t_1.equals(PathVerb_CONIC_getInstance()) || this.e5t_1.equals(PathVerb_CUBIC_getInstance()) ? ', p1=' + toString_0(this.g5t_1) : '') + (this.e5t_1.equals(PathVerb_QUAD_getInstance()) || this.e5t_1.equals(PathVerb_CONIC_getInstance()) || this.e5t_1.equals(PathVerb_CUBIC_getInstance()) ? ', p2=' + toString_0(this.h5t_1) : '') + (this.e5t_1.equals(PathVerb_CUBIC_getInstance()) ? ', p3=' + toString_0(this.i5t_1) : '') + (this.e5t_1.equals(PathVerb_CONIC_getInstance()) ? ', conicWeight=' + this.j5t_1 : '') + (this.e5t_1.equals(PathVerb_LINE_getInstance()) ? ', closeLine=' + this.k5t_1 : '') + (!this.e5t_1.equals(PathVerb_DONE_getInstance()) ? ', closedContour=' + this.l5t_1 : '') + ')';
  };
  protoOf(PathSegment).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PathSegment))
      return false;
    return this.e5t_1.equals(other.e5t_1) && (!this.e5t_1.equals(PathVerb_DONE_getInstance()) ? equals(this.f5t_1, other.f5t_1) : true) && (this.e5t_1.equals(PathVerb_LINE_getInstance()) || this.e5t_1.equals(PathVerb_QUAD_getInstance()) || this.e5t_1.equals(PathVerb_CONIC_getInstance()) || this.e5t_1.equals(PathVerb_CUBIC_getInstance()) ? equals(this.g5t_1, other.g5t_1) : true) && (this.e5t_1.equals(PathVerb_QUAD_getInstance()) || this.e5t_1.equals(PathVerb_CONIC_getInstance()) || this.e5t_1.equals(PathVerb_CUBIC_getInstance()) ? equals(this.h5t_1, other.h5t_1) : true) && (this.e5t_1.equals(PathVerb_CUBIC_getInstance()) ? equals(this.i5t_1, other.i5t_1) : true) && (this.e5t_1.equals(PathVerb_CONIC_getInstance()) ? compareTo(other.j5t_1, this.j5t_1) === 0 : true) && (this.e5t_1.equals(PathVerb_LINE_getInstance()) ? this.k5t_1 === other.k5t_1 : true) && (!this.e5t_1.equals(PathVerb_DONE_getInstance()) ? this.l5t_1 === other.l5t_1 : true);
  };
  protoOf(PathSegment).hashCode = function () {
    var tmp;
    switch (this.e5t_1.a1_1) {
      case 6:
        tmp = objectHashes([this.e5t_1]);
        break;
      case 0:
        tmp = objectHashes([this.e5t_1, this.f5t_1, this.l5t_1]);
        break;
      case 1:
        tmp = objectHashes([this.e5t_1, this.f5t_1, this.g5t_1, this.k5t_1, this.l5t_1]);
        break;
      case 2:
        tmp = objectHashes([this.e5t_1, this.f5t_1, this.g5t_1, this.h5t_1, this.l5t_1]);
        break;
      case 3:
        tmp = objectHashes([this.e5t_1, this.f5t_1, this.g5t_1, this.h5t_1, this.j5t_1, this.l5t_1]);
        break;
      case 4:
        tmp = objectHashes([this.e5t_1, this.f5t_1, this.g5t_1, this.h5t_1, this.i5t_1, this.l5t_1]);
        break;
      default:
        throw RuntimeException_init_$Create$('Unreachable');
    }
    return tmp;
  };
  function objectHashes(args) {
    return contentHashCode_0(args);
  }
  function Companion_31() {
    Companion_instance_31 = this;
    Companion_instance_62.q5h();
  }
  protoOf(Companion_31).a5s = function (path, forceClose) {
    var tmp;
    try {
      var i = new PathSegmentIterator(path, org_jetbrains_skia_PathSegmentIterator__1nMake(getPtr(path), forceClose));
      i.p5t_1 = nextSegment(i);
      tmp = i;
    }finally {
      reachabilityBarrier(path);
    }
    return tmp;
  };
  var Companion_instance_31;
  function Companion_getInstance_31() {
    if (Companion_instance_31 == null)
      new Companion_31();
    return Companion_instance_31;
  }
  function nextSegment($this) {
    // Inline function 'org.jetbrains.skia.impl.withResult' call
    var result = new Int32Array(10);
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        var handle = $this$interopScope.a5h(result);
        org_jetbrains_skia_PathSegmentIterator__1nNext($this.n5h_1, handle);
        $this$interopScope.b5h(handle, result);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return pathSegmentFromIntArray(result);
  }
  function PathSegmentIterator(_path, ptr) {
    Companion_getInstance_31();
    Managed.call(this, ptr, org_jetbrains_skia_PathSegmentIterator__1nGetFinalizer());
    this.o5t_1 = _path;
    this.p5t_1 = null;
    Stats_instance.k5h();
  }
  protoOf(PathSegmentIterator).v = function () {
    var tmp;
    try {
      var tmp0_safe_receiver = this.p5t_1;
      if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e5t_1, PathVerb_DONE_getInstance()))
        throw NoSuchElementException_init_$Create$();
      var res = this.p5t_1;
      this.p5t_1 = nextSegment(this);
      tmp = res;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PathSegmentIterator).u = function () {
    var tmp0_safe_receiver = this.p5t_1;
    return !equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.e5t_1, PathVerb_DONE_getInstance());
  };
  protoOf(PathSegmentIterator).l4 = function () {
    // Inline function 'kotlin.TODO' call
    var reason = 'Not yet implemented';
    throw new NotImplementedError('An operation is not implemented: ' + reason);
  };
  function pathSegmentFromIntArray(points) {
    var context = last(points);
    var verb = context & 7;
    var isClosedBit = context >> 7 & 1;
    var isClosedLineBit = context >> 6 & 1;
    var isClosed = !(isClosedBit === 0);
    var tmp;
    switch (get_entries_6().l1(verb).a1_1) {
      case 0:
      case 5:
        // Inline function 'kotlin.fromBits' call

        var bits = points[0];
        var tmp_0 = floatFromBits(bits);
        // Inline function 'kotlin.fromBits' call

        var bits_0 = points[1];
        var tmp$ret$1 = floatFromBits(bits_0);
        tmp = PathSegment_init_$Create$(verb, tmp_0, tmp$ret$1, isClosed);
        break;
      case 1:
        // Inline function 'kotlin.fromBits' call

        var bits_1 = points[0];
        var tmp_1 = floatFromBits(bits_1);
        // Inline function 'kotlin.fromBits' call

        var bits_2 = points[1];
        var tmp_2 = floatFromBits(bits_2);
        // Inline function 'kotlin.fromBits' call

        var bits_3 = points[2];
        var tmp_3 = floatFromBits(bits_3);
        // Inline function 'kotlin.fromBits' call

        var bits_4 = points[3];
        var tmp$ret$5 = floatFromBits(bits_4);
        tmp = PathSegment_init_$Create$_0(tmp_1, tmp_2, tmp_3, tmp$ret$5, !(isClosedLineBit === 0), isClosed);
        break;
      case 2:
        // Inline function 'kotlin.fromBits' call

        var bits_5 = points[0];
        var tmp_4 = floatFromBits(bits_5);
        // Inline function 'kotlin.fromBits' call

        var bits_6 = points[1];
        var tmp_5 = floatFromBits(bits_6);
        // Inline function 'kotlin.fromBits' call

        var bits_7 = points[2];
        var tmp_6 = floatFromBits(bits_7);
        // Inline function 'kotlin.fromBits' call

        var bits_8 = points[3];
        var tmp_7 = floatFromBits(bits_8);
        // Inline function 'kotlin.fromBits' call

        var bits_9 = points[4];
        var tmp_8 = floatFromBits(bits_9);
        // Inline function 'kotlin.fromBits' call

        var bits_10 = points[5];
        var tmp$ret$11 = floatFromBits(bits_10);
        tmp = PathSegment_init_$Create$_1(tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp$ret$11, isClosed);
        break;
      case 3:
        // Inline function 'kotlin.fromBits' call

        var bits_11 = points[0];
        var tmp_9 = floatFromBits(bits_11);
        // Inline function 'kotlin.fromBits' call

        var bits_12 = points[1];
        var tmp_10 = floatFromBits(bits_12);
        // Inline function 'kotlin.fromBits' call

        var bits_13 = points[2];
        var tmp_11 = floatFromBits(bits_13);
        // Inline function 'kotlin.fromBits' call

        var bits_14 = points[3];
        var tmp_12 = floatFromBits(bits_14);
        // Inline function 'kotlin.fromBits' call

        var bits_15 = points[4];
        var tmp_13 = floatFromBits(bits_15);
        // Inline function 'kotlin.fromBits' call

        var bits_16 = points[5];
        var tmp_14 = floatFromBits(bits_16);
        // Inline function 'kotlin.fromBits' call

        var bits_17 = points[8];
        var tmp$ret$18 = floatFromBits(bits_17);
        tmp = PathSegment_init_$Create$_2(tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp$ret$18, isClosed);
        break;
      case 4:
        // Inline function 'kotlin.fromBits' call

        var bits_18 = points[0];
        var tmp_15 = floatFromBits(bits_18);
        // Inline function 'kotlin.fromBits' call

        var bits_19 = points[1];
        var tmp_16 = floatFromBits(bits_19);
        // Inline function 'kotlin.fromBits' call

        var bits_20 = points[2];
        var tmp_17 = floatFromBits(bits_20);
        // Inline function 'kotlin.fromBits' call

        var bits_21 = points[3];
        var tmp_18 = floatFromBits(bits_21);
        // Inline function 'kotlin.fromBits' call

        var bits_22 = points[4];
        var tmp_19 = floatFromBits(bits_22);
        // Inline function 'kotlin.fromBits' call

        var bits_23 = points[5];
        var tmp_20 = floatFromBits(bits_23);
        // Inline function 'kotlin.fromBits' call

        var bits_24 = points[6];
        var tmp_21 = floatFromBits(bits_24);
        // Inline function 'kotlin.fromBits' call

        var bits_25 = points[7];
        var tmp$ret$26 = floatFromBits(bits_25);
        tmp = PathSegment_init_$Create$_3(tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, tmp_21, tmp$ret$26, isClosed);
        break;
      case 6:
        tmp = new PathSegment();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  var PathVerb_MOVE_instance;
  var PathVerb_LINE_instance;
  var PathVerb_QUAD_instance;
  var PathVerb_CONIC_instance;
  var PathVerb_CUBIC_instance;
  var PathVerb_CLOSE_instance;
  var PathVerb_DONE_instance;
  function values_6() {
    return [PathVerb_MOVE_getInstance(), PathVerb_LINE_getInstance(), PathVerb_QUAD_getInstance(), PathVerb_CONIC_getInstance(), PathVerb_CUBIC_getInstance(), PathVerb_CLOSE_getInstance(), PathVerb_DONE_getInstance()];
  }
  function get_entries_6() {
    if ($ENTRIES_6 == null)
      $ENTRIES_6 = enumEntries(values_6());
    return $ENTRIES_6;
  }
  var PathVerb_entriesInitialized;
  function PathVerb_initEntries() {
    if (PathVerb_entriesInitialized)
      return Unit_instance;
    PathVerb_entriesInitialized = true;
    PathVerb_MOVE_instance = new PathVerb('MOVE', 0);
    PathVerb_LINE_instance = new PathVerb('LINE', 1);
    PathVerb_QUAD_instance = new PathVerb('QUAD', 2);
    PathVerb_CONIC_instance = new PathVerb('CONIC', 3);
    PathVerb_CUBIC_instance = new PathVerb('CUBIC', 4);
    PathVerb_CLOSE_instance = new PathVerb('CLOSE', 5);
    PathVerb_DONE_instance = new PathVerb('DONE', 6);
  }
  var $ENTRIES_6;
  function PathVerb(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PathVerb_MOVE_getInstance() {
    PathVerb_initEntries();
    return PathVerb_MOVE_instance;
  }
  function PathVerb_LINE_getInstance() {
    PathVerb_initEntries();
    return PathVerb_LINE_instance;
  }
  function PathVerb_QUAD_getInstance() {
    PathVerb_initEntries();
    return PathVerb_QUAD_instance;
  }
  function PathVerb_CONIC_getInstance() {
    PathVerb_initEntries();
    return PathVerb_CONIC_instance;
  }
  function PathVerb_CUBIC_getInstance() {
    PathVerb_initEntries();
    return PathVerb_CUBIC_instance;
  }
  function PathVerb_CLOSE_getInstance() {
    PathVerb_initEntries();
    return PathVerb_CLOSE_instance;
  }
  function PathVerb_DONE_getInstance() {
    PathVerb_initEntries();
    return PathVerb_DONE_instance;
  }
  function Companion_32() {
    Companion_instance_32 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_32;
  function Companion_getInstance_32() {
    if (Companion_instance_32 == null)
      new Companion_32();
    return Companion_instance_32;
  }
  function Picture(ptr, managed) {
    Companion_getInstance_32();
    managed = managed === VOID ? true : managed;
    RefCnt_init_$Init$_0(ptr, managed, this);
  }
  function Companion_33() {
    Companion_instance_33 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_33;
  function Companion_getInstance_33() {
    if (Companion_instance_33 == null)
      new Companion_33();
    return Companion_instance_33;
  }
  function PictureRecorder_init_$Init$($this) {
    PictureRecorder.call($this, org_jetbrains_skia_PictureRecorder__1nMake());
    Stats_instance.k5h();
    return $this;
  }
  function PictureRecorder_init_$Create$() {
    return PictureRecorder_init_$Init$(objectCreate(protoOf(PictureRecorder)));
  }
  function _FinalizerHolder_13() {
    _FinalizerHolder_instance_13 = this;
    this.q5t_1 = org_jetbrains_skia_PictureRecorder__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_13;
  function _FinalizerHolder_getInstance_13() {
    if (_FinalizerHolder_instance_13 == null)
      new _FinalizerHolder_13();
    return _FinalizerHolder_instance_13;
  }
  function PictureRecorder(ptr) {
    Companion_getInstance_33();
    Managed.call(this, ptr, _FinalizerHolder_getInstance_13().q5t_1);
  }
  protoOf(PictureRecorder).t5t = function (left, top, right, bottom, bbh) {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = new Canvas(org_jetbrains_skia_PictureRecorder__1nBeginRecording(this.n5h_1, left, top, right, bottom, getPtr(bbh)), false, this);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(PictureRecorder).u5t = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = new Picture(org_jetbrains_skia_PictureRecorder__1nFinishRecordingAsPicture(this.n5h_1));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  var PixelGeometry_UNKNOWN_instance;
  var PixelGeometry_RGB_H_instance;
  var PixelGeometry_BGR_H_instance;
  var PixelGeometry_RGB_V_instance;
  var PixelGeometry_BGR_V_instance;
  var PixelGeometry_entriesInitialized;
  function PixelGeometry_initEntries() {
    if (PixelGeometry_entriesInitialized)
      return Unit_instance;
    PixelGeometry_entriesInitialized = true;
    PixelGeometry_UNKNOWN_instance = new PixelGeometry('UNKNOWN', 0);
    PixelGeometry_RGB_H_instance = new PixelGeometry('RGB_H', 1);
    PixelGeometry_BGR_H_instance = new PixelGeometry('BGR_H', 2);
    PixelGeometry_RGB_V_instance = new PixelGeometry('RGB_V', 3);
    PixelGeometry_BGR_V_instance = new PixelGeometry('BGR_V', 4);
  }
  function PixelGeometry(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PixelGeometry_UNKNOWN_getInstance() {
    PixelGeometry_initEntries();
    return PixelGeometry_UNKNOWN_instance;
  }
  function Companion_34() {
    Companion_instance_34 = this;
    this.v5t_1 = new Point(0.0, 0.0);
  }
  var Companion_instance_34;
  function Companion_getInstance_34() {
    if (Companion_instance_34 == null)
      new Companion_34();
    return Companion_instance_34;
  }
  function Point(x, y) {
    Companion_getInstance_34();
    this.w5t_1 = x;
    this.x5t_1 = y;
  }
  protoOf(Point).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Point))
      return false;
    if (!(compareTo(this.w5t_1, other.w5t_1) === 0))
      return false;
    return compareTo(this.x5t_1, other.x5t_1) === 0;
  };
  protoOf(Point).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + toBits(this.w5t_1) | 0;
    result = imul(result, PRIME) + toBits(this.x5t_1) | 0;
    return result;
  };
  protoOf(Point).toString = function () {
    return 'Point(_x=' + this.w5t_1 + ', _y=' + this.x5t_1 + ')';
  };
  function Point3(x, y, z) {
    this.y5t_1 = x;
    this.z5t_1 = y;
    this.a5u_1 = z;
  }
  protoOf(Point3).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Point3))
      return false;
    if (!(compareTo(this.y5t_1, other.y5t_1) === 0))
      return false;
    if (!(compareTo(this.z5t_1, other.z5t_1) === 0))
      return false;
    return compareTo(this.a5u_1, other.a5u_1) === 0;
  };
  protoOf(Point3).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + toBits(this.y5t_1) | 0;
    result = imul(result, PRIME) + toBits(this.z5t_1) | 0;
    result = imul(result, PRIME) + toBits(this.a5u_1) | 0;
    return result;
  };
  protoOf(Point3).toString = function () {
    return 'Point3(_x=' + this.y5t_1 + ', _y=' + this.z5t_1 + ', _z=' + this.a5u_1 + ')';
  };
  function Rect$Companion$fromInteropPointerNullable$lambda($result, $block) {
    return function ($this$fromInteropPointer, it) {
      $result._v = $block(it);
      return Unit_instance;
    };
  }
  function Companion_35() {
  }
  protoOf(Companion_35).b5u = function (l, t, r, b) {
    return new Rect(l, t, r, b);
  };
  protoOf(Companion_35).c5u = function (w, h) {
    return new Rect(0.0, 0.0, w, h);
  };
  protoOf(Companion_35).d5u = function (l, t, w, h) {
    return new Rect(l, t, l + w, t + h);
  };
  protoOf(Companion_35).y5r = function (block) {
    // Inline function 'org.jetbrains.skia.impl.withResult' call
    var result = new Float32Array(4);
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        var handle = $this$interopScope.t5o(result);
        block($this$interopScope, handle);
        $this$interopScope.u5o(handle, result);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    var result_0 = result;
    return new Rect(result_0[0], result_0[1], result_0[2], result_0[3]);
  };
  protoOf(Companion_35).e5u = function (block) {
    var result = {_v: true};
    var rect = this.y5r(Rect$Companion$fromInteropPointerNullable$lambda(result, block));
    var tmp;
    if (result._v) {
      tmp = rect;
    } else {
      tmp = null;
    }
    return tmp;
  };
  var Companion_instance_35;
  function Companion_getInstance_35() {
    return Companion_instance_35;
  }
  function Rect(left, top, right, bottom) {
    this.k5k_1 = left;
    this.l5k_1 = top;
    this.m5k_1 = right;
    this.n5k_1 = bottom;
  }
  protoOf(Rect).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Rect))
      return false;
    if (!(compareTo(this.k5k_1, other.k5k_1) === 0))
      return false;
    if (!(compareTo(this.l5k_1, other.l5k_1) === 0))
      return false;
    if (!(compareTo(this.m5k_1, other.m5k_1) === 0))
      return false;
    return compareTo(this.n5k_1, other.n5k_1) === 0;
  };
  protoOf(Rect).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + toBits(this.k5k_1) | 0;
    result = imul(result, PRIME) + toBits(this.l5k_1) | 0;
    result = imul(result, PRIME) + toBits(this.m5k_1) | 0;
    result = imul(result, PRIME) + toBits(this.n5k_1) | 0;
    return result;
  };
  protoOf(Rect).toString = function () {
    return 'Rect(_left=' + this.k5k_1 + ', _top=' + this.l5k_1 + ', _right=' + this.m5k_1 + ', _bottom=' + this.n5k_1 + ')';
  };
  function Companion_36() {
    Companion_instance_36 = this;
    this.o5k_1 = new FilterMipmap(FilterMode_NEAREST_getInstance(), MipmapMode_NONE_getInstance());
    this.p5k_1 = new FilterMipmap(FilterMode_LINEAR_getInstance(), MipmapMode_NONE_getInstance());
    this.q5k_1 = new CubicResampler(0.33333334, 0.33333334);
    this.r5k_1 = new CubicResampler(0.0, 0.5);
  }
  var Companion_instance_36;
  function Companion_getInstance_36() {
    if (Companion_instance_36 == null)
      new Companion_36();
    return Companion_instance_36;
  }
  function Companion_37() {
    Companion_instance_37 = this;
    Companion_instance_62.q5h();
  }
  protoOf(Companion_37).f5u = function (x0, y0, x1, y1, colors, positions, style) {
    // Inline function 'kotlin.require' call
    if (!(positions == null || colors.length === positions.length)) {
      var message = 'colors.length ' + colors.length + '!= positions.length ' + ensureNotNull(positions).length;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    Stats_instance.k5h();
    var tmp$ret$2;
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        tmp$ret$2 = org_jetbrains_skia_Shader__1nMakeLinearGradient(x0, y0, x1, y1, $this$interopScope.u5j(colors), $this$interopScope.h5k(positions), colors.length, style.s5p_1.a1_1, style.v5p(), $this$interopScope.h5k(style.w5p()));
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return new Shader(tmp$ret$2);
  };
  protoOf(Companion_37).g5u = function (x, y, r, colors, positions, style) {
    // Inline function 'kotlin.require' call
    if (!(positions == null || colors.length === positions.length)) {
      var message = 'colors.length ' + colors.length + '!= positions.length ' + ensureNotNull(positions).length;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    Stats_instance.k5h();
    var tmp$ret$2;
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        tmp$ret$2 = org_jetbrains_skia_Shader__1nMakeRadialGradient(x, y, r, $this$interopScope.u5j(colors), $this$interopScope.h5k(positions), colors.length, style.s5p_1.a1_1, style.v5p(), $this$interopScope.h5k(style.w5p()));
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return new Shader(tmp$ret$2);
  };
  protoOf(Companion_37).h5u = function (x, y, colors, positions) {
    return this.i5u(x, y, 0.0, 360.0, colors, positions, Companion_getInstance_19().r5p_1);
  };
  protoOf(Companion_37).i5u = function (x, y, startAngle, endAngle, colors, positions, style) {
    // Inline function 'kotlin.require' call
    if (!(positions == null || colors.length === positions.length)) {
      var message = 'colors.length ' + colors.length + '!= positions.length ' + ensureNotNull(positions).length;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    Stats_instance.k5h();
    var tmp$ret$2;
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        tmp$ret$2 = org_jetbrains_skia_Shader__1nMakeSweepGradient(x, y, startAngle, endAngle, $this$interopScope.u5j(colors), $this$interopScope.h5k(positions), colors.length, style.s5p_1.a1_1, style.v5p(), $this$interopScope.h5k(style.w5p()));
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return new Shader(tmp$ret$2);
  };
  var Companion_instance_37;
  function Companion_getInstance_37() {
    if (Companion_instance_37 == null)
      new Companion_37();
    return Companion_instance_37;
  }
  function Shader(ptr) {
    Companion_getInstance_37();
    RefCnt_init_$Init$(ptr, this);
  }
  protoOf(Shader).l5u = function (localMatrix) {
    var tmp;
    try {
      Stats_instance.k5h();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          tmp$ret$0 = org_jetbrains_skia_Shader__1nMakeWithLocalMatrix(this.n5h_1, $this$interopScope.h5k(localMatrix.x5k_1));
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
      tmp = new Shader(tmp$ret$0);
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(localMatrix);
    }
    return tmp;
  };
  function ShadowUtils() {
    ShadowUtils_instance = this;
    Companion_instance_62.q5h();
  }
  protoOf(ShadowUtils).m5u = function (canvas, path, zPlaneParams, lightPos, lightRadius, ambientColor, spotColor, transparentOccluder, geometricOnly) {
    Stats_instance.k5h();
    var flags = 0;
    if (transparentOccluder)
      flags = flags | 1;
    if (geometricOnly)
      flags = flags | 2;
    try {
      org_jetbrains_skia_ShadowUtils__1nDrawShadow(getPtr(canvas), getPtr(path), zPlaneParams.y5t_1, zPlaneParams.z5t_1, zPlaneParams.a5u_1, lightPos.y5t_1, lightPos.z5t_1, lightPos.a5u_1, lightRadius, ambientColor, spotColor, flags);
    }finally {
      reachabilityBarrier(canvas);
      reachabilityBarrier(path);
    }
  };
  var ShadowUtils_instance;
  function ShadowUtils_getInstance() {
    if (ShadowUtils_instance == null)
      new ShadowUtils();
    return ShadowUtils_instance;
  }
  function ArrayDecoder(ptr, disposePtr) {
    this.n5u_1 = ptr;
    this.o5u_1 = disposePtr;
  }
  protoOf(ArrayDecoder).s1d = function () {
    org_jetbrains_skia_StdVectorDecoder__1nDisposeArray(this.n5u_1, this.o5u_1);
  };
  protoOf(ArrayDecoder).p5u = function (index) {
    return org_jetbrains_skia_StdVectorDecoder__1nReleaseElement(this.n5u_1, index);
  };
  protoOf(ArrayDecoder).n1 = function () {
    return org_jetbrains_skia_StdVectorDecoder__1nGetArraySize(this.n5u_1);
  };
  function Companion_38() {
    Companion_instance_38 = this;
    Companion_instance_62.q5h();
  }
  protoOf(Companion_38).q5u = function (context, rt, origin, colorFormat, colorSpace, surfaceProps) {
    var tmp;
    try {
      Stats_instance.k5h();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          var tmp_0 = getPtr(context);
          var tmp_1 = getPtr(rt);
          var tmp_2 = getPtr(colorSpace);
          tmp$ret$0 = org_jetbrains_skia_Surface__1nMakeFromBackendRenderTarget(tmp_0, tmp_1, origin.a1_1, colorFormat.a1_1, tmp_2, $this$interopScope.u5j(surfaceProps == null ? null : surfaceProps.r5u()));
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
      var ptr = tmp$ret$0;
      tmp = ptr === Companion_instance_63.s5h() ? null : Surface_init_$Create$_0(ptr, context, rt);
    }finally {
      reachabilityBarrier(context);
      reachabilityBarrier(rt);
      reachabilityBarrier(colorSpace);
    }
    return tmp;
  };
  protoOf(Companion_38).s5u = function (width, height) {
    Stats_instance.k5h();
    var ptr = org_jetbrains_skia_Surface__1nMakeRasterN32Premul(width, height);
    // Inline function 'kotlin.require' call
    if (!!(ptr === Companion_instance_63.s5h())) {
      var message = 'Failed Surface.makeRasterN32Premul(' + width + ', ' + height + ')';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return Surface_init_$Create$(ptr);
  };
  var Companion_instance_38;
  function Companion_getInstance_38() {
    if (Companion_instance_38 == null)
      new Companion_38();
    return Companion_instance_38;
  }
  function Surface_init_$Init$(ptr, $this) {
    RefCnt_init_$Init$(ptr, $this);
    Surface.call($this);
    $this.v5u_1 = null;
    $this.w5u_1 = null;
    return $this;
  }
  function Surface_init_$Create$(ptr) {
    return Surface_init_$Init$(ptr, objectCreate(protoOf(Surface)));
  }
  function Surface_init_$Init$_0(ptr, context, renderTarget, $this) {
    RefCnt_init_$Init$(ptr, $this);
    Surface.call($this);
    $this.v5u_1 = context;
    $this.w5u_1 = renderTarget;
    return $this;
  }
  function Surface_init_$Create$_0(ptr, context, renderTarget) {
    return Surface_init_$Init$_0(ptr, context, renderTarget, objectCreate(protoOf(Surface)));
  }
  protoOf(Surface).x5u = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      var ptr = org_jetbrains_skia_Surface__1nGetCanvas(this.n5h_1);
      var tmp_0;
      if (ptr === Companion_instance_63.s5h()) {
        throw IllegalArgumentException_init_$Create$_0();
      } else {
        tmp_0 = new Canvas(ptr, false, this);
      }
      tmp = tmp_0;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Surface).y5u = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = new Image(org_jetbrains_skia_Surface__1nMakeImageSnapshot(this.n5h_1));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Surface).z5u = function () {
    var tmp0_safe_receiver = this.v5u_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.f5n(this);
    }
  };
  function Surface() {
    Companion_getInstance_38();
  }
  var SurfaceColorFormat_UNKNOWN_instance;
  var SurfaceColorFormat_ALPHA_8_instance;
  var SurfaceColorFormat_RGB_565_instance;
  var SurfaceColorFormat_ARGB_4444_instance;
  var SurfaceColorFormat_RGBA_8888_instance;
  var SurfaceColorFormat_RGB_888x_instance;
  var SurfaceColorFormat_BGRA_8888_instance;
  var SurfaceColorFormat_RGBA_1010102_instance;
  var SurfaceColorFormat_RGB_101010x_instance;
  var SurfaceColorFormat_GRAY_8_instance;
  var SurfaceColorFormat_RGBA_F16_NORM_instance;
  var SurfaceColorFormat_RGBA_F16_instance;
  var SurfaceColorFormat_RGBA_F32_instance;
  var SurfaceColorFormat_R8G8_UNORM_instance;
  var SurfaceColorFormat_A16_FLOAT_instance;
  var SurfaceColorFormat_R16G16_FLOAT_instance;
  var SurfaceColorFormat_A16_UNORM_instance;
  var SurfaceColorFormat_R16G16_UNORM_instance;
  var SurfaceColorFormat_R16G16B16A16_UNORM_instance;
  var SurfaceColorFormat_entriesInitialized;
  function SurfaceColorFormat_initEntries() {
    if (SurfaceColorFormat_entriesInitialized)
      return Unit_instance;
    SurfaceColorFormat_entriesInitialized = true;
    SurfaceColorFormat_UNKNOWN_instance = new SurfaceColorFormat('UNKNOWN', 0);
    SurfaceColorFormat_ALPHA_8_instance = new SurfaceColorFormat('ALPHA_8', 1);
    SurfaceColorFormat_RGB_565_instance = new SurfaceColorFormat('RGB_565', 2);
    SurfaceColorFormat_ARGB_4444_instance = new SurfaceColorFormat('ARGB_4444', 3);
    SurfaceColorFormat_RGBA_8888_instance = new SurfaceColorFormat('RGBA_8888', 4);
    SurfaceColorFormat_RGB_888x_instance = new SurfaceColorFormat('RGB_888x', 5);
    SurfaceColorFormat_BGRA_8888_instance = new SurfaceColorFormat('BGRA_8888', 6);
    SurfaceColorFormat_RGBA_1010102_instance = new SurfaceColorFormat('RGBA_1010102', 7);
    SurfaceColorFormat_RGB_101010x_instance = new SurfaceColorFormat('RGB_101010x', 8);
    SurfaceColorFormat_GRAY_8_instance = new SurfaceColorFormat('GRAY_8', 9);
    SurfaceColorFormat_RGBA_F16_NORM_instance = new SurfaceColorFormat('RGBA_F16_NORM', 10);
    SurfaceColorFormat_RGBA_F16_instance = new SurfaceColorFormat('RGBA_F16', 11);
    SurfaceColorFormat_RGBA_F32_instance = new SurfaceColorFormat('RGBA_F32', 12);
    SurfaceColorFormat_R8G8_UNORM_instance = new SurfaceColorFormat('R8G8_UNORM', 13);
    SurfaceColorFormat_A16_FLOAT_instance = new SurfaceColorFormat('A16_FLOAT', 14);
    SurfaceColorFormat_R16G16_FLOAT_instance = new SurfaceColorFormat('R16G16_FLOAT', 15);
    SurfaceColorFormat_A16_UNORM_instance = new SurfaceColorFormat('A16_UNORM', 16);
    SurfaceColorFormat_R16G16_UNORM_instance = new SurfaceColorFormat('R16G16_UNORM', 17);
    SurfaceColorFormat_R16G16B16A16_UNORM_instance = new SurfaceColorFormat('R16G16B16A16_UNORM', 18);
  }
  function SurfaceColorFormat(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function SurfaceColorFormat_RGBA_8888_getInstance() {
    SurfaceColorFormat_initEntries();
    return SurfaceColorFormat_RGBA_8888_instance;
  }
  var SurfaceOrigin_TOP_LEFT_instance;
  var SurfaceOrigin_BOTTOM_LEFT_instance;
  var SurfaceOrigin_entriesInitialized;
  function SurfaceOrigin_initEntries() {
    if (SurfaceOrigin_entriesInitialized)
      return Unit_instance;
    SurfaceOrigin_entriesInitialized = true;
    SurfaceOrigin_TOP_LEFT_instance = new SurfaceOrigin('TOP_LEFT', 0);
    SurfaceOrigin_BOTTOM_LEFT_instance = new SurfaceOrigin('BOTTOM_LEFT', 1);
  }
  function SurfaceOrigin(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function SurfaceOrigin_BOTTOM_LEFT_getInstance() {
    SurfaceOrigin_initEntries();
    return SurfaceOrigin_BOTTOM_LEFT_instance;
  }
  function _getPixelGeometryOrdinal($this) {
    return $this.w5j_1.a1_1;
  }
  function SurfaceProps(isDeviceIndependentFonts, pixelGeometry) {
    isDeviceIndependentFonts = isDeviceIndependentFonts === VOID ? false : isDeviceIndependentFonts;
    pixelGeometry = pixelGeometry === VOID ? PixelGeometry_UNKNOWN_getInstance() : pixelGeometry;
    this.v5j_1 = isDeviceIndependentFonts;
    this.w5j_1 = pixelGeometry;
  }
  protoOf(SurfaceProps).x5j = function () {
    return 0 | (this.v5j_1 ? 1 : 0);
  };
  protoOf(SurfaceProps).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof SurfaceProps))
      return false;
    if (!(this.v5j_1 === other.v5j_1))
      return false;
    return this.w5j_1.equals(other.w5j_1);
  };
  protoOf(SurfaceProps).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + (this.v5j_1 ? 79 : 97) | 0;
    result = imul(result, PRIME) + this.w5j_1.hashCode() | 0;
    return result;
  };
  protoOf(SurfaceProps).toString = function () {
    return 'SurfaceProps(_deviceIndependentFonts=' + this.v5j_1 + ', _pixelGeometry=' + this.w5j_1.toString() + ')';
  };
  protoOf(SurfaceProps).r5u = function () {
    // Inline function 'kotlin.intArrayOf' call
    return new Int32Array([this.x5j(), _getPixelGeometryOrdinal(this)]);
  };
  function Companion_39() {
    Companion_instance_39 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_39;
  function Companion_getInstance_39() {
    if (Companion_instance_39 == null)
      new Companion_39();
    return Companion_instance_39;
  }
  function Typeface(ptr) {
    Companion_getInstance_39();
    RefCnt_init_$Init$(ptr, this);
  }
  protoOf(Typeface).c5v = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = FontStyle_init_$Create$_0(org_jetbrains_skia_Typeface__1nGetFontStyle(this.n5h_1));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Typeface).d5v = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_Typeface__1nGetUniqueId(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Typeface).o5h = function (other) {
    var tmp;
    try {
      tmp = org_jetbrains_skia_Typeface__1nEquals(this.n5h_1, getPtr(other));
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(other);
    }
    return tmp;
  };
  protoOf(Typeface).e5v = function (variations, collectionIndex) {
    var tmp;
    try {
      // Inline function 'kotlin.collections.isEmpty' call
      if (variations.length === 0)
        return this;
      Stats_instance.k5h();
      var variationsCount = imul(variations.length, 2);
      // Inline function 'org.jetbrains.skiko.internal.unpackTo' call
      var destinationArray = new Int32Array(variationsCount);
      var targetIndex = 0;
      var inductionVariable = 0;
      var last = variations.length - 1 | 0;
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp0 = variations[i];
          var idx = targetIndex;
          destinationArray[idx] = tmp0.o5p_1;
          destinationArray[idx + 1 | 0] = toRawBits(tmp0.p5p_1);
          targetIndex = idx + 2 | 0;
        }
         while (inductionVariable <= last);
      var variationsData = destinationArray;
      var tmp$ret$3;
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          tmp$ret$3 = org_jetbrains_skia_Typeface__1nMakeClone(this.n5h_1, $this$interopScope.u5j(variationsData), variationsCount, collectionIndex);
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
      var ptr = tmp$ret$3;
      // Inline function 'kotlin.require' call
      if (!!(ptr === Companion_instance_63.s5h())) {
        var message = 'Failed to clone Typeface ' + this.toString() + ' with ' + contentToString(variations);
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      tmp = new Typeface(ptr);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Typeface).f5v = function (variations, collectionIndex, $super) {
    collectionIndex = collectionIndex === VOID ? 0 : collectionIndex;
    return $super === VOID ? this.e5v(variations, collectionIndex) : $super.e5v.call(this, variations, collectionIndex);
  };
  protoOf(Typeface).g5v = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      // Inline function 'org.jetbrains.skia.impl.withStringResult' call
      var tmp$ret$1 = org_jetbrains_skia_Typeface__1nGetFamilyName(this.n5h_1);
      // Inline function 'org.jetbrains.skia.impl.use' call
      var this_0 = new ManagedString(tmp$ret$1);
      var tmp_0;
      try {
        tmp_0 = this_0.toString();
      }finally {
        this_0.j4();
      }
      tmp = tmp_0;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Typeface).toString = function () {
    return "Typeface(familyName='" + this.g5v() + "', fontStyle=" + this.c5v().toString() + ', uniqueId=' + this.d5v() + ')';
  };
  function Companion_40() {
    Companion_instance_40 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_40;
  function Companion_getInstance_40() {
    if (Companion_instance_40 == null)
      new Companion_40();
    return Companion_instance_40;
  }
  function _FinalizerHolder_14() {
    _FinalizerHolder_instance_14 = this;
    this.h5v_1 = org_jetbrains_skia_U16String__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_14;
  function _FinalizerHolder_getInstance_14() {
    if (_FinalizerHolder_instance_14 == null)
      new _FinalizerHolder_14();
    return _FinalizerHolder_instance_14;
  }
  function U16String(ptr) {
    Companion_getInstance_40();
    Managed.call(this, ptr, _FinalizerHolder_getInstance_14().h5v_1);
  }
  function CharProperties() {
    CharProperties_instance = this;
    Companion_instance_62.q5h();
    this.i5v_1 = 0;
    this.j5v_1 = 0;
    this.k5v_1 = 1;
    this.l5v_1 = 2;
    this.m5v_1 = 3;
    this.n5v_1 = 4;
    this.o5v_1 = 5;
    this.p5v_1 = 6;
    this.q5v_1 = 7;
    this.r5v_1 = 8;
    this.s5v_1 = 9;
    this.t5v_1 = 10;
    this.u5v_1 = 11;
    this.v5v_1 = 12;
    this.w5v_1 = 13;
    this.x5v_1 = 14;
    this.y5v_1 = 15;
    this.z5v_1 = 16;
    this.a5w_1 = 17;
    this.b5w_1 = 18;
    this.c5w_1 = 19;
    this.d5w_1 = 20;
    this.e5w_1 = 21;
    this.f5w_1 = 22;
    this.g5w_1 = 23;
    this.h5w_1 = 24;
    this.i5w_1 = 25;
    this.j5w_1 = 26;
    this.k5w_1 = 27;
    this.l5w_1 = 28;
    this.m5w_1 = 29;
    this.n5w_1 = 30;
    this.o5w_1 = 31;
    this.p5w_1 = 32;
    this.q5w_1 = 33;
    this.r5w_1 = 34;
    this.s5w_1 = 35;
    this.t5w_1 = 36;
    this.u5w_1 = 37;
    this.v5w_1 = 38;
    this.w5w_1 = 39;
    this.x5w_1 = 40;
    this.y5w_1 = 41;
    this.z5w_1 = 42;
    this.a5x_1 = 43;
    this.b5x_1 = 44;
    this.c5x_1 = 45;
    this.d5x_1 = 46;
    this.e5x_1 = 47;
    this.f5x_1 = 48;
    this.g5x_1 = 49;
    this.h5x_1 = 50;
    this.i5x_1 = 51;
    this.j5x_1 = 52;
    this.k5x_1 = 53;
    this.l5x_1 = 54;
    this.m5x_1 = 55;
    this.n5x_1 = 56;
    this.o5x_1 = 57;
    this.p5x_1 = 58;
    this.q5x_1 = 59;
    this.r5x_1 = 60;
    this.s5x_1 = 61;
    this.t5x_1 = 62;
    this.u5x_1 = 63;
    this.v5x_1 = 64;
    this.w5x_1 = 4096;
    this.x5x_1 = 4096;
    this.y5x_1 = 4097;
    this.z5x_1 = 4098;
    this.a5y_1 = 4099;
    this.b5y_1 = 4100;
    this.c5y_1 = 4101;
    this.d5y_1 = 4102;
    this.e5y_1 = 4103;
    this.f5y_1 = 4104;
    this.g5y_1 = 4105;
    this.h5y_1 = 4106;
    this.i5y_1 = 4107;
    this.j5y_1 = 4108;
    this.k5y_1 = 4109;
    this.l5y_1 = 4110;
    this.m5y_1 = 4111;
    this.n5y_1 = 4112;
    this.o5y_1 = 4113;
    this.p5y_1 = 4114;
    this.q5y_1 = 4115;
    this.r5y_1 = 4116;
    this.s5y_1 = 4117;
    this.t5y_1 = 4118;
    this.u5y_1 = 4119;
    this.v5y_1 = 4120;
    this.w5y_1 = 8192;
    this.x5y_1 = 8192;
    this.y5y_1 = 12288;
    this.z5y_1 = 12288;
    this.a5z_1 = 16384;
    this.b5z_1 = 16384;
    this.c5z_1 = 16385;
    this.d5z_1 = 16386;
    this.e5z_1 = 16388;
    this.f5z_1 = 16389;
    this.g5z_1 = 16390;
    this.h5z_1 = 16391;
    this.i5z_1 = 16392;
    this.j5z_1 = 16393;
    this.k5z_1 = 16394;
    this.l5z_1 = 16396;
    this.m5z_1 = 16397;
    this.n5z_1 = 28672;
    this.o5z_1 = 28672;
    this.p5z_1 = -1;
  }
  protoOf(CharProperties).q5z = function (codePoint, property) {
    Stats_instance.k5h();
    return org_jetbrains_skia_icu_Unicode__1nCodePointHasBinaryProperty(codePoint, property);
  };
  var CharProperties_instance;
  function CharProperties_getInstance() {
    if (CharProperties_instance == null)
      new CharProperties();
    return CharProperties_instance;
  }
  function CharDirection() {
    CharDirection_instance = this;
    Companion_instance_62.q5h();
    this.r5z_1 = 0;
    this.s5z_1 = 1;
    this.t5z_1 = 2;
    this.u5z_1 = 3;
    this.v5z_1 = 4;
    this.w5z_1 = 5;
    this.x5z_1 = 6;
    this.y5z_1 = 7;
    this.z5z_1 = 8;
    this.a60_1 = 9;
    this.b60_1 = 10;
    this.c60_1 = 11;
    this.d60_1 = 12;
    this.e60_1 = 13;
    this.f60_1 = 14;
    this.g60_1 = 15;
    this.h60_1 = 16;
    this.i60_1 = 17;
    this.j60_1 = 18;
    this.k60_1 = 19;
    this.l60_1 = 20;
    this.m60_1 = 21;
    this.n60_1 = 22;
  }
  protoOf(CharDirection).o60 = function (codePoint) {
    Stats_instance.k5h();
    return org_jetbrains_skia_icu_Unicode__1nCharDirection(codePoint);
  };
  var CharDirection_instance;
  function CharDirection_getInstance() {
    if (CharDirection_instance == null)
      new CharDirection();
    return CharDirection_instance;
  }
  function getPtr(n) {
    var tmp1_elvis_lhs = n == null ? null : n.n5h_1;
    return tmp1_elvis_lhs == null ? Companion_instance_63.s5h() : tmp1_elvis_lhs;
  }
  function refCntToString(_this__u8e3s4, managedString, nullPointer) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    this_0.q(managedString);
    this_0.jd(this_0.a() - 1 | 0);
    if (_this__u8e3s4.n5h_1 === nullPointer) {
      this_0.q(', disposed');
    } else {
      this_0.q(', refCount=');
      this_0.ed(_this__u8e3s4.c5m());
    }
    this_0.s(_Char___init__impl__6a9atx(41));
    return this_0.toString();
  }
  var Affinity_UPSTREAM_instance;
  var Affinity_DOWNSTREAM_instance;
  var Affinity_entriesInitialized;
  function Affinity_initEntries() {
    if (Affinity_entriesInitialized)
      return Unit_instance;
    Affinity_entriesInitialized = true;
    Affinity_UPSTREAM_instance = new Affinity('UPSTREAM', 0);
    Affinity_DOWNSTREAM_instance = new Affinity('DOWNSTREAM', 1);
  }
  function Affinity(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Affinity_UPSTREAM_getInstance() {
    Affinity_initEntries();
    return Affinity_UPSTREAM_instance;
  }
  function Affinity_DOWNSTREAM_getInstance() {
    Affinity_initEntries();
    return Affinity_DOWNSTREAM_instance;
  }
  var Alignment_LEFT_instance;
  var Alignment_RIGHT_instance;
  var Alignment_CENTER_instance;
  var Alignment_JUSTIFY_instance;
  var Alignment_START_instance;
  var Alignment_END_instance;
  var Alignment_entriesInitialized;
  function Alignment_initEntries() {
    if (Alignment_entriesInitialized)
      return Unit_instance;
    Alignment_entriesInitialized = true;
    Alignment_LEFT_instance = new Alignment('LEFT', 0);
    Alignment_RIGHT_instance = new Alignment('RIGHT', 1);
    Alignment_CENTER_instance = new Alignment('CENTER', 2);
    Alignment_JUSTIFY_instance = new Alignment('JUSTIFY', 3);
    Alignment_START_instance = new Alignment('START', 4);
    Alignment_END_instance = new Alignment('END', 5);
  }
  function Alignment(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Alignment_LEFT_getInstance() {
    Alignment_initEntries();
    return Alignment_LEFT_instance;
  }
  function Alignment_RIGHT_getInstance() {
    Alignment_initEntries();
    return Alignment_RIGHT_instance;
  }
  function Alignment_CENTER_getInstance() {
    Alignment_initEntries();
    return Alignment_CENTER_instance;
  }
  function Alignment_JUSTIFY_getInstance() {
    Alignment_initEntries();
    return Alignment_JUSTIFY_instance;
  }
  function Alignment_START_getInstance() {
    Alignment_initEntries();
    return Alignment_START_instance;
  }
  function Alignment_END_getInstance() {
    Alignment_initEntries();
    return Alignment_END_instance;
  }
  var BaselineMode_ALPHABETIC_instance;
  var BaselineMode_IDEOGRAPHIC_instance;
  var BaselineMode_entriesInitialized;
  function BaselineMode_initEntries() {
    if (BaselineMode_entriesInitialized)
      return Unit_instance;
    BaselineMode_entriesInitialized = true;
    BaselineMode_ALPHABETIC_instance = new BaselineMode('ALPHABETIC', 0);
    BaselineMode_IDEOGRAPHIC_instance = new BaselineMode('IDEOGRAPHIC', 1);
  }
  function BaselineMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function BaselineMode_ALPHABETIC_getInstance() {
    BaselineMode_initEntries();
    return BaselineMode_ALPHABETIC_instance;
  }
  var DecorationLineStyle_SOLID_instance;
  var DecorationLineStyle_DOUBLE_instance;
  var DecorationLineStyle_DOTTED_instance;
  var DecorationLineStyle_DASHED_instance;
  var DecorationLineStyle_WAVY_instance;
  var DecorationLineStyle_entriesInitialized;
  function DecorationLineStyle_initEntries() {
    if (DecorationLineStyle_entriesInitialized)
      return Unit_instance;
    DecorationLineStyle_entriesInitialized = true;
    DecorationLineStyle_SOLID_instance = new DecorationLineStyle('SOLID', 0);
    DecorationLineStyle_DOUBLE_instance = new DecorationLineStyle('DOUBLE', 1);
    DecorationLineStyle_DOTTED_instance = new DecorationLineStyle('DOTTED', 2);
    DecorationLineStyle_DASHED_instance = new DecorationLineStyle('DASHED', 3);
    DecorationLineStyle_WAVY_instance = new DecorationLineStyle('WAVY', 4);
  }
  function DecorationLineStyle(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function DecorationLineStyle_SOLID_getInstance() {
    DecorationLineStyle_initEntries();
    return DecorationLineStyle_SOLID_instance;
  }
  function DecorationLineStyle_DOUBLE_getInstance() {
    DecorationLineStyle_initEntries();
    return DecorationLineStyle_DOUBLE_instance;
  }
  function DecorationLineStyle_DOTTED_getInstance() {
    DecorationLineStyle_initEntries();
    return DecorationLineStyle_DOTTED_instance;
  }
  function DecorationLineStyle_DASHED_getInstance() {
    DecorationLineStyle_initEntries();
    return DecorationLineStyle_DASHED_instance;
  }
  function DecorationLineStyle_WAVY_getInstance() {
    DecorationLineStyle_initEntries();
    return DecorationLineStyle_WAVY_instance;
  }
  function Companion_41() {
    Companion_instance_41 = this;
    this.p60_1 = new DecorationStyle(false, false, false, true, -16777216, DecorationLineStyle_SOLID_getInstance(), 1.0);
  }
  var Companion_instance_41;
  function Companion_getInstance_41() {
    if (Companion_instance_41 == null)
      new Companion_41();
    return Companion_instance_41;
  }
  function DecorationStyle(_underline, _overline, _lineThrough, _gaps, color, lineStyle, thicknessMultiplier) {
    Companion_getInstance_41();
    this.q60_1 = _underline;
    this.r60_1 = _overline;
    this.s60_1 = _lineThrough;
    this.t60_1 = _gaps;
    this.u60_1 = color;
    this.v60_1 = lineStyle;
    this.w60_1 = thicknessMultiplier;
  }
  protoOf(DecorationStyle).x60 = function () {
    return this.v60_1;
  };
  protoOf(DecorationStyle).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof DecorationStyle))
      return false;
    if (!(this.q60_1 === other.q60_1))
      return false;
    if (!(this.r60_1 === other.r60_1))
      return false;
    if (!(this.s60_1 === other.s60_1))
      return false;
    if (!(this.t60_1 === other.t60_1))
      return false;
    if (!(this.u60_1 === other.u60_1))
      return false;
    if (!(compareTo(this.w60_1, other.w60_1) === 0))
      return false;
    return this.x60().equals(other.x60());
  };
  protoOf(DecorationStyle).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + (this.q60_1 ? 79 : 97) | 0;
    result = imul(result, PRIME) + (this.r60_1 ? 79 : 97) | 0;
    result = imul(result, PRIME) + (this.s60_1 ? 79 : 97) | 0;
    result = imul(result, PRIME) + (this.t60_1 ? 79 : 97) | 0;
    result = imul(result, PRIME) + this.u60_1 | 0;
    result = imul(result, PRIME) + toBits(this.w60_1) | 0;
    result = imul(result, PRIME) + this.x60().hashCode() | 0;
    return result;
  };
  protoOf(DecorationStyle).toString = function () {
    return 'DecorationStyle(_underline=' + this.q60_1 + ', _overline=' + this.r60_1 + ', _lineThrough=' + this.s60_1 + ', _gaps=' + this.t60_1 + ', _color=' + this.u60_1 + ', _lineStyle=' + this.x60().toString() + ', _thicknessMultiplier=' + this.w60_1 + ')';
  };
  var Direction_RTL_instance;
  var Direction_LTR_instance;
  function values_7() {
    return [Direction_RTL_getInstance(), Direction_LTR_getInstance()];
  }
  function get_entries_7() {
    if ($ENTRIES_7 == null)
      $ENTRIES_7 = enumEntries(values_7());
    return $ENTRIES_7;
  }
  var Direction_entriesInitialized;
  function Direction_initEntries() {
    if (Direction_entriesInitialized)
      return Unit_instance;
    Direction_entriesInitialized = true;
    Direction_RTL_instance = new Direction('RTL', 0);
    Direction_LTR_instance = new Direction('LTR', 1);
  }
  var $ENTRIES_7;
  function Direction(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Direction_RTL_getInstance() {
    Direction_initEntries();
    return Direction_RTL_instance;
  }
  function Direction_LTR_getInstance() {
    Direction_initEntries();
    return Direction_LTR_instance;
  }
  function Companion_42() {
    Companion_instance_42 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_42;
  function Companion_getInstance_42() {
    if (Companion_instance_42 == null)
      new Companion_42();
    return Companion_instance_42;
  }
  function FontCollection_init_$Init$($this) {
    FontCollection.call($this, org_jetbrains_skia_paragraph_FontCollection__1nMake());
    Stats_instance.k5h();
    return $this;
  }
  function FontCollection_init_$Create$() {
    return FontCollection_init_$Init$(objectCreate(protoOf(FontCollection)));
  }
  function FontCollection(ptr) {
    Companion_getInstance_42();
    RefCnt_init_$Init$(ptr, this);
  }
  protoOf(FontCollection).a61 = function (fontMgr) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_FontCollection__1nSetAssetFontManager(this.n5h_1, getPtr(fontMgr), Companion_instance_63.s5h());
      tmp = this;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(fontMgr);
    }
    return tmp;
  };
  protoOf(FontCollection).b61 = function (fontMgr) {
    return this.c61(fontMgr, null);
  };
  protoOf(FontCollection).c61 = function (fontMgr, defaultFamilyName) {
    var tmp;
    try {
      Stats_instance.k5h();
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          org_jetbrains_skia_paragraph_FontCollection__1nSetDefaultFontManager(this.n5h_1, getPtr(fontMgr), $this$interopScope.y5i(defaultFamilyName));
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
      tmp = this;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(fontMgr);
    }
    return tmp;
  };
  protoOf(FontCollection).d61 = function (familyNames, style) {
    var tmp;
    try {
      Stats_instance.k5h();
      // Inline function 'org.jetbrains.skia.arrayDecoderScope' call
      var arrayDecoder = null;
      var tmp_0;
      try {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'org.jetbrains.skia.impl.interopScope' call
          try {
            var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
            access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
            var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
            var tmp_1 = this.n5h_1;
            var tmp_2 = $this$interopScope.e61(familyNames);
            var tmp1_elvis_lhs = familyNames == null ? null : familyNames.length;
            tmp$ret$2 = org_jetbrains_skia_paragraph_FontCollection__1nFindTypefaces(tmp_1, tmp_2, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs, style.b5p_1);
            break $l$block;
          }finally {
            var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
            access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
            if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
              access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
            }
          }
        }
        arrayDecoder = new ArrayDecoder(tmp$ret$2, org_jetbrains_skia_impl_RefCnt__getFinalizer());
        var arrayDecoder_0 = arrayDecoder;
        // Inline function 'kotlin.collections.map' call
        var this_0 = until(0, arrayDecoder_0.n1());
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var inductionVariable = this_0.x1_1;
        var last = this_0.y1_1;
        if (inductionVariable <= last)
          do {
            var item = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var i = item;
            var tmp$ret$7 = new Typeface(arrayDecoder_0.p5u(i));
            destination.j1(tmp$ret$7);
          }
           while (!(item === last));
        // Inline function 'kotlin.collections.toTypedArray' call
        tmp_0 = copyToArray(destination);
      }finally {
        var tmp0_safe_receiver = arrayDecoder;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.s1d();
        }
      }
      tmp = tmp_0;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  var HeightMode_ALL_instance;
  var HeightMode_DISABLE_FIRST_ASCENT_instance;
  var HeightMode_DISABLE_LAST_DESCENT_instance;
  var HeightMode_DISABLE_ALL_instance;
  var HeightMode_entriesInitialized;
  function HeightMode_initEntries() {
    if (HeightMode_entriesInitialized)
      return Unit_instance;
    HeightMode_entriesInitialized = true;
    HeightMode_ALL_instance = new HeightMode('ALL', 0);
    HeightMode_DISABLE_FIRST_ASCENT_instance = new HeightMode('DISABLE_FIRST_ASCENT', 1);
    HeightMode_DISABLE_LAST_DESCENT_instance = new HeightMode('DISABLE_LAST_DESCENT', 2);
    HeightMode_DISABLE_ALL_instance = new HeightMode('DISABLE_ALL', 3);
  }
  function HeightMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function HeightMode_ALL_getInstance() {
    HeightMode_initEntries();
    return HeightMode_ALL_instance;
  }
  function HeightMode_DISABLE_FIRST_ASCENT_getInstance() {
    HeightMode_initEntries();
    return HeightMode_DISABLE_FIRST_ASCENT_instance;
  }
  function HeightMode_DISABLE_LAST_DESCENT_getInstance() {
    HeightMode_initEntries();
    return HeightMode_DISABLE_LAST_DESCENT_instance;
  }
  function HeightMode_DISABLE_ALL_getInstance() {
    HeightMode_initEntries();
    return HeightMode_DISABLE_ALL_instance;
  }
  function Companion_43() {
  }
  protoOf(Companion_43).f61 = function (array) {
    return org_jetbrains_skia_paragraph_LineMetrics__1nGetArraySize(array);
  };
  protoOf(Companion_43).g61 = function (array) {
    return org_jetbrains_skia_paragraph_LineMetrics__1nDisposeArray(array);
  };
  protoOf(Companion_43).h61 = function (array, index) {
    var intArray = new Int32Array(6);
    var doubleArray = new Float64Array(7);
    // Inline function 'org.jetbrains.skia.impl.withResult' call
    $l$block_0: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        var handle = $this$interopScope.a5h(intArray);
        // Inline function 'org.jetbrains.skia.impl.withResult' call
        $l$block: {
          // Inline function 'org.jetbrains.skia.impl.interopScope' call
          try {
            var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
            access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 + 1 | 0);
            var $this$interopScope_0 = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
            var handle_0 = $this$interopScope_0.i61(doubleArray);
            org_jetbrains_skia_paragraph_LineMetrics__1nGetArrayElement(array, index, handle, handle_0);
            $this$interopScope_0.j61(handle_0, doubleArray);
            break $l$block;
          }finally {
            var _unary__edvuaz_1 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
            access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_1 - 1 | 0);
            if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
              access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
            }
          }
        }
        $this$interopScope.b5h(handle, intArray);
        break $l$block_0;
      }finally {
        var _unary__edvuaz_2 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_2 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return new LineMetrics(intArray[0], intArray[1], intArray[2], intArray[3], !(intArray[4] === 0), doubleArray[0], doubleArray[1], doubleArray[2], doubleArray[3], doubleArray[4], doubleArray[5], doubleArray[6], intArray[5]);
  };
  var Companion_instance_43;
  function Companion_getInstance_43() {
    return Companion_instance_43;
  }
  function LineMetrics(startIndex, endIndex, endExcludingWhitespaces, endIncludingNewline, isHardBreak, ascent, descent, unscaledAscent, height, width, left, baseline, lineNumber) {
    this.k61_1 = startIndex;
    this.l61_1 = endIndex;
    this.m61_1 = endExcludingWhitespaces;
    this.n61_1 = endIncludingNewline;
    this.o61_1 = isHardBreak;
    this.p61_1 = ascent;
    this.q61_1 = descent;
    this.r61_1 = unscaledAscent;
    this.s61_1 = height;
    this.t61_1 = width;
    this.u61_1 = left;
    this.v61_1 = baseline;
    this.w61_1 = lineNumber;
  }
  protoOf(LineMetrics).x61 = function () {
    return this.u61_1 + this.t61_1;
  };
  protoOf(LineMetrics).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof LineMetrics))
      return false;
    if (!(this.k61_1 === other.k61_1))
      return false;
    if (!(this.l61_1 === other.l61_1))
      return false;
    if (!(this.m61_1 === other.m61_1))
      return false;
    if (!(this.n61_1 === other.n61_1))
      return false;
    if (!(this.o61_1 === other.o61_1))
      return false;
    if (!(compareTo(this.p61_1, other.p61_1) === 0))
      return false;
    if (!(compareTo(this.q61_1, other.q61_1) === 0))
      return false;
    if (!(compareTo(this.r61_1, other.r61_1) === 0))
      return false;
    if (!(compareTo(this.s61_1, other.s61_1) === 0))
      return false;
    if (!(compareTo(this.t61_1, other.t61_1) === 0))
      return false;
    if (!(compareTo(this.u61_1, other.u61_1) === 0))
      return false;
    if (!(compareTo(this.v61_1, other.v61_1) === 0))
      return false;
    return this.w61_1 === other.w61_1;
  };
  protoOf(LineMetrics).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + this.k61_1 | 0;
    result = imul(result, PRIME) + this.l61_1 | 0;
    result = imul(result, PRIME) + this.m61_1 | 0;
    result = imul(result, PRIME) + this.n61_1 | 0;
    result = imul(result, PRIME) + (this.o61_1 ? 79 : 97) | 0;
    result = imul(result, PRIME) + convertToInt(toBits_0(this.p61_1)) | 0;
    result = imul(result, PRIME) + convertToInt(toBits_0(this.q61_1)) | 0;
    result = imul(result, PRIME) + convertToInt(toBits_0(this.r61_1)) | 0;
    result = imul(result, PRIME) + convertToInt(toBits_0(this.s61_1)) | 0;
    result = imul(result, PRIME) + convertToInt(toBits_0(this.t61_1)) | 0;
    result = imul(result, PRIME) + convertToInt(toBits_0(this.u61_1)) | 0;
    result = imul(result, PRIME) + convertToInt(toBits_0(this.v61_1)) | 0;
    result = imul(result, PRIME) + this.w61_1 | 0;
    return result;
  };
  protoOf(LineMetrics).toString = function () {
    return 'LineMetrics(_startIndex=' + this.k61_1 + ', _endIndex=' + this.l61_1 + ', _endExcludingWhitespaces=' + this.m61_1 + ', _endIncludingNewline=' + this.n61_1 + ', _hardBreak=' + this.o61_1 + ', _ascent=' + this.p61_1 + ', _descent=' + this.q61_1 + ', _unscaledAscent=' + this.r61_1 + ', _height=' + this.s61_1 + ', _width=' + this.t61_1 + ', _left=' + this.u61_1 + ', _baseline=' + this.v61_1 + ', _lineNumber=' + this.w61_1 + ')';
  };
  function Companion_44() {
    Companion_instance_44 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_44;
  function Companion_getInstance_44() {
    if (Companion_instance_44 == null)
      new Companion_44();
    return Companion_instance_44;
  }
  function _FinalizerHolder_15() {
    _FinalizerHolder_instance_15 = this;
    this.y61_1 = org_jetbrains_skia_paragraph_Paragraph__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_15;
  function _FinalizerHolder_getInstance_15() {
    if (_FinalizerHolder_instance_15 == null)
      new _FinalizerHolder_15();
    return _FinalizerHolder_instance_15;
  }
  function Paragraph$getWordBoundary$lambda(this$0, $offset) {
    return function ($this$fromInteropPointer, it) {
      org_jetbrains_skia_paragraph_Paragraph__1nGetWordBoundary(this$0.n5h_1, $offset, it);
      return Unit_instance;
    };
  }
  function Paragraph(ptr, text) {
    Companion_getInstance_44();
    Managed.call(this, ptr, _FinalizerHolder_getInstance_15().y61_1);
    Stats_instance.k5h();
    this.b62_1 = text;
  }
  protoOf(Paragraph).j4 = function () {
    if (!(this.b62_1 == null)) {
      ensureNotNull(this.b62_1).j4();
      this.b62_1 = null;
    }
    protoOf(Managed).j4.call(this);
  };
  protoOf(Paragraph).i5e = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_paragraph_Paragraph__1nGetHeight(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paragraph).c62 = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_paragraph_Paragraph__1nGetMinIntrinsicWidth(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paragraph).d62 = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_paragraph_Paragraph__1nGetMaxIntrinsicWidth(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paragraph).e62 = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_paragraph_Paragraph__1nGetAlphabeticBaseline(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paragraph).f62 = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_paragraph_Paragraph__1nDidExceedMaxLines(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paragraph).g62 = function (width) {
    Stats_instance.k5h();
    org_jetbrains_skia_paragraph_Paragraph__1nLayout(this.n5h_1, width);
    return this;
  };
  protoOf(Paragraph).h62 = function (canvas, x, y) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_Paragraph__1nPaint(this.n5h_1, getPtr(canvas), x, y);
      tmp = this;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(canvas);
    }
    return tmp;
  };
  protoOf(Paragraph).i62 = function (start, end, rectHeightMode, rectWidthMode) {
    var tmp;
    try {
      Stats_instance.k5h();
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          // Inline function 'org.jetbrains.skia.impl.InteropScope.fromInterop' call
          var this_0 = org_jetbrains_skia_paragraph_Paragraph__1nGetRectsForRange(this.n5h_1, start, end, rectHeightMode.a1_1, rectWidthMode.a1_1);
          var size = Companion_instance_48.f61(this_0);
          var tmp_0 = 0;
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_1 = Array(size);
          while (tmp_0 < size) {
            var tmp_2 = tmp_0;
            tmp_1[tmp_2] = Companion_instance_48.h61(this_0, tmp_2);
            tmp_0 = tmp_0 + 1 | 0;
          }
          var result = tmp_1;
          Companion_instance_48.g61(this_0);
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
      tmp = result;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paragraph).j62 = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          // Inline function 'org.jetbrains.skia.impl.InteropScope.fromInterop' call
          var this_0 = org_jetbrains_skia_paragraph_Paragraph__1nGetRectsForPlaceholders(this.n5h_1);
          var size = Companion_instance_48.f61(this_0);
          var tmp_0 = 0;
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_1 = Array(size);
          while (tmp_0 < size) {
            var tmp_2 = tmp_0;
            tmp_1[tmp_2] = Companion_instance_48.h61(this_0, tmp_2);
            tmp_0 = tmp_0 + 1 | 0;
          }
          var result = tmp_1;
          Companion_instance_48.g61(this_0);
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
      tmp = result;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paragraph).k62 = function (dx, dy) {
    var tmp;
    try {
      Stats_instance.k5h();
      var res = org_jetbrains_skia_paragraph_Paragraph__1nGetGlyphPositionAtCoordinate(this.n5h_1, dx, dy);
      tmp = res >= 0 ? new PositionWithAffinity(res, Affinity_DOWNSTREAM_getInstance()) : new PositionWithAffinity((-res | 0) - 1 | 0, Affinity_UPSTREAM_getInstance());
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paragraph).l62 = function (offset) {
    var tmp;
    try {
      Stats_instance.k5h();
      var tmp_0 = Companion_instance_20;
      tmp = fromInteropPointer_0(tmp_0, Paragraph$getWordBoundary$lambda(this, offset));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paragraph).m62 = function () {
    var tmp;
    try {
      var tmp_0;
      if (this.b62_1 == null) {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = [];
      } else {
        Stats_instance.k5h();
        $l$block: {
          // Inline function 'org.jetbrains.skia.impl.interopScope' call
          try {
            var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
            access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
            // Inline function 'org.jetbrains.skia.impl.InteropScope.fromInterop' call
            var this_0 = org_jetbrains_skia_paragraph_Paragraph__1nGetLineMetrics(this.n5h_1, getPtr(this.b62_1));
            var size = Companion_instance_43.f61(this_0);
            var tmp_1 = 0;
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_2 = Array(size);
            while (tmp_1 < size) {
              var tmp_3 = tmp_1;
              tmp_2[tmp_3] = Companion_instance_43.h61(this_0, tmp_3);
              tmp_1 = tmp_1 + 1 | 0;
            }
            var result = tmp_2;
            Companion_instance_43.g61(this_0);
            break $l$block;
          }finally {
            var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
            access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
            if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
              access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
            }
          }
        }
        tmp_0 = result;
      }
      tmp = tmp_0;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(this.b62_1);
    }
    return tmp;
  };
  protoOf(Paragraph).n62 = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_paragraph_Paragraph__1nGetLineNumber(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(Paragraph).o62 = function () {
    Stats_instance.k5h();
    org_jetbrains_skia_paragraph_Paragraph__1nMarkDirty(this.n5h_1);
    return this;
  };
  protoOf(Paragraph).p62 = function (from, to, paint) {
    var tmp;
    try {
      if (!(this.b62_1 == null)) {
        Stats_instance.k5h();
        org_jetbrains_skia_paragraph_Paragraph__1nUpdateForegroundPaint(this.n5h_1, from, to, getPtr(paint), getPtr(this.b62_1));
      }
      tmp = this;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(paint);
      reachabilityBarrier(this.b62_1);
    }
    return tmp;
  };
  function Companion_45() {
    Companion_instance_45 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_45;
  function Companion_getInstance_45() {
    if (Companion_instance_45 == null)
      new Companion_45();
    return Companion_instance_45;
  }
  function _FinalizerHolder_16() {
    _FinalizerHolder_instance_16 = this;
    this.q62_1 = org_jetbrains_skia_paragraph_ParagraphBuilder__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_16;
  function _FinalizerHolder_getInstance_16() {
    if (_FinalizerHolder_instance_16 == null)
      new _FinalizerHolder_16();
    return _FinalizerHolder_instance_16;
  }
  function ParagraphBuilder(style, fc) {
    Companion_getInstance_45();
    Managed.call(this, makeParagraphBuilder(style, fc), _FinalizerHolder_getInstance_16().q62_1);
    this.t62_1 = null;
  }
  protoOf(ParagraphBuilder).u62 = function (style) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_ParagraphBuilder__1nPushStyle(this.n5h_1, getPtr(style));
      tmp = this;
    }finally {
      reachabilityBarrier(style);
    }
    return tmp;
  };
  protoOf(ParagraphBuilder).v62 = function (text) {
    Stats_instance.k5h();
    try {
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          org_jetbrains_skia_paragraph_ParagraphBuilder__1nAddText(this.n5h_1, $this$interopScope.y5i(text));
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
    }finally {
      reachabilityBarrier(this);
    }
    if (this.t62_1 == null) {
      this.t62_1 = ManagedString_init_$Create$(text);
    } else
      ensureNotNull(this.t62_1).o5q(text);
    return this;
  };
  protoOf(ParagraphBuilder).w62 = function (style) {
    // Inline function 'kotlin.check' call
    if (!!isNaN_0(style.x62_1)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    // Inline function 'kotlin.check' call
    if (!!isNaN_0(style.y62_1)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    // Inline function 'kotlin.check' call
    if (!!isNaN_0(style.b63_1)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_ParagraphBuilder__1nAddPlaceholder(this.n5h_1, style.x62_1, style.y62_1, style.c63().a1_1, style.d63().a1_1, style.b63_1);
    }finally {
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(ParagraphBuilder).g3d = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      var paragraph = new Paragraph(org_jetbrains_skia_paragraph_ParagraphBuilder__1nBuild(this.n5h_1), this.t62_1);
      this.t62_1 = null;
      tmp = paragraph;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  function makeParagraphBuilder(style, fc) {
    Stats_instance.k5h();
    var tmp;
    try {
      tmp = org_jetbrains_skia_paragraph_ParagraphBuilder__1nMake(getPtr(style), getPtr(fc));
    }finally {
      reachabilityBarrier(style);
      reachabilityBarrier(fc);
    }
    return tmp;
  }
  function Companion_46() {
    Companion_instance_46 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_46;
  function Companion_getInstance_46() {
    if (Companion_instance_46 == null)
      new Companion_46();
    return Companion_instance_46;
  }
  function _FinalizerHolder_17() {
    _FinalizerHolder_instance_17 = this;
    this.e63_1 = org_jetbrains_skia_paragraph_ParagraphStyle__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_17;
  function _FinalizerHolder_getInstance_17() {
    if (_FinalizerHolder_instance_17 == null)
      new _FinalizerHolder_17();
    return _FinalizerHolder_instance_17;
  }
  function ParagraphStyle() {
    Companion_getInstance_46();
    Managed.call(this, org_jetbrains_skia_paragraph_ParagraphStyle__1nMake(), _FinalizerHolder_getInstance_17().e63_1);
    Stats_instance.k5h();
  }
  protoOf(ParagraphStyle).o5h = function (other) {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_paragraph_ParagraphStyle__1nEquals(this.n5h_1, getPtr(other));
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(other);
    }
    return tmp;
  };
  protoOf(ParagraphStyle).h63 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_ParagraphStyle__1nSetReplaceTabCharacters(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(ParagraphStyle).i63 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_ParagraphStyle__1nSetTextStyle(this.n5h_1, getPtr(value));
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(value);
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(ParagraphStyle).j63 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_ParagraphStyle__1nSetDirection(this.n5h_1, value.a1_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(ParagraphStyle).k63 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_ParagraphStyle__1nSetAlignment(this.n5h_1, value.a1_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(ParagraphStyle).l63 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_ParagraphStyle__1nSetMaxLinesCount(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(ParagraphStyle).m63 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          org_jetbrains_skia_paragraph_ParagraphStyle__1nSetEllipsis(this.n5h_1, $this$interopScope.y5i(value));
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(ParagraphStyle).n63 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_ParagraphStyle__1nSetHeightMode(this.n5h_1, value.a1_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(ParagraphStyle).o63 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_ParagraphStyle__1nSetTextIndent(this.n5h_1, value.p63_1, value.q63_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  var PlaceholderAlignment_BASELINE_instance;
  var PlaceholderAlignment_ABOVE_BASELINE_instance;
  var PlaceholderAlignment_BELOW_BASELINE_instance;
  var PlaceholderAlignment_TOP_instance;
  var PlaceholderAlignment_BOTTOM_instance;
  var PlaceholderAlignment_MIDDLE_instance;
  var PlaceholderAlignment_entriesInitialized;
  function PlaceholderAlignment_initEntries() {
    if (PlaceholderAlignment_entriesInitialized)
      return Unit_instance;
    PlaceholderAlignment_entriesInitialized = true;
    PlaceholderAlignment_BASELINE_instance = new PlaceholderAlignment('BASELINE', 0);
    PlaceholderAlignment_ABOVE_BASELINE_instance = new PlaceholderAlignment('ABOVE_BASELINE', 1);
    PlaceholderAlignment_BELOW_BASELINE_instance = new PlaceholderAlignment('BELOW_BASELINE', 2);
    PlaceholderAlignment_TOP_instance = new PlaceholderAlignment('TOP', 3);
    PlaceholderAlignment_BOTTOM_instance = new PlaceholderAlignment('BOTTOM', 4);
    PlaceholderAlignment_MIDDLE_instance = new PlaceholderAlignment('MIDDLE', 5);
  }
  function PlaceholderAlignment(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function PlaceholderAlignment_ABOVE_BASELINE_getInstance() {
    PlaceholderAlignment_initEntries();
    return PlaceholderAlignment_ABOVE_BASELINE_instance;
  }
  function PlaceholderAlignment_TOP_getInstance() {
    PlaceholderAlignment_initEntries();
    return PlaceholderAlignment_TOP_instance;
  }
  function PlaceholderAlignment_BOTTOM_getInstance() {
    PlaceholderAlignment_initEntries();
    return PlaceholderAlignment_BOTTOM_instance;
  }
  function PlaceholderAlignment_MIDDLE_getInstance() {
    PlaceholderAlignment_initEntries();
    return PlaceholderAlignment_MIDDLE_instance;
  }
  function PlaceholderStyle(width, height, alignment, baselineMode, baseline) {
    this.x62_1 = width;
    this.y62_1 = height;
    this.z62_1 = alignment;
    this.a63_1 = baselineMode;
    this.b63_1 = baseline;
  }
  protoOf(PlaceholderStyle).c63 = function () {
    return this.z62_1;
  };
  protoOf(PlaceholderStyle).d63 = function () {
    return this.a63_1;
  };
  protoOf(PlaceholderStyle).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof PlaceholderStyle))
      return false;
    if (!(compareTo(this.x62_1, other.x62_1) === 0))
      return false;
    if (!(compareTo(this.y62_1, other.y62_1) === 0))
      return false;
    if (!(compareTo(this.b63_1, other.b63_1) === 0))
      return false;
    if (!this.c63().equals(other.c63()))
      return false;
    return this.d63().equals(other.d63());
  };
  protoOf(PlaceholderStyle).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + toBits(this.x62_1) | 0;
    result = imul(result, PRIME) + toBits(this.y62_1) | 0;
    result = imul(result, PRIME) + toBits(this.b63_1) | 0;
    result = imul(result, PRIME) + this.c63().hashCode() | 0;
    result = imul(result, PRIME) + this.d63().hashCode() | 0;
    return result;
  };
  protoOf(PlaceholderStyle).toString = function () {
    return 'PlaceholderStyle(_width=' + this.x62_1 + ', _height=' + this.y62_1 + ', _alignment=' + this.c63().toString() + ', _baselineMode=' + this.d63().toString() + ', _baseline=' + this.b63_1 + ')';
  };
  function PositionWithAffinity(position, affinity) {
    this.r63_1 = position;
    this.s63_1 = affinity;
  }
  protoOf(PositionWithAffinity).t63 = function () {
    return this.s63_1;
  };
  protoOf(PositionWithAffinity).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof PositionWithAffinity))
      return false;
    if (!(this.r63_1 === other.r63_1))
      return false;
    return this.t63().equals(other.t63());
  };
  protoOf(PositionWithAffinity).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + this.r63_1 | 0;
    result = imul(result, PRIME) + this.t63().hashCode() | 0;
    return result;
  };
  protoOf(PositionWithAffinity).toString = function () {
    return 'PositionWithAffinity(_position=' + this.r63_1 + ', _affinity=' + this.t63().toString() + ')';
  };
  var RectHeightMode_TIGHT_instance;
  var RectHeightMode_MAX_instance;
  var RectHeightMode_INCLUDE_LINE_SPACING_MIDDLE_instance;
  var RectHeightMode_INCLUDE_LINE_SPACING_TOP_instance;
  var RectHeightMode_INCLUDE_LINE_SPACING_BOTTOM_instance;
  var RectHeightMode_STRUT_instance;
  var RectHeightMode_entriesInitialized;
  function RectHeightMode_initEntries() {
    if (RectHeightMode_entriesInitialized)
      return Unit_instance;
    RectHeightMode_entriesInitialized = true;
    RectHeightMode_TIGHT_instance = new RectHeightMode('TIGHT', 0);
    RectHeightMode_MAX_instance = new RectHeightMode('MAX', 1);
    RectHeightMode_INCLUDE_LINE_SPACING_MIDDLE_instance = new RectHeightMode('INCLUDE_LINE_SPACING_MIDDLE', 2);
    RectHeightMode_INCLUDE_LINE_SPACING_TOP_instance = new RectHeightMode('INCLUDE_LINE_SPACING_TOP', 3);
    RectHeightMode_INCLUDE_LINE_SPACING_BOTTOM_instance = new RectHeightMode('INCLUDE_LINE_SPACING_BOTTOM', 4);
    RectHeightMode_STRUT_instance = new RectHeightMode('STRUT', 5);
  }
  function RectHeightMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function RectHeightMode_MAX_getInstance() {
    RectHeightMode_initEntries();
    return RectHeightMode_MAX_instance;
  }
  function RectHeightMode_STRUT_getInstance() {
    RectHeightMode_initEntries();
    return RectHeightMode_STRUT_instance;
  }
  var RectWidthMode_TIGHT_instance;
  var RectWidthMode_MAX_instance;
  var RectWidthMode_entriesInitialized;
  function RectWidthMode_initEntries() {
    if (RectWidthMode_entriesInitialized)
      return Unit_instance;
    RectWidthMode_entriesInitialized = true;
    RectWidthMode_TIGHT_instance = new RectWidthMode('TIGHT', 0);
    RectWidthMode_MAX_instance = new RectWidthMode('MAX', 1);
  }
  function RectWidthMode(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function RectWidthMode_TIGHT_getInstance() {
    RectWidthMode_initEntries();
    return RectWidthMode_TIGHT_instance;
  }
  function Companion_47() {
  }
  var Companion_instance_47;
  function Companion_getInstance_47() {
    return Companion_instance_47;
  }
  function Shadow(color, offsetX, offsetY, blurSigma) {
    this.u63_1 = color;
    this.v63_1 = offsetX;
    this.w63_1 = offsetY;
    this.x63_1 = blurSigma;
  }
  protoOf(Shadow).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof Shadow))
      return false;
    if (!(this.u63_1 === other.u63_1))
      return false;
    if (!(compareTo(this.v63_1, other.v63_1) === 0))
      return false;
    if (!(compareTo(this.w63_1, other.w63_1) === 0))
      return false;
    return compareTo(this.x63_1, other.x63_1) === 0;
  };
  protoOf(Shadow).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + this.u63_1 | 0;
    result = imul(result, PRIME) + toBits(this.v63_1) | 0;
    result = imul(result, PRIME) + toBits(this.w63_1) | 0;
    var blurSigma = toBits_0(this.x63_1);
    result = imul(result, PRIME) + convertToInt(bitwiseXor(shiftRightUnsigned(blurSigma, 32), blurSigma)) | 0;
    return result;
  };
  protoOf(Shadow).toString = function () {
    return 'Shadow(_color=' + this.u63_1 + ', _offsetX=' + this.v63_1 + ', _offsetY=' + this.w63_1 + ', _blurSigma=' + this.x63_1 + ')';
  };
  function TextBox_init_$Init$(l, t, r, b, direction, $this) {
    TextBox.call($this, Companion_instance_35.b5u(l, t, r, b), get_entries_7().l1(direction));
    return $this;
  }
  function TextBox_init_$Create$(l, t, r, b, direction) {
    return TextBox_init_$Init$(l, t, r, b, direction, objectCreate(protoOf(TextBox)));
  }
  function Companion_48() {
  }
  protoOf(Companion_48).h61 = function (array, index) {
    var rect = new Float32Array(4);
    var direction = new Int32Array(1);
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        var rectPtr = $this$interopScope.h5k(rect);
        var directionPtr = $this$interopScope.u5j(direction);
        org_jetbrains_skia_paragraph_TextBox__1nGetArrayElement(array, index, rectPtr, directionPtr);
        $this$interopScope.u5o(rectPtr, rect);
        $this$interopScope.b5h(directionPtr, direction);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return TextBox_init_$Create$(rect[0], rect[1], rect[2], rect[3], direction[0]);
  };
  protoOf(Companion_48).f61 = function (array) {
    return org_jetbrains_skia_paragraph_TextBox__1nGetArraySize(array);
  };
  protoOf(Companion_48).g61 = function (array) {
    return org_jetbrains_skia_paragraph_TextBox__1nDisposeArray(array);
  };
  var Companion_instance_48;
  function Companion_getInstance_48() {
    return Companion_instance_48;
  }
  function TextBox(rect, direction) {
    this.y63_1 = rect;
    this.z63_1 = direction;
  }
  protoOf(TextBox).a64 = function () {
    return this.z63_1;
  };
  protoOf(TextBox).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof TextBox))
      return false;
    if (!this.y63_1.equals(other.y63_1))
      return false;
    return this.a64().equals(other.a64());
  };
  protoOf(TextBox).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + this.y63_1.hashCode() | 0;
    result = imul(result, PRIME) + this.a64().hashCode() | 0;
    return result;
  };
  protoOf(TextBox).toString = function () {
    return 'TextBox(_rect=' + this.y63_1.toString() + ', _direction=' + this.a64().toString() + ')';
  };
  function TextIndent(firstLine, restLine) {
    firstLine = firstLine === VOID ? 0.0 : firstLine;
    restLine = restLine === VOID ? 0.0 : restLine;
    this.p63_1 = firstLine;
    this.q63_1 = restLine;
  }
  protoOf(TextIndent).toString = function () {
    return 'TextIndent(firstLine=' + this.p63_1 + ', restLine=' + this.q63_1 + ')';
  };
  protoOf(TextIndent).hashCode = function () {
    var result = getNumberHashCode(this.p63_1);
    result = imul(result, 31) + getNumberHashCode(this.q63_1) | 0;
    return result;
  };
  protoOf(TextIndent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TextIndent))
      return false;
    if (!equals(this.p63_1, other.p63_1))
      return false;
    if (!equals(this.q63_1, other.q63_1))
      return false;
    return true;
  };
  function Companion_49() {
    Companion_instance_49 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_49;
  function Companion_getInstance_49() {
    if (Companion_instance_49 == null)
      new Companion_49();
    return Companion_instance_49;
  }
  function TextStyle_init_$Init$($this) {
    TextStyle.call($this, org_jetbrains_skia_paragraph_TextStyle__1nMake());
    Stats_instance.k5h();
    return $this;
  }
  function TextStyle_init_$Create$() {
    return TextStyle_init_$Init$(objectCreate(protoOf(TextStyle)));
  }
  function _FinalizerHolder_18() {
    _FinalizerHolder_instance_18 = this;
    this.b64_1 = org_jetbrains_skia_paragraph_TextStyle__1nGetFinalizer();
  }
  var _FinalizerHolder_instance_18;
  function _FinalizerHolder_getInstance_18() {
    if (_FinalizerHolder_instance_18 == null)
      new _FinalizerHolder_18();
    return _FinalizerHolder_instance_18;
  }
  function TextStyle$_get_fontMetrics_$lambda_9osnwy(this$0) {
    return function ($this$fromInteropPointer, it) {
      org_jetbrains_skia_paragraph_TextStyle__1nGetFontMetrics(this$0.n5h_1, it);
      return Unit_instance;
    };
  }
  function TextStyle(ptr) {
    Companion_getInstance_49();
    Managed.call(this, ptr, _FinalizerHolder_getInstance_18().b64_1);
  }
  protoOf(TextStyle).o5h = function (other) {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = org_jetbrains_skia_paragraph_TextStyle__1nEquals(this.n5h_1, getPtr(other));
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(other);
    }
    return tmp;
  };
  protoOf(TextStyle).z5q = function (value) {
    this.e64(value);
  };
  protoOf(TextStyle).e64 = function (color) {
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_TextStyle__1nSetColor(this.n5h_1, color);
    }finally {
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(TextStyle).f64 = function (value) {
    this.g64(value);
  };
  protoOf(TextStyle).g64 = function (paint) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_TextStyle__1nSetForeground(this.n5h_1, getPtr(paint));
      tmp = this;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(paint);
    }
    return tmp;
  };
  protoOf(TextStyle).h64 = function (value) {
    this.i64(value);
  };
  protoOf(TextStyle).i64 = function (paint) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_TextStyle__1nSetBackground(this.n5h_1, getPtr(paint));
      tmp = this;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(paint);
    }
    return tmp;
  };
  protoOf(TextStyle).j64 = function (value) {
    this.k64(value);
  };
  protoOf(TextStyle).k64 = function (d) {
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_TextStyle__1nSetDecorationStyle(this.n5h_1, d.q60_1, d.r60_1, d.s60_1, d.t60_1, d.u60_1, d.v60_1.a1_1, d.w60_1);
    }finally {
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(TextStyle).l64 = function (value) {
    this.m64(value);
  };
  protoOf(TextStyle).c5v = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = FontStyle_init_$Create$_0(org_jetbrains_skia_paragraph_TextStyle__1nGetFontStyle(this.n5h_1));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(TextStyle).m64 = function (s) {
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_TextStyle__1nSetFontStyle(this.n5h_1, s.b5p_1);
    }finally {
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(TextStyle).n64 = function (s) {
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_TextStyle__1nAddShadow(this.n5h_1, s.u63_1, s.v63_1, s.w63_1, s.x63_1);
    }finally {
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(TextStyle).o64 = function (f) {
    try {
      Stats_instance.k5h();
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          org_jetbrains_skia_paragraph_TextStyle__1nAddFontFeature(this.n5h_1, $this$interopScope.y5i(f.c5o()), f.z5n_1);
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
    }finally {
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(TextStyle).p64 = function (FontFeatures) {
    var inductionVariable = 0;
    var last = FontFeatures.length;
    while (inductionVariable < last) {
      var s = FontFeatures[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.o64(s);
    }
    return this;
  };
  protoOf(TextStyle).q64 = function (value) {
    this.r64(value);
  };
  protoOf(TextStyle).r64 = function (size) {
    // Inline function 'kotlin.check' call
    if (!!isNaN_0(size)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_TextStyle__1nSetFontSize(this.n5h_1, size);
    }finally {
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(TextStyle).s64 = function (value) {
    this.t64(value);
  };
  protoOf(TextStyle).t64 = function (families) {
    Stats_instance.k5h();
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        var tmp = this.n5h_1;
        var tmp_0 = $this$interopScope.e61(families);
        var tmp1_elvis_lhs = families == null ? null : families.length;
        org_jetbrains_skia_paragraph_TextStyle__1nSetFontFamilies(tmp, tmp_0, tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    return this;
  };
  protoOf(TextStyle).u64 = function (value) {
    this.v64(value);
  };
  protoOf(TextStyle).v64 = function (height) {
    if (height == null) {
      try {
        Stats_instance.k5h();
        org_jetbrains_skia_paragraph_TextStyle__1nSetHeight(this.n5h_1, false, 0.0);
      }finally {
        reachabilityBarrier(this);
      }
    } else {
      // Inline function 'kotlin.check' call
      if (!!isNaN_0(height)) {
        throw IllegalStateException_init_$Create$('Check failed.');
      }
      try {
        Stats_instance.k5h();
        org_jetbrains_skia_paragraph_TextStyle__1nSetHeight(this.n5h_1, true, height);
      }finally {
        reachabilityBarrier(this);
      }
    }
    return this;
  };
  protoOf(TextStyle).w64 = function (value) {
    this.x64(value);
  };
  protoOf(TextStyle).x64 = function (topRatio) {
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_TextStyle__1nSetTopRatio(this.n5h_1, topRatio);
    }finally {
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(TextStyle).y64 = function (value) {
    this.z64(value);
  };
  protoOf(TextStyle).z64 = function (letterSpacing) {
    // Inline function 'kotlin.check' call
    if (!!isNaN_0(letterSpacing)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_TextStyle__1nSetLetterSpacing(this.n5h_1, letterSpacing);
    }finally {
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(TextStyle).a65 = function (value) {
    this.b65(value);
  };
  protoOf(TextStyle).b65 = function (baselineShift) {
    // Inline function 'kotlin.check' call
    if (!!isNaN_0(baselineShift)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_TextStyle__1nSetBaselineShift(this.n5h_1, baselineShift);
    }finally {
      reachabilityBarrier(this);
    }
    return this;
  };
  protoOf(TextStyle).c65 = function (value) {
    this.d65(value);
  };
  protoOf(TextStyle).d65 = function (typeface) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_TextStyle__1nSetTypeface(this.n5h_1, getPtr(typeface));
      tmp = this;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(typeface);
    }
    return tmp;
  };
  protoOf(TextStyle).e65 = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      var tmp_0 = Companion_instance_14;
      tmp = fromInteropPointer(tmp_0, TextStyle$_get_fontMetrics_$lambda_9osnwy(this));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(TextStyle).f65 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_TextStyle__1nSetFontEdging(this.n5h_1, value.a1_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(TextStyle).g65 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_TextStyle__1nSetSubpixel(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(TextStyle).h65 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_paragraph_TextStyle__1nSetFontHinting(this.n5h_1, value.a1_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  function TypefaceFontProvider_init_$Init$($this) {
    TypefaceFontProvider.call($this, org_jetbrains_skia_paragraph_TypefaceFontProvider__1nMake());
    return $this;
  }
  function TypefaceFontProvider_init_$Create$() {
    return TypefaceFontProvider_init_$Init$(objectCreate(protoOf(TypefaceFontProvider)));
  }
  function Companion_50() {
    Companion_instance_50 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_50;
  function Companion_getInstance_50() {
    if (Companion_instance_50 == null)
      new Companion_50();
    return Companion_instance_50;
  }
  function TypefaceFontProvider(ptr) {
    Companion_getInstance_50();
    FontMgr_init_$Init$(ptr, this);
    Stats_instance.k5h();
  }
  function TypefaceFontProviderWithFallback_init_$Init$($this) {
    TypefaceFontProviderWithFallback.call($this, org_jetbrains_skia_paragraph_TypefaceFontProviderWithFallback__1nMakeAsFallbackProvider());
    return $this;
  }
  function TypefaceFontProviderWithFallback_init_$Create$() {
    return TypefaceFontProviderWithFallback_init_$Init$(objectCreate(protoOf(TypefaceFontProviderWithFallback)));
  }
  function Companion_51() {
    Companion_instance_51 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_51;
  function Companion_getInstance_51() {
    if (Companion_instance_51 == null)
      new Companion_51();
    return Companion_instance_51;
  }
  function TypefaceFontProviderWithFallback(ptr) {
    Companion_getInstance_51();
    TypefaceFontProvider.call(this, ptr);
    Stats_instance.k5h();
  }
  protoOf(TypefaceFontProviderWithFallback).k65 = function (typeface, alias) {
    var tmp;
    try {
      Stats_instance.k5h();
      $l$block: {
        // Inline function 'org.jetbrains.skia.impl.interopScope' call
        try {
          var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
          var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
          org_jetbrains_skia_paragraph_TypefaceFontProviderWithFallback__1nRegisterTypefaceForFallback(this.n5h_1, getPtr(typeface), $this$interopScope.y5i(alias));
          break $l$block;
        }finally {
          var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
          access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
          if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
            access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
          }
        }
      }
      tmp = this;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(typeface);
    }
    return tmp;
  };
  function Companion_52() {
    Companion_instance_52 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_52;
  function Companion_getInstance_52() {
    if (Companion_instance_52 == null)
      new Companion_52();
    return Companion_instance_52;
  }
  function SVGContainer(ptr) {
    Companion_getInstance_52();
    SVGTransformableNode.call(this, ptr);
  }
  function Companion_53() {
    Companion_instance_53 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_53;
  function Companion_getInstance_53() {
    if (Companion_instance_53 == null)
      new Companion_53();
    return Companion_instance_53;
  }
  function SVGDOM_init_$Init$(data, $this) {
    SVGDOM.call($this, makeSVGDOM(data));
    return $this;
  }
  function SVGDOM_init_$Create$(data) {
    return SVGDOM_init_$Init$(data, objectCreate(protoOf(SVGDOM)));
  }
  function SVGDOM(ptr) {
    Companion_getInstance_53();
    RefCnt_init_$Init$(ptr, this);
  }
  protoOf(SVGDOM).n65 = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      var ptr = org_jetbrains_skia_svg_SVGDOM__1nGetRoot(this.n5h_1);
      tmp = ptr === Companion_instance_63.s5h() ? null : new SVGSVG(ptr);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(SVGDOM).o65 = function (canvas) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_svg_SVGDOM__1nRender(this.n5h_1, getPtr(canvas));
      tmp = this;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(canvas);
    }
    return tmp;
  };
  function makeSVGDOM(data) {
    Stats_instance.k5h();
    var tmp;
    try {
      tmp = org_jetbrains_skia_svg_SVGDOM__1nMakeFromData(getPtr(data));
    }finally {
      reachabilityBarrier(data);
    }
    return tmp;
  }
  function Companion_54() {
  }
  protoOf(Companion_54).p65 = function (block) {
    // Inline function 'org.jetbrains.skia.impl.withResult' call
    var result = new Int32Array(2);
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        var handle = $this$interopScope.a5h(result);
        block($this$interopScope, handle);
        $this$interopScope.b5h(handle, result);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.fromBits' call
    var bits = result[0];
    var tmp$ret$5 = floatFromBits(bits);
    return SVGLength_init_$Create$(tmp$ret$5, result[1]);
  };
  var Companion_instance_54;
  function Companion_getInstance_54() {
    return Companion_instance_54;
  }
  function SVGLength_init_$Init$(value, unit, $this) {
    SVGLength.call($this, value, get_entries_8().l1(unit));
    return $this;
  }
  function SVGLength_init_$Create$(value, unit) {
    return SVGLength_init_$Init$(value, unit, objectCreate(protoOf(SVGLength)));
  }
  function SVGLength(value, unit) {
    this.q65_1 = value;
    this.r65_1 = unit;
  }
  protoOf(SVGLength).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof SVGLength))
      return false;
    if (!(compareTo(this.q65_1, other.q65_1) === 0))
      return false;
    return this.r65_1.equals(other.r65_1);
  };
  protoOf(SVGLength).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + toBits(this.q65_1) | 0;
    result = imul(result, PRIME) + this.r65_1.hashCode() | 0;
    return result;
  };
  protoOf(SVGLength).toString = function () {
    return 'SVGLength(_value=' + this.q65_1 + ', _unit=' + this.r65_1.toString() + ')';
  };
  protoOf(SVGLength).s65 = function (_unit) {
    return this.r65_1 === _unit ? this : new SVGLength(this.q65_1, _unit);
  };
  var SVGLengthUnit_UNKNOWN_instance;
  var SVGLengthUnit_NUMBER_instance;
  var SVGLengthUnit_PERCENTAGE_instance;
  var SVGLengthUnit_EMS_instance;
  var SVGLengthUnit_EXS_instance;
  var SVGLengthUnit_PX_instance;
  var SVGLengthUnit_CM_instance;
  var SVGLengthUnit_MM_instance;
  var SVGLengthUnit_IN_instance;
  var SVGLengthUnit_PT_instance;
  var SVGLengthUnit_PC_instance;
  function values_8() {
    return [SVGLengthUnit_UNKNOWN_getInstance(), SVGLengthUnit_NUMBER_getInstance(), SVGLengthUnit_PERCENTAGE_getInstance(), SVGLengthUnit_EMS_getInstance(), SVGLengthUnit_EXS_getInstance(), SVGLengthUnit_PX_getInstance(), SVGLengthUnit_CM_getInstance(), SVGLengthUnit_MM_getInstance(), SVGLengthUnit_IN_getInstance(), SVGLengthUnit_PT_getInstance(), SVGLengthUnit_PC_getInstance()];
  }
  function get_entries_8() {
    if ($ENTRIES_8 == null)
      $ENTRIES_8 = enumEntries(values_8());
    return $ENTRIES_8;
  }
  var SVGLengthUnit_entriesInitialized;
  function SVGLengthUnit_initEntries() {
    if (SVGLengthUnit_entriesInitialized)
      return Unit_instance;
    SVGLengthUnit_entriesInitialized = true;
    SVGLengthUnit_UNKNOWN_instance = new SVGLengthUnit('UNKNOWN', 0);
    SVGLengthUnit_NUMBER_instance = new SVGLengthUnit('NUMBER', 1);
    SVGLengthUnit_PERCENTAGE_instance = new SVGLengthUnit('PERCENTAGE', 2);
    SVGLengthUnit_EMS_instance = new SVGLengthUnit('EMS', 3);
    SVGLengthUnit_EXS_instance = new SVGLengthUnit('EXS', 4);
    SVGLengthUnit_PX_instance = new SVGLengthUnit('PX', 5);
    SVGLengthUnit_CM_instance = new SVGLengthUnit('CM', 6);
    SVGLengthUnit_MM_instance = new SVGLengthUnit('MM', 7);
    SVGLengthUnit_IN_instance = new SVGLengthUnit('IN', 8);
    SVGLengthUnit_PT_instance = new SVGLengthUnit('PT', 9);
    SVGLengthUnit_PC_instance = new SVGLengthUnit('PC', 10);
  }
  var $ENTRIES_8;
  function SVGLengthUnit(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function SVGLengthUnit_UNKNOWN_getInstance() {
    SVGLengthUnit_initEntries();
    return SVGLengthUnit_UNKNOWN_instance;
  }
  function SVGLengthUnit_NUMBER_getInstance() {
    SVGLengthUnit_initEntries();
    return SVGLengthUnit_NUMBER_instance;
  }
  function SVGLengthUnit_PERCENTAGE_getInstance() {
    SVGLengthUnit_initEntries();
    return SVGLengthUnit_PERCENTAGE_instance;
  }
  function SVGLengthUnit_EMS_getInstance() {
    SVGLengthUnit_initEntries();
    return SVGLengthUnit_EMS_instance;
  }
  function SVGLengthUnit_EXS_getInstance() {
    SVGLengthUnit_initEntries();
    return SVGLengthUnit_EXS_instance;
  }
  function SVGLengthUnit_PX_getInstance() {
    SVGLengthUnit_initEntries();
    return SVGLengthUnit_PX_instance;
  }
  function SVGLengthUnit_CM_getInstance() {
    SVGLengthUnit_initEntries();
    return SVGLengthUnit_CM_instance;
  }
  function SVGLengthUnit_MM_getInstance() {
    SVGLengthUnit_initEntries();
    return SVGLengthUnit_MM_instance;
  }
  function SVGLengthUnit_IN_getInstance() {
    SVGLengthUnit_initEntries();
    return SVGLengthUnit_IN_instance;
  }
  function SVGLengthUnit_PT_getInstance() {
    SVGLengthUnit_initEntries();
    return SVGLengthUnit_PT_instance;
  }
  function SVGLengthUnit_PC_getInstance() {
    SVGLengthUnit_initEntries();
    return SVGLengthUnit_PC_instance;
  }
  function Companion_55() {
    Companion_instance_55 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_55;
  function Companion_getInstance_55() {
    if (Companion_instance_55 == null)
      new Companion_55();
    return Companion_instance_55;
  }
  function SVGNode(ptr) {
    Companion_getInstance_55();
    RefCnt_init_$Init$(ptr, this);
  }
  function Companion_56() {
  }
  var Companion_instance_56;
  function Companion_getInstance_56() {
    return Companion_instance_56;
  }
  function SVGPreserveAspectRatio_init_$Init$($this) {
    SVGPreserveAspectRatio.call($this, SVGPreserveAspectRatioAlign_XMID_YMID_getInstance(), SVGPreserveAspectRatioScale_MEET_getInstance());
    return $this;
  }
  function SVGPreserveAspectRatio_init_$Create$() {
    return SVGPreserveAspectRatio_init_$Init$(objectCreate(protoOf(SVGPreserveAspectRatio)));
  }
  function SVGPreserveAspectRatio_init_$Init$_0(align, $this) {
    SVGPreserveAspectRatio.call($this, align, SVGPreserveAspectRatioScale_MEET_getInstance());
    return $this;
  }
  function SVGPreserveAspectRatio_init_$Create$_0(align) {
    return SVGPreserveAspectRatio_init_$Init$_0(align, objectCreate(protoOf(SVGPreserveAspectRatio)));
  }
  function SVGPreserveAspectRatio(align, scale) {
    this.t65_1 = align;
    this.u65_1 = scale;
  }
  protoOf(SVGPreserveAspectRatio).v65 = function () {
    return this.t65_1;
  };
  protoOf(SVGPreserveAspectRatio).w65 = function () {
    return this.u65_1;
  };
  protoOf(SVGPreserveAspectRatio).equals = function (other) {
    if (other === this)
      return true;
    if (!(other instanceof SVGPreserveAspectRatio))
      return false;
    if (!this.v65().equals(other.v65()))
      return false;
    return this.w65().equals(other.w65());
  };
  protoOf(SVGPreserveAspectRatio).hashCode = function () {
    var PRIME = 59;
    var result = 1;
    result = imul(result, PRIME) + this.v65().hashCode() | 0;
    result = imul(result, PRIME) + this.w65().hashCode() | 0;
    return result;
  };
  protoOf(SVGPreserveAspectRatio).toString = function () {
    return 'SVGPreserveAspectRatio(_align=' + this.v65().toString() + ', _scale=' + this.w65().toString() + ')';
  };
  var SVGPreserveAspectRatioAlign_XMIN_YMIN_instance;
  var SVGPreserveAspectRatioAlign_XMID_YMIN_instance;
  var SVGPreserveAspectRatioAlign_XMAX_YMIN_instance;
  var SVGPreserveAspectRatioAlign_XMIN_YMID_instance;
  var SVGPreserveAspectRatioAlign_XMID_YMID_instance;
  var SVGPreserveAspectRatioAlign_XMAX_YMID_instance;
  var SVGPreserveAspectRatioAlign_XMIN_YMAX_instance;
  var SVGPreserveAspectRatioAlign_XMID_YMAX_instance;
  var SVGPreserveAspectRatioAlign_XMAX_YMAX_instance;
  var SVGPreserveAspectRatioAlign_NONE_instance;
  function Companion_57() {
  }
  protoOf(Companion_57).x65 = function (value) {
    var tmp;
    switch (value) {
      case 0:
        tmp = SVGPreserveAspectRatioAlign_XMIN_YMIN_getInstance();
        break;
      case 1:
        tmp = SVGPreserveAspectRatioAlign_XMID_YMIN_getInstance();
        break;
      case 2:
        tmp = SVGPreserveAspectRatioAlign_XMAX_YMIN_getInstance();
        break;
      case 4:
        tmp = SVGPreserveAspectRatioAlign_XMIN_YMID_getInstance();
        break;
      case 5:
        tmp = SVGPreserveAspectRatioAlign_XMID_YMID_getInstance();
        break;
      case 6:
        tmp = SVGPreserveAspectRatioAlign_XMAX_YMID_getInstance();
        break;
      case 8:
        tmp = SVGPreserveAspectRatioAlign_XMIN_YMAX_getInstance();
        break;
      case 9:
        tmp = SVGPreserveAspectRatioAlign_XMID_YMAX_getInstance();
        break;
      case 10:
        tmp = SVGPreserveAspectRatioAlign_XMAX_YMAX_getInstance();
        break;
      case 16:
        tmp = SVGPreserveAspectRatioAlign_NONE_getInstance();
        break;
      default:
        throw IllegalArgumentException_init_$Create$('Unknown SVGPreserveAspectRatioAlign value: ' + value);
    }
    return tmp;
  };
  var Companion_instance_57;
  function Companion_getInstance_57() {
    return Companion_instance_57;
  }
  var SVGPreserveAspectRatioAlign_entriesInitialized;
  function SVGPreserveAspectRatioAlign_initEntries() {
    if (SVGPreserveAspectRatioAlign_entriesInitialized)
      return Unit_instance;
    SVGPreserveAspectRatioAlign_entriesInitialized = true;
    SVGPreserveAspectRatioAlign_XMIN_YMIN_instance = new SVGPreserveAspectRatioAlign('XMIN_YMIN', 0, 0);
    SVGPreserveAspectRatioAlign_XMID_YMIN_instance = new SVGPreserveAspectRatioAlign('XMID_YMIN', 1, 1);
    SVGPreserveAspectRatioAlign_XMAX_YMIN_instance = new SVGPreserveAspectRatioAlign('XMAX_YMIN', 2, 2);
    SVGPreserveAspectRatioAlign_XMIN_YMID_instance = new SVGPreserveAspectRatioAlign('XMIN_YMID', 3, 4);
    SVGPreserveAspectRatioAlign_XMID_YMID_instance = new SVGPreserveAspectRatioAlign('XMID_YMID', 4, 5);
    SVGPreserveAspectRatioAlign_XMAX_YMID_instance = new SVGPreserveAspectRatioAlign('XMAX_YMID', 5, 6);
    SVGPreserveAspectRatioAlign_XMIN_YMAX_instance = new SVGPreserveAspectRatioAlign('XMIN_YMAX', 6, 8);
    SVGPreserveAspectRatioAlign_XMID_YMAX_instance = new SVGPreserveAspectRatioAlign('XMID_YMAX', 7, 9);
    SVGPreserveAspectRatioAlign_XMAX_YMAX_instance = new SVGPreserveAspectRatioAlign('XMAX_YMAX', 8, 10);
    SVGPreserveAspectRatioAlign_NONE_instance = new SVGPreserveAspectRatioAlign('NONE', 9, 16);
  }
  function SVGPreserveAspectRatioAlign(name, ordinal, _value) {
    Enum.call(this, name, ordinal);
    this.a66_1 = _value;
  }
  function SVGPreserveAspectRatioAlign_XMIN_YMIN_getInstance() {
    SVGPreserveAspectRatioAlign_initEntries();
    return SVGPreserveAspectRatioAlign_XMIN_YMIN_instance;
  }
  function SVGPreserveAspectRatioAlign_XMID_YMIN_getInstance() {
    SVGPreserveAspectRatioAlign_initEntries();
    return SVGPreserveAspectRatioAlign_XMID_YMIN_instance;
  }
  function SVGPreserveAspectRatioAlign_XMAX_YMIN_getInstance() {
    SVGPreserveAspectRatioAlign_initEntries();
    return SVGPreserveAspectRatioAlign_XMAX_YMIN_instance;
  }
  function SVGPreserveAspectRatioAlign_XMIN_YMID_getInstance() {
    SVGPreserveAspectRatioAlign_initEntries();
    return SVGPreserveAspectRatioAlign_XMIN_YMID_instance;
  }
  function SVGPreserveAspectRatioAlign_XMID_YMID_getInstance() {
    SVGPreserveAspectRatioAlign_initEntries();
    return SVGPreserveAspectRatioAlign_XMID_YMID_instance;
  }
  function SVGPreserveAspectRatioAlign_XMAX_YMID_getInstance() {
    SVGPreserveAspectRatioAlign_initEntries();
    return SVGPreserveAspectRatioAlign_XMAX_YMID_instance;
  }
  function SVGPreserveAspectRatioAlign_XMIN_YMAX_getInstance() {
    SVGPreserveAspectRatioAlign_initEntries();
    return SVGPreserveAspectRatioAlign_XMIN_YMAX_instance;
  }
  function SVGPreserveAspectRatioAlign_XMID_YMAX_getInstance() {
    SVGPreserveAspectRatioAlign_initEntries();
    return SVGPreserveAspectRatioAlign_XMID_YMAX_instance;
  }
  function SVGPreserveAspectRatioAlign_XMAX_YMAX_getInstance() {
    SVGPreserveAspectRatioAlign_initEntries();
    return SVGPreserveAspectRatioAlign_XMAX_YMAX_instance;
  }
  function SVGPreserveAspectRatioAlign_NONE_getInstance() {
    SVGPreserveAspectRatioAlign_initEntries();
    return SVGPreserveAspectRatioAlign_NONE_instance;
  }
  var SVGPreserveAspectRatioScale_MEET_instance;
  var SVGPreserveAspectRatioScale_SLICE_instance;
  var SVGPreserveAspectRatioScale_entriesInitialized;
  function SVGPreserveAspectRatioScale_initEntries() {
    if (SVGPreserveAspectRatioScale_entriesInitialized)
      return Unit_instance;
    SVGPreserveAspectRatioScale_entriesInitialized = true;
    SVGPreserveAspectRatioScale_MEET_instance = new SVGPreserveAspectRatioScale('MEET', 0);
    SVGPreserveAspectRatioScale_SLICE_instance = new SVGPreserveAspectRatioScale('SLICE', 1);
  }
  function SVGPreserveAspectRatioScale(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function SVGPreserveAspectRatioScale_MEET_getInstance() {
    SVGPreserveAspectRatioScale_initEntries();
    return SVGPreserveAspectRatioScale_MEET_instance;
  }
  function Companion_58() {
    Companion_instance_58 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_58;
  function Companion_getInstance_58() {
    if (Companion_instance_58 == null)
      new Companion_58();
    return Companion_instance_58;
  }
  function SVGSVG$_get_width_$lambda_z81obo(this$0) {
    return function ($this$fromInterop, it) {
      org_jetbrains_skia_svg_SVGSVG__1nGetWidth(this$0.n5h_1, it);
      return Unit_instance;
    };
  }
  function SVGSVG$_get_height_$lambda_1cq2rn(this$0) {
    return function ($this$fromInterop, it) {
      org_jetbrains_skia_svg_SVGSVG__1nGetHeight(this$0.n5h_1, it);
      return Unit_instance;
    };
  }
  function SVGSVG$_get_viewBox_$lambda_hsbx38(this$0) {
    return function (it) {
      return org_jetbrains_skia_svg_SVGSVG__1nGetViewBox(this$0.n5h_1, it);
    };
  }
  function SVGSVG(ptr) {
    Companion_getInstance_58();
    SVGContainer.call(this, ptr);
  }
  protoOf(SVGSVG).d66 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_svg_SVGSVG__1nSetWidth(this.n5h_1, value.q65_1, value.r65_1.a1_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(SVGSVG).h5e = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      var tmp_0 = Companion_instance_54;
      tmp = tmp_0.p65(SVGSVG$_get_width_$lambda_z81obo(this));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(SVGSVG).e66 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_svg_SVGSVG__1nSetHeight(this.n5h_1, value.q65_1, value.r65_1.a1_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(SVGSVG).i5e = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      var tmp_0 = Companion_instance_54;
      tmp = tmp_0.p65(SVGSVG$_get_height_$lambda_1cq2rn(this));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(SVGSVG).f66 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_svg_SVGSVG__1nSetPreserveAspectRatio(this.n5h_1, value.t65_1.a66_1, value.u65_1.a1_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(SVGSVG).g66 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skia_svg_SVGSVG__1nSetViewBox(this.n5h_1, ensureNotNull(value).k5k_1, value.l5k_1, value.m5k_1, value.n5k_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(SVGSVG).h66 = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      var tmp_0 = Companion_instance_35;
      tmp = tmp_0.e5u(SVGSVG$_get_viewBox_$lambda_hsbx38(this));
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  function Companion_59() {
    Companion_instance_59 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_59;
  function Companion_getInstance_59() {
    if (Companion_instance_59 == null)
      new Companion_59();
    return Companion_instance_59;
  }
  function SVGTransformableNode(ptr) {
    Companion_getInstance_59();
    SVGNode.call(this, ptr);
  }
  var GraphicsApi_UNKNOWN_instance;
  var GraphicsApi_SOFTWARE_FAST_instance;
  var GraphicsApi_SOFTWARE_COMPAT_instance;
  var GraphicsApi_OPENGL_instance;
  var GraphicsApi_DIRECT3D_instance;
  var GraphicsApi_ANGLE_instance;
  var GraphicsApi_VULKAN_instance;
  var GraphicsApi_METAL_instance;
  var GraphicsApi_WEBGL_instance;
  var GraphicsApi_entriesInitialized;
  function GraphicsApi_initEntries() {
    if (GraphicsApi_entriesInitialized)
      return Unit_instance;
    GraphicsApi_entriesInitialized = true;
    GraphicsApi_UNKNOWN_instance = new GraphicsApi('UNKNOWN', 0);
    GraphicsApi_SOFTWARE_FAST_instance = new GraphicsApi('SOFTWARE_FAST', 1);
    GraphicsApi_SOFTWARE_COMPAT_instance = new GraphicsApi('SOFTWARE_COMPAT', 2);
    GraphicsApi_OPENGL_instance = new GraphicsApi('OPENGL', 3);
    GraphicsApi_DIRECT3D_instance = new GraphicsApi('DIRECT3D', 4);
    GraphicsApi_ANGLE_instance = new GraphicsApi('ANGLE', 5);
    GraphicsApi_VULKAN_instance = new GraphicsApi('VULKAN', 6);
    GraphicsApi_METAL_instance = new GraphicsApi('METAL', 7);
    GraphicsApi_WEBGL_instance = new GraphicsApi('WEBGL', 8);
  }
  function GraphicsApi(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function GraphicsApi_WEBGL_getInstance() {
    GraphicsApi_initEntries();
    return GraphicsApi_WEBGL_instance;
  }
  var OS_Android_instance;
  var OS_Linux_instance;
  var OS_Windows_instance;
  var OS_MacOS_instance;
  var OS_Ios_instance;
  var OS_Tvos_instance;
  var OS_Unknown_instance;
  var OS_entriesInitialized;
  function OS_initEntries() {
    if (OS_entriesInitialized)
      return Unit_instance;
    OS_entriesInitialized = true;
    OS_Android_instance = new OS('Android', 0, 'android');
    OS_Linux_instance = new OS('Linux', 1, 'linux');
    OS_Windows_instance = new OS('Windows', 2, 'windows');
    OS_MacOS_instance = new OS('MacOS', 3, 'macos');
    OS_Ios_instance = new OS('Ios', 4, 'ios');
    OS_Tvos_instance = new OS('Tvos', 5, 'tvos');
    OS_Unknown_instance = new OS('Unknown', 6, 'unknown');
  }
  function OS(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this.k66_1 = id;
  }
  protoOf(OS).l66 = function () {
    return this.equals(OS_MacOS_getInstance());
  };
  var Arch_X64_instance;
  var Arch_Arm64_instance;
  var Arch_Unknown_instance;
  var Arch_entriesInitialized;
  function Arch_initEntries() {
    if (Arch_entriesInitialized)
      return Unit_instance;
    Arch_entriesInitialized = true;
    Arch_X64_instance = new Arch('X64', 0, 'x64');
    Arch_Arm64_instance = new Arch('Arm64', 1, 'arm64');
    Arch_Unknown_instance = new Arch('Unknown', 2, 'unknown');
  }
  function Arch(name, ordinal, id) {
    Enum.call(this, name, ordinal);
    this.o66_1 = id;
  }
  function OS_Android_getInstance() {
    OS_initEntries();
    return OS_Android_instance;
  }
  function OS_Linux_getInstance() {
    OS_initEntries();
    return OS_Linux_instance;
  }
  function OS_Windows_getInstance() {
    OS_initEntries();
    return OS_Windows_instance;
  }
  function OS_MacOS_getInstance() {
    OS_initEntries();
    return OS_MacOS_instance;
  }
  function OS_Ios_getInstance() {
    OS_initEntries();
    return OS_Ios_instance;
  }
  function OS_Unknown_getInstance() {
    OS_initEntries();
    return OS_Unknown_instance;
  }
  function Arch_Unknown_getInstance() {
    Arch_initEntries();
    return Arch_Unknown_instance;
  }
  function RenderException(message, cause) {
    message = message === VOID ? null : message;
    cause = cause === VOID ? null : cause;
    RuntimeException_init_$Init$(message, cause, this);
    captureStack(this, RenderException);
  }
  function SkikoRenderDelegate() {
  }
  var SystemTheme_DARK_instance;
  var SystemTheme_LIGHT_instance;
  var SystemTheme_UNKNOWN_instance;
  var SystemTheme_entriesInitialized;
  function SystemTheme_initEntries() {
    if (SystemTheme_entriesInitialized)
      return Unit_instance;
    SystemTheme_entriesInitialized = true;
    SystemTheme_DARK_instance = new SystemTheme('DARK', 0);
    SystemTheme_LIGHT_instance = new SystemTheme('LIGHT', 1);
    SystemTheme_UNKNOWN_instance = new SystemTheme('UNKNOWN', 2);
  }
  function SystemTheme(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function SystemTheme_UNKNOWN_getInstance() {
    SystemTheme_initEntries();
    return SystemTheme_UNKNOWN_instance;
  }
  function Companion_60() {
    Companion_instance_60 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_60;
  function Companion_getInstance_60() {
    if (Companion_instance_60 == null)
      new Companion_60();
    return Companion_instance_60;
  }
  function RenderNode_init_$Init$(context, $this) {
    RenderNode.call($this, org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nMake(getPtr(context)));
    Stats_instance.k5h();
    return $this;
  }
  function RenderNode_init_$Create$(context) {
    return RenderNode_init_$Init$(context, objectCreate(protoOf(RenderNode)));
  }
  function RenderNode(ptr, managed) {
    Companion_getInstance_60();
    managed = managed === VOID ? true : managed;
    RefCnt_init_$Init$_0(ptr, managed, this);
  }
  protoOf(RenderNode).s66 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetLayerPaint(this.n5h_1, getPtr(value));
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(value);
    }
    return tmp;
  };
  protoOf(RenderNode).t66 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetBounds(this.n5h_1, value.k5k_1, value.l5k_1, value.m5k_1, value.n5k_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).u66 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetPivot(this.n5h_1, value.w5t_1, value.x5t_1);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).v66 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetAlpha(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).w66 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetScaleX(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).x66 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetScaleY(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).y66 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetTranslationX(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).z66 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetTranslationY(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).a67 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetShadowElevation(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).b67 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetAmbientShadowColor(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).c67 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetSpotShadowColor(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).d67 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetRotationX(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).e67 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetRotationY(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).f67 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetRotationZ(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).g67 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetCameraDistance(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).h67 = function (left, top, right, bottom, mode, antiAlias) {
    Stats_instance.k5h();
    org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetClipRect(this.n5h_1, left, top, right, bottom, mode.a1_1, antiAlias);
  };
  protoOf(RenderNode).i67 = function (left, top, right, bottom, mode, antiAlias, $super) {
    mode = mode === VOID ? ClipMode_INTERSECT_getInstance() : mode;
    antiAlias = antiAlias === VOID ? false : antiAlias;
    var tmp;
    if ($super === VOID) {
      this.h67(left, top, right, bottom, mode, antiAlias);
      tmp = Unit_instance;
    } else {
      tmp = $super.h67.call(this, left, top, right, bottom, mode, antiAlias);
    }
    return tmp;
  };
  protoOf(RenderNode).j67 = function (left, top, right, bottom, radii, mode, antiAlias) {
    Stats_instance.k5h();
    $l$block: {
      // Inline function 'org.jetbrains.skia.impl.interopScope' call
      try {
        var _unary__edvuaz = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz + 1 | 0);
        var $this$interopScope = access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0();
        org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetClipRRect(this.n5h_1, left, top, right, bottom, $this$interopScope.h5k(radii), radii.length, mode.a1_1, antiAlias);
        break $l$block;
      }finally {
        var _unary__edvuaz_0 = access$_get_interopScopeCounter_$tNative_webKt_h1nl5b();
        access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_unary__edvuaz_0 - 1 | 0);
        if (access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() === 0) {
          access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0().r2v();
        }
      }
    }
  };
  protoOf(RenderNode).k67 = function (left, top, right, bottom, radii, mode, antiAlias, $super) {
    mode = mode === VOID ? ClipMode_INTERSECT_getInstance() : mode;
    antiAlias = antiAlias === VOID ? false : antiAlias;
    var tmp;
    if ($super === VOID) {
      this.j67(left, top, right, bottom, radii, mode, antiAlias);
      tmp = Unit_instance;
    } else {
      tmp = $super.j67.call(this, left, top, right, bottom, radii, mode, antiAlias);
    }
    return tmp;
  };
  protoOf(RenderNode).l67 = function (p, mode, antiAlias) {
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetClipPath(this.n5h_1, getPtr(p), mode.a1_1, antiAlias);
    }finally {
      reachabilityBarrier(this);
      reachabilityBarrier(p);
    }
  };
  protoOf(RenderNode).m67 = function (p, mode, antiAlias, $super) {
    mode = mode === VOID ? ClipMode_INTERSECT_getInstance() : mode;
    antiAlias = antiAlias === VOID ? false : antiAlias;
    var tmp;
    if ($super === VOID) {
      this.l67(p, mode, antiAlias);
      tmp = Unit_instance;
    } else {
      tmp = $super.l67.call(this, p, mode, antiAlias);
    }
    return tmp;
  };
  protoOf(RenderNode).n67 = function (value) {
    var tmp;
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nSetClip(this.n5h_1, value);
      tmp = Unit_instance;
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).o67 = function () {
    var tmp;
    try {
      Stats_instance.k5h();
      tmp = new Canvas(org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nBeginRecording(this.n5h_1), false, this);
    }finally {
      reachabilityBarrier(this);
    }
    return tmp;
  };
  protoOf(RenderNode).p67 = function () {
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nEndRecording(this.n5h_1);
    }finally {
      reachabilityBarrier(this);
    }
  };
  protoOf(RenderNode).q67 = function (canvas) {
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeKt_RenderNode_1nDrawInto(this.n5h_1, getPtr(canvas));
    }finally {
      reachabilityBarrier(this);
    }
  };
  function Companion_61() {
    Companion_instance_61 = this;
    Companion_instance_62.q5h();
  }
  var Companion_instance_61;
  function Companion_getInstance_61() {
    if (Companion_instance_61 == null)
      new Companion_61();
    return Companion_instance_61;
  }
  function RenderNodeContext_init_$Init$(measureDrawBounds, $this) {
    measureDrawBounds = measureDrawBounds === VOID ? false : measureDrawBounds;
    RenderNodeContext.call($this, org_jetbrains_skiko_node_RenderNodeContextKt_RenderNodeContext_1nMake(measureDrawBounds));
    Stats_instance.k5h();
    return $this;
  }
  function RenderNodeContext_init_$Create$(measureDrawBounds) {
    return RenderNodeContext_init_$Init$(measureDrawBounds, objectCreate(protoOf(RenderNodeContext)));
  }
  function RenderNodeContext(ptr, managed) {
    Companion_getInstance_61();
    managed = managed === VOID ? true : managed;
    RefCnt_init_$Init$_0(ptr, managed, this);
  }
  protoOf(RenderNodeContext).t67 = function (centerX, centerY, centerZ, radius, ambientShadowAlpha, spotShadowAlpha) {
    try {
      Stats_instance.k5h();
      org_jetbrains_skiko_node_RenderNodeContextKt_RenderNodeContext_1nSetLightingInfo(this.n5h_1, centerX, centerY, centerZ, radius, ambientShadowAlpha, spotShadowAlpha);
    }finally {
      reachabilityBarrier(this);
    }
  };
  function get_registry() {
    _init_properties_Managed_js_kt__4ok5rc();
    return registry;
  }
  var registry;
  function unregister(managed) {
    _init_properties_Managed_js_kt__4ok5rc();
    get_registry().unregister(managed);
  }
  function register(managed, thunk) {
    _init_properties_Managed_js_kt__4ok5rc();
    get_registry().register(managed, thunk, managed);
  }
  function registry$lambda(it) {
    _init_properties_Managed_js_kt__4ok5rc();
    var thunk = it instanceof FinalizationThunk ? it : THROW_CCE();
    thunk.w67();
    return Unit_instance;
  }
  var properties_initialized_Managed_js_kt_llxy4m;
  function _init_properties_Managed_js_kt__4ok5rc() {
    if (!properties_initialized_Managed_js_kt_llxy4m) {
      properties_initialized_Managed_js_kt_llxy4m = true;
      registry = new FinalizationRegistry(registry$lambda);
    }
  }
  function toInterop($this, array, copyArrayToWasm) {
    var tmp;
    var tmp_0;
    if (!(array == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      tmp_0 = !(array.length === 0);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var data = malloc(array.length);
      $this.y5g_1.j1(data);
      if (copyArrayToWasm) {
        toWasm(data, array);
      }
      tmp = data;
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function toInterop_0($this, array, copyArrayToWasm) {
    var tmp;
    var tmp_0;
    if (!(array == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      tmp_0 = !(array.length === 0);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var data = malloc(imul(array.length, 2));
      $this.y5g_1.j1(data);
      if (copyArrayToWasm) {
        toWasm_0(data, array);
      }
      tmp = data;
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function toInterop_1($this, array, copyArrayToWasm) {
    var tmp;
    var tmp_0;
    if (!(array == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      tmp_0 = !(array.length === 0);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var data = malloc(imul(array.length, 4));
      $this.y5g_1.j1(data);
      if (copyArrayToWasm) {
        toWasm_1(data, array);
      }
      tmp = data;
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function toInterop_2($this, array, copyArrayToWasm) {
    var tmp;
    var tmp_0;
    if (!(array == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      tmp_0 = !(array.length === 0);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var data = malloc(imul(array.length, 4));
      $this.y5g_1.j1(data);
      if (copyArrayToWasm) {
        toWasm_2(data, array);
      }
      tmp = data;
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function toInterop_3($this, array, copyArrayToWasm) {
    var tmp;
    var tmp_0;
    if (!(array == null)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      // Inline function 'kotlin.collections.isEmpty' call
      tmp_0 = !(array.length === 0);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var data = malloc(imul(array.length, 8));
      $this.y5g_1.j1(data);
      if (copyArrayToWasm) {
        toWasm_3(data, array);
      }
      tmp = data;
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function toInterop_4($this, array, copyArrayToWasm) {
    var tmp;
    if (!(array == null) && array.n1() > 0) {
      var data = malloc(imul(array.n1(), 4));
      $this.y5g_1.j1(data);
      if (copyArrayToWasm) {
        toWasm_1(data, array.k5q_1);
      }
      tmp = data;
    } else {
      tmp = 0;
    }
    return tmp;
  }
  function InteropScope() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.y5g_1 = ArrayList_init_$Create$_0();
    this.z5g_1 = false;
  }
  protoOf(InteropScope).y5i = function (string) {
    var tmp;
    if (!(string == null)) {
      tmp = this.q5m(convertToZeroTerminatedString(string));
    } else {
      tmp = 0;
    }
    return tmp;
  };
  protoOf(InteropScope).q5m = function (array) {
    return toInterop(this, array, true);
  };
  protoOf(InteropScope).y5m = function (array) {
    return toInterop(this, array, false);
  };
  protoOf(InteropScope).n5j = function (array) {
    return toInterop_0(this, array, true);
  };
  protoOf(InteropScope).b5h = function (_this__u8e3s4, result) {
    fromWasm(_this__u8e3s4, result);
  };
  protoOf(InteropScope).u5j = function (array) {
    return toInterop_1(this, array, true);
  };
  protoOf(InteropScope).a5h = function (array) {
    return toInterop_1(this, array, false);
  };
  protoOf(InteropScope).u5o = function (_this__u8e3s4, result) {
    fromWasm_0(_this__u8e3s4, result);
  };
  protoOf(InteropScope).h5k = function (array) {
    return toInterop_2(this, array, true);
  };
  protoOf(InteropScope).t5o = function (array) {
    return toInterop_2(this, array, false);
  };
  protoOf(InteropScope).j61 = function (_this__u8e3s4, result) {
    fromWasm_1(_this__u8e3s4, result);
  };
  protoOf(InteropScope).i61 = function (array) {
    return toInterop_3(this, array, false);
  };
  protoOf(InteropScope).z5m = function (_this__u8e3s4, result) {
    fromWasm_2(_this__u8e3s4, result);
  };
  protoOf(InteropScope).i5q = function (array) {
    return toInterop_4(this, array, false);
  };
  protoOf(InteropScope).j5q = function (_this__u8e3s4, result) {
    return fromWasm(_this__u8e3s4, result.k5q_1);
  };
  protoOf(InteropScope).e61 = function (stringArray) {
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    var tmp;
    if (stringArray == null) {
      tmp = true;
    } else {
      // Inline function 'kotlin.collections.isEmpty' call
      tmp = stringArray.length === 0;
    }
    if (tmp)
      return 0;
    var tmp_0 = 0;
    var tmp_1 = stringArray.length;
    var tmp_2 = new Int32Array(tmp_1);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = this.y5i(stringArray[tmp_3]);
      tmp_0 = tmp_0 + 1 | 0;
    }
    var ptrs = tmp_2;
    return this.u5j(ptrs);
  };
  protoOf(InteropScope).r2v = function () {
    // Inline function 'org.jetbrains.skiko.internal.fastForEach' call
    var this_0 = this.y5g_1;
    var inductionVariable = 0;
    var last = this_0.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = this_0.l1(index);
        free(item);
      }
       while (inductionVariable <= last);
    this.y5g_1.c3();
    // Inline function 'org.jetbrains.skia.impl.InteropScope.releaseCallbacks' call
    if (this.z5g_1) {
      _releaseLocalCallbackScope();
      this.z5g_1 = false;
    }
  };
  function onWasmReady(onReady) {
    var tmp = awaitSkiko;
    tmp.then(onWasmReady$lambda(onReady));
  }
  function createWebGLContext(canvas, attr) {
    attr = attr === VOID ? null : attr;
    var contextAttributes = new createWebGLContext$contextAttributes$1(attr);
    return GL.createContext(canvas, asJsObject(contextAttributes));
  }
  function asJsObject(_this__u8e3s4) {
    var jsObject = {};
    if (_this__u8e3s4.alpha == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      jsObject.alpha = _this__u8e3s4.alpha;
    }
    if (_this__u8e3s4.depth == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      jsObject.depth = _this__u8e3s4.depth;
    }
    if (_this__u8e3s4.stencil == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      jsObject.stencil = _this__u8e3s4.stencil;
    }
    if (_this__u8e3s4.antialias == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      jsObject.antialias = _this__u8e3s4.antialias;
    }
    if (_this__u8e3s4.premultipliedAlpha == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      jsObject.premultipliedAlpha = _this__u8e3s4.premultipliedAlpha;
    }
    if (_this__u8e3s4.preserveDrawingBuffer == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      jsObject.preserveDrawingBuffer = _this__u8e3s4.preserveDrawingBuffer;
    }
    if (_this__u8e3s4.preferLowPowerToHighPerformance == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      jsObject.preferLowPowerToHighPerformance = _this__u8e3s4.preferLowPowerToHighPerformance;
    }
    if (_this__u8e3s4.failIfMajorPerformanceCaveat == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      jsObject.failIfMajorPerformanceCaveat = _this__u8e3s4.failIfMajorPerformanceCaveat;
    }
    if (_this__u8e3s4.enableExtensionsByDefault == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      jsObject.enableExtensionsByDefault = _this__u8e3s4.enableExtensionsByDefault;
    }
    if (_this__u8e3s4.explicitSwapControl == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      jsObject.explicitSwapControl = _this__u8e3s4.explicitSwapControl;
    }
    if (_this__u8e3s4.renderViaOffscreenBackBuffer == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      jsObject.renderViaOffscreenBackBuffer = _this__u8e3s4.renderViaOffscreenBackBuffer;
    }
    if (_this__u8e3s4.majorVersion == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      jsObject.majorVersion = _this__u8e3s4.majorVersion;
    }
    return jsObject;
  }
  function onWasmReady$lambda($onReady) {
    return function (it) {
      $onReady();
      return Unit_instance;
    };
  }
  function createWebGLContext$contextAttributes$1($attr) {
    var tmp = this;
    var tmp1_elvis_lhs = $attr == null ? null : $attr.alpha;
    tmp.x67_1 = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    var tmp_0 = this;
    var tmp1_elvis_lhs_0 = $attr == null ? null : $attr.depth;
    tmp_0.y67_1 = tmp1_elvis_lhs_0 == null ? 1 : tmp1_elvis_lhs_0;
    var tmp_1 = this;
    var tmp1_elvis_lhs_1 = $attr == null ? null : $attr.stencil;
    tmp_1.z67_1 = tmp1_elvis_lhs_1 == null ? 8 : tmp1_elvis_lhs_1;
    var tmp_2 = this;
    var tmp1_elvis_lhs_2 = $attr == null ? null : $attr.antialias;
    tmp_2.a68_1 = tmp1_elvis_lhs_2 == null ? 0 : tmp1_elvis_lhs_2;
    var tmp_3 = this;
    var tmp1_elvis_lhs_3 = $attr == null ? null : $attr.premultipliedAlpha;
    tmp_3.b68_1 = tmp1_elvis_lhs_3 == null ? 1 : tmp1_elvis_lhs_3;
    var tmp_4 = this;
    var tmp1_elvis_lhs_4 = $attr == null ? null : $attr.preserveDrawingBuffer;
    tmp_4.c68_1 = tmp1_elvis_lhs_4 == null ? 0 : tmp1_elvis_lhs_4;
    var tmp_5 = this;
    var tmp1_elvis_lhs_5 = $attr == null ? null : $attr.preferLowPowerToHighPerformance;
    tmp_5.d68_1 = tmp1_elvis_lhs_5 == null ? 0 : tmp1_elvis_lhs_5;
    var tmp_6 = this;
    var tmp1_elvis_lhs_6 = $attr == null ? null : $attr.failIfMajorPerformanceCaveat;
    tmp_6.e68_1 = tmp1_elvis_lhs_6 == null ? 0 : tmp1_elvis_lhs_6;
    var tmp_7 = this;
    var tmp1_elvis_lhs_7 = $attr == null ? null : $attr.enableExtensionsByDefault;
    tmp_7.f68_1 = tmp1_elvis_lhs_7 == null ? 1 : tmp1_elvis_lhs_7;
    var tmp_8 = this;
    var tmp1_elvis_lhs_8 = $attr == null ? null : $attr.explicitSwapControl;
    tmp_8.g68_1 = tmp1_elvis_lhs_8 == null ? 0 : tmp1_elvis_lhs_8;
    var tmp_9 = this;
    var tmp1_elvis_lhs_9 = $attr == null ? null : $attr.renderViaOffscreenBackBuffer;
    tmp_9.h68_1 = tmp1_elvis_lhs_9 == null ? 0 : tmp1_elvis_lhs_9;
    var tmp_10 = this;
    var tmp1_elvis_lhs_10 = $attr == null ? null : $attr.majorVersion;
    tmp_10.i68_1 = tmp1_elvis_lhs_10 == null ? 2 : tmp1_elvis_lhs_10;
    delete this.alpha;
    delete this.depth;
    delete this.stencil;
    delete this.antialias;
    delete this.premultipliedAlpha;
    delete this.preserveDrawingBuffer;
    delete this.preferLowPowerToHighPerformance;
    delete this.failIfMajorPerformanceCaveat;
    delete this.enableExtensionsByDefault;
    delete this.explicitSwapControl;
    delete this.renderViaOffscreenBackBuffer;
    delete this.majorVersion;
  }
  protoOf(createWebGLContext$contextAttributes$1).j68 = function () {
    return this.x67_1;
  };
  protoOf(createWebGLContext$contextAttributes$1).k68 = function () {
    return this.y67_1;
  };
  protoOf(createWebGLContext$contextAttributes$1).l68 = function () {
    return this.z67_1;
  };
  protoOf(createWebGLContext$contextAttributes$1).m68 = function () {
    return this.a68_1;
  };
  protoOf(createWebGLContext$contextAttributes$1).n68 = function () {
    return this.b68_1;
  };
  protoOf(createWebGLContext$contextAttributes$1).o68 = function () {
    return this.c68_1;
  };
  protoOf(createWebGLContext$contextAttributes$1).p68 = function () {
    return this.d68_1;
  };
  protoOf(createWebGLContext$contextAttributes$1).q68 = function () {
    return this.e68_1;
  };
  protoOf(createWebGLContext$contextAttributes$1).r68 = function () {
    return this.f68_1;
  };
  protoOf(createWebGLContext$contextAttributes$1).s68 = function () {
    return this.g68_1;
  };
  protoOf(createWebGLContext$contextAttributes$1).t68 = function () {
    return this.h68_1;
  };
  protoOf(createWebGLContext$contextAttributes$1).u68 = function () {
    return this.i68_1;
  };
  function convertToZeroTerminatedString(string) {
    var utf8 = encodeToByteArray(string);
    return copyOf(utf8, utf8.length + 1 | 0);
  }
  var LANG$delegate;
  function Pattern(regex) {
    this.v68_1 = Regex_init_$Create$(regex);
  }
  function compilePattern(regex) {
    _init_properties_Actuals_web_kt__cwbdqx();
    return new Pattern(regex);
  }
  function commonSynchronized(lock, block) {
    _init_properties_Actuals_web_kt__cwbdqx();
    block();
  }
  function LANG$delegate$lambda() {
    _init_properties_Actuals_web_kt__cwbdqx();
    var lang = window.navigator.language;
    var tmp;
    // Inline function 'kotlin.text.isNullOrEmpty' call
    if (lang == null || charSequenceLength(lang) === 0) {
      tmp = 'en-US';
    } else {
      tmp = lang;
    }
    return tmp;
  }
  var properties_initialized_Actuals_web_kt_1cg0bp;
  function _init_properties_Actuals_web_kt__cwbdqx() {
    if (!properties_initialized_Actuals_web_kt_1cg0bp) {
      properties_initialized_Actuals_web_kt_1cg0bp = true;
      LANG$delegate = lazy(LANG$delegate$lambda);
    }
  }
  function Companion_62() {
  }
  protoOf(Companion_62).q5h = function () {
  };
  var Companion_instance_62;
  function Companion_getInstance_62() {
    return Companion_instance_62;
  }
  function Managed(ptr, finalizer, managed) {
    managed = managed === VOID ? true : managed;
    Native.call(this, ptr);
    this.m5h_1 = null;
    if (managed) {
      // Inline function 'kotlin.require' call
      if (!!(ptr === 0)) {
        var message = 'Managed ptr is 0';
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      // Inline function 'kotlin.require' call
      if (!!(finalizer === 0)) {
        var message_0 = 'Managed finalizer is 0';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
      var thunk = new FinalizationThunk(finalizer, ptr);
      register(this, thunk);
      this.m5h_1 = thunk;
    }
  }
  protoOf(Managed).j4 = function () {
    if (Companion_instance_63.s5h() === this.n5h_1)
      throw RuntimeException_init_$Create$('Object already closed: ' + getKClassFromExpression(this).o() + ', _ptr=' + this.n5h_1);
    else if (null == this.m5h_1)
      throw RuntimeException_init_$Create$("Object is not managed, can't close(): " + getKClassFromExpression(this).o() + ', _ptr=' + this.n5h_1);
    else {
      unregister(this);
      ensureNotNull(this.m5h_1).w67();
      this.m5h_1 = null;
      this.n5h_1 = 0;
    }
  };
  function FinalizationThunk(finalizer, obj) {
    this.u67_1 = finalizer;
    this.v67_1 = obj;
  }
  protoOf(FinalizationThunk).w67 = function () {
    if (!(this.v67_1 === 0)) {
      org_jetbrains_skia_impl_Managed__invokeFinalizer(this.u67_1, this.v67_1);
    }
    this.v67_1 = 0;
  };
  function get_INTEROP_SCOPE() {
    _init_properties_Native_web_kt__70micd();
    return INTEROP_SCOPE;
  }
  var INTEROP_SCOPE;
  function set_interopScopeCounter(_set____db54di) {
    _init_properties_Native_web_kt__70micd();
    interopScopeCounter = _set____db54di;
  }
  function get_interopScopeCounter() {
    _init_properties_Native_web_kt__70micd();
    return interopScopeCounter;
  }
  var interopScopeCounter;
  function reachabilityBarrier(obj) {
    _init_properties_Native_web_kt__70micd();
  }
  function Companion_63() {
  }
  protoOf(Companion_63).s5h = function () {
    return 0;
  };
  var Companion_instance_63;
  function Companion_getInstance_63() {
    return Companion_instance_63;
  }
  function Native(ptr) {
    if (ptr === Companion_instance_63.s5h())
      throw RuntimeException_init_$Create$("Can't wrap nullptr");
    this.n5h_1 = ptr;
  }
  protoOf(Native).equals = function (other) {
    if (this === other)
      return true;
    if (null == other)
      return false;
    if (!(other instanceof Native))
      return false;
    return this.n5h_1 === other.n5h_1 ? true : this.o5h(other);
  };
  protoOf(Native).hashCode = function () {
    return this.n5h_1;
  };
  protoOf(Native).o5h = function (other) {
    return false;
  };
  protoOf(Native).toString = function () {
    return plus(getKClassFromExpression(this).o(), '(_ptr=0x') + toString_1(this.n5h_1, 16) + ')';
  };
  function Companion_64() {
  }
  var Companion_instance_64;
  function Companion_getInstance_64() {
    return Companion_instance_64;
  }
  function NativePointerArray(size) {
    this.k5q_1 = new Int32Array(size);
  }
  protoOf(NativePointerArray).l1 = function (index) {
    return this.k5q_1[index];
  };
  protoOf(NativePointerArray).n1 = function () {
    return this.k5q_1.length;
  };
  function toWasm(dest, src) {
    _init_properties_Native_web_kt__70micd();
    var address = dest;
    var inductionVariable = 0;
    var last = src.length;
    while (inductionVariable < last) {
      var value = src[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      skia_memSetByte(address, value);
      address = address + 1 | 0;
    }
  }
  function toWasm_0(dest, src) {
    _init_properties_Native_web_kt__70micd();
    var address = dest;
    var inductionVariable = 0;
    var last = src.length;
    while (inductionVariable < last) {
      var value = src[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      skia_memSetShort(address, value);
      address = address + 2 | 0;
    }
  }
  function fromWasm(src, result) {
    _init_properties_Native_web_kt__70micd();
    var address = src;
    var inductionVariable = 0;
    var last = result.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result[index] = skia_memGetInt(address);
        address = address + 4 | 0;
      }
       while (inductionVariable <= last);
  }
  function toWasm_1(dest, src) {
    _init_properties_Native_web_kt__70micd();
    var address = dest;
    var inductionVariable = 0;
    var last = src.length;
    while (inductionVariable < last) {
      var value = src[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      skia_memSetInt(address, value);
      address = address + 4 | 0;
    }
  }
  function fromWasm_0(src, result) {
    _init_properties_Native_web_kt__70micd();
    var address = src;
    var inductionVariable = 0;
    var last = result.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result[index] = skia_memGetFloat(address);
        address = address + 4 | 0;
      }
       while (inductionVariable <= last);
  }
  function toWasm_2(dest, src) {
    _init_properties_Native_web_kt__70micd();
    var address = dest;
    var inductionVariable = 0;
    var last = src.length;
    while (inductionVariable < last) {
      var value = src[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      skia_memSetFloat(address, value);
      address = address + 4 | 0;
    }
  }
  function fromWasm_1(src, result) {
    _init_properties_Native_web_kt__70micd();
    var address = src;
    var inductionVariable = 0;
    var last = result.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result[index] = skia_memGetDouble(address);
        address = address + 8 | 0;
      }
       while (inductionVariable <= last);
  }
  function toWasm_3(dest, src) {
    _init_properties_Native_web_kt__70micd();
    var address = dest;
    var inductionVariable = 0;
    var last = src.length;
    while (inductionVariable < last) {
      var value = src[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      skia_memSetDouble(address, value);
      address = address + 8 | 0;
    }
  }
  function fromWasm_2(src, result) {
    _init_properties_Native_web_kt__70micd();
    var address = src;
    var inductionVariable = 0;
    var last = result.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        result[index] = skia_memGetByte(address);
        address = address + 1 | 0;
      }
       while (inductionVariable <= last);
  }
  function access$_get_INTEROP_SCOPE_$tNative_webKt_chn7j0() {
    return get_INTEROP_SCOPE();
  }
  function access$_get_interopScopeCounter_$tNative_webKt_h1nl5b() {
    return get_interopScopeCounter();
  }
  function access$_set_interopScopeCounter_$tNative_webKt_mvg2hx(_set____db54di) {
    return set_interopScopeCounter(_set____db54di);
  }
  var properties_initialized_Native_web_kt_qki601;
  function _init_properties_Native_web_kt__70micd() {
    if (!properties_initialized_Native_web_kt_qki601) {
      properties_initialized_Native_web_kt_qki601 = true;
      INTEROP_SCOPE = new InteropScope();
      interopScopeCounter = 0;
    }
  }
  function RefCnt_init_$Init$(ptr, $this) {
    Managed.call($this, ptr, _FinalizerHolder_getInstance_19().w68_1, true);
    RefCnt.call($this);
    return $this;
  }
  function RefCnt_init_$Init$_0(ptr, allowClose, $this) {
    Managed.call($this, ptr, _FinalizerHolder_getInstance_19().w68_1, allowClose);
    RefCnt.call($this);
    return $this;
  }
  protoOf(RefCnt).c5m = function () {
    Stats_instance.k5h();
    return org_jetbrains_skia_impl_RefCnt__getRefCount(this.n5h_1);
  };
  protoOf(RefCnt).toString = function () {
    return refCntToString(this, protoOf(Managed).toString.call(this), 0);
  };
  function RefCnt() {
  }
  function _FinalizerHolder_19() {
    _FinalizerHolder_instance_19 = this;
    this.w68_1 = org_jetbrains_skia_impl_RefCnt__getFinalizer();
  }
  var _FinalizerHolder_instance_19;
  function _FinalizerHolder_getInstance_19() {
    if (_FinalizerHolder_instance_19 == null)
      new _FinalizerHolder_19();
    return _FinalizerHolder_instance_19;
  }
  function Stats() {
  }
  protoOf(Stats).k5h = function () {
  };
  var Stats_instance;
  function Stats_getInstance() {
    return Stats_instance;
  }
  function currentNanoTime() {
    return numberToLong(window.performance.now() * 1000000);
  }
  function loadOpenGLLibrary() {
  }
  function disposeCanvas($this) {
    var tmp0_safe_receiver = $this.b69_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.j4();
    }
    $this.b69_1 = null;
    var tmp1_safe_receiver = $this.c69_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.j4();
    }
    $this.c69_1 = null;
  }
  function CanvasRenderer$needRedraw$lambda(this$0) {
    return function (timestamp) {
      this$0.e69_1 = false;
      GL.makeContextCurrent(this$0.x68_1);
      var tmp0_safe_receiver = this$0.d69_1;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.m3p(-1);
      var tmp1_safe_receiver = this$0.d69_1;
      if (tmp1_safe_receiver == null)
        null;
      else
        tmp1_safe_receiver.y5k();
      this$0.f69(timestamp);
      var tmp2_safe_receiver = this$0.b69_1;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.z5u();
      }
      this$0.a69_1.d5n();
      return Unit_instance;
    };
  }
  function CanvasRenderer(contextPointer, width, height) {
    this.x68_1 = contextPointer;
    this.y68_1 = width;
    this.z68_1 = height;
    this.b69_1 = null;
    this.c69_1 = null;
    this.d69_1 = null;
    GL.makeContextCurrent(this.x68_1);
    this.a69_1 = Companion_getInstance_11().a5n();
    this.g69();
    this.e69_1 = false;
  }
  protoOf(CanvasRenderer).g69 = function () {
    disposeCanvas(this);
    this.c69_1 = Companion_getInstance_0().r5h(this.y68_1, this.z68_1, 1, 8, 0, 32856);
    var tmp = this;
    var tmp0_elvis_lhs = Companion_getInstance_38().q5u(this.a69_1, ensureNotNull(this.c69_1), SurfaceOrigin_BOTTOM_LEFT_getInstance(), SurfaceColorFormat_RGBA_8888_getInstance(), Companion_getInstance_8().i5m_1, new SurfaceProps());
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw new RenderException('Cannot create surface');
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp.b69_1 = tmp_0;
    this.d69_1 = ensureNotNull(this.b69_1).x5u();
  };
  protoOf(CanvasRenderer).h69 = function () {
    if (this.e69_1) {
      return Unit_instance;
    }
    this.e69_1 = true;
    var tmp = window;
    tmp.requestAnimationFrame(CanvasRenderer$needRedraw$lambda(this));
  };
  function get_hostOs() {
    _init_properties_OsArch_web_kt__49jcm8();
    return hostOs;
  }
  var hostOs;
  function get_hostArch() {
    _init_properties_OsArch_web_kt__49jcm8();
    return hostArch;
  }
  var hostArch;
  var hostId$delegate;
  function detectHostOs() {
    _init_properties_OsArch_web_kt__49jcm8();
    // Inline function 'kotlin.takeIf' call
    var this_0 = getNavigatorInfo();
    var tmp;
    // Inline function 'kotlin.text.isNotEmpty' call
    if (charSequenceLength(this_0) > 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var platformInfo = tmp0_elvis_lhs == null ? window.navigator.userAgent : tmp0_elvis_lhs;
    return contains(platformInfo, 'Android', true) ? OS_Android_getInstance() : contains(platformInfo, 'iPhone', true) ? OS_Ios_getInstance() : contains(platformInfo, 'iOS', true) ? OS_Ios_getInstance() : contains(platformInfo, 'iPad', true) ? OS_Ios_getInstance() : contains(platformInfo, 'Linux', true) ? OS_Linux_getInstance() : contains(platformInfo, 'Mac', true) ? OS_MacOS_getInstance() : contains(platformInfo, 'Win', true) ? OS_Windows_getInstance() : OS_Unknown_getInstance();
  }
  function getNavigatorInfo() {
    _init_properties_OsArch_web_kt__49jcm8();
    return navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform;
  }
  function hostId$delegate$lambda() {
    _init_properties_OsArch_web_kt__49jcm8();
    return get_hostOs().k66_1 + '-' + get_hostArch().o66_1;
  }
  var properties_initialized_OsArch_web_kt_10ji6a;
  function _init_properties_OsArch_web_kt__49jcm8() {
    if (!properties_initialized_OsArch_web_kt_10ji6a) {
      properties_initialized_OsArch_web_kt_10ji6a = true;
      hostOs = detectHostOs();
      hostArch = Arch_Unknown_getInstance();
      hostId$delegate = lazy(hostId$delegate$lambda);
    }
  }
  function attachTo($this, htmlCanvas) {
    $this.l69_1 = htmlCanvas;
    var tmp = $this;
    tmp.i69_1 = new SkiaLayer$attachTo$1(htmlCanvas, $this);
  }
  function SkiaLayer$attachTo$1($htmlCanvas, this$0) {
    this.u69_1 = this$0;
    CanvasRenderer.call(this, createWebGLContext($htmlCanvas), $htmlCanvas.width, $htmlCanvas.height);
  }
  protoOf(SkiaLayer$attachTo$1).f69 = function (currentTimestamp) {
    var currentNanos = currentTimestamp * 1000000;
    var tmp0_safe_receiver = this.u69_1.k69_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.p66(ensureNotNull(this.d69_1), this.y68_1, this.z68_1, numberToLong(currentNanos));
    }
  };
  function SkiaLayer() {
    this.i69_1 = null;
    this.j69_1 = GraphicsApi_WEBGL_getInstance();
    this.k69_1 = null;
    this.l69_1 = null;
  }
  protoOf(SkiaLayer).v69 = function (throttledToVsync) {
    var tmp0_safe_receiver = this.i69_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.h69();
    }
  };
  protoOf(SkiaLayer).w69 = function (throttledToVsync, $super) {
    throttledToVsync = throttledToVsync === VOID ? true : throttledToVsync;
    var tmp;
    if ($super === VOID) {
      this.v69(throttledToVsync);
      tmp = Unit_instance;
    } else {
      tmp = $super.v69.call(this, throttledToVsync);
    }
    return tmp;
  };
  protoOf(SkiaLayer).x69 = function (container) {
    attachTo(this, container instanceof HTMLCanvasElement ? container : THROW_CCE());
  };
  function get_currentSystemTheme() {
    return SystemTheme_UNKNOWN_getInstance();
  }
  //region block: post-declaration
  protoOf(Bitmap).h5e = get_width;
  protoOf(Bitmap).i5e = get_height;
  protoOf(Bitmap).v5i = get_colorType;
  protoOf(Bitmap).w5i = get_colorSpace;
  protoOf(Bitmap).x5i = get_isOpaque;
  protoOf(Codec).h5e = get_width;
  protoOf(Codec).i5e = get_height;
  protoOf(Image).h5e = get_width;
  protoOf(Image).i5e = get_height;
  defineProp(protoOf(createWebGLContext$contextAttributes$1), 'alpha', function () {
    return this.j68();
  });
  defineProp(protoOf(createWebGLContext$contextAttributes$1), 'depth', function () {
    return this.k68();
  });
  defineProp(protoOf(createWebGLContext$contextAttributes$1), 'stencil', function () {
    return this.l68();
  });
  defineProp(protoOf(createWebGLContext$contextAttributes$1), 'antialias', function () {
    return this.m68();
  });
  defineProp(protoOf(createWebGLContext$contextAttributes$1), 'premultipliedAlpha', function () {
    return this.n68();
  });
  defineProp(protoOf(createWebGLContext$contextAttributes$1), 'preserveDrawingBuffer', function () {
    return this.o68();
  });
  defineProp(protoOf(createWebGLContext$contextAttributes$1), 'preferLowPowerToHighPerformance', function () {
    return this.p68();
  });
  defineProp(protoOf(createWebGLContext$contextAttributes$1), 'failIfMajorPerformanceCaveat', function () {
    return this.q68();
  });
  defineProp(protoOf(createWebGLContext$contextAttributes$1), 'enableExtensionsByDefault', function () {
    return this.r68();
  });
  defineProp(protoOf(createWebGLContext$contextAttributes$1), 'explicitSwapControl', function () {
    return this.s68();
  });
  defineProp(protoOf(createWebGLContext$contextAttributes$1), 'renderViaOffscreenBackBuffer', function () {
    return this.t68();
  });
  defineProp(protoOf(createWebGLContext$contextAttributes$1), 'majorVersion', function () {
    return this.u68();
  });
  //endregion
  //region block: init
  Companion_instance = new Companion();
  Companion_instance_5 = new Companion_5();
  Companion_instance_14 = new Companion_14();
  Companion_instance_18 = new Companion_18();
  Companion_instance_20 = new Companion_20();
  Companion_instance_21 = new Companion_21();
  Companion_instance_35 = new Companion_35();
  Companion_instance_43 = new Companion_43();
  Companion_instance_47 = new Companion_47();
  Companion_instance_48 = new Companion_48();
  Companion_instance_54 = new Companion_54();
  Companion_instance_56 = new Companion_56();
  Companion_instance_57 = new Companion_57();
  Companion_instance_62 = new Companion_62();
  Companion_instance_63 = new Companion_63();
  Companion_instance_64 = new Companion_64();
  Stats_instance = new Stats();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = _ColorMatrix___init__impl__3gytx1;
  _.$_$.b = CharDirection_getInstance;
  _.$_$.c = CharProperties_getInstance;
  _.$_$.d = Companion_getInstance_1;
  _.$_$.e = Companion_getInstance_2;
  _.$_$.f = Companion_getInstance_4;
  _.$_$.g = Companion_getInstance_6;
  _.$_$.h = Companion_getInstance_8;
  _.$_$.i = Companion_getInstance_9;
  _.$_$.j = Companion_getInstance_10;
  _.$_$.k = Companion_getInstance_13;
  _.$_$.l = Companion_getInstance_15;
  _.$_$.m = Companion_getInstance_16;
  _.$_$.n = Companion_getInstance_22;
  _.$_$.o = Companion_getInstance_25;
  _.$_$.p = Companion_getInstance_28;
  _.$_$.q = Companion_instance_35;
  _.$_$.r = Companion_getInstance_36;
  _.$_$.s = Companion_getInstance_37;
  _.$_$.t = ShadowUtils_getInstance;
  _.$_$.u = Companion_getInstance_38;
  _.$_$.v = Alignment_CENTER_getInstance;
  _.$_$.w = Alignment_END_getInstance;
  _.$_$.x = Alignment_JUSTIFY_getInstance;
  _.$_$.y = Alignment_LEFT_getInstance;
  _.$_$.z = Alignment_RIGHT_getInstance;
  _.$_$.a1 = Alignment_START_getInstance;
  _.$_$.b1 = BaselineMode_ALPHABETIC_getInstance;
  _.$_$.c1 = DecorationLineStyle_DASHED_getInstance;
  _.$_$.d1 = DecorationLineStyle_DOTTED_getInstance;
  _.$_$.e1 = DecorationLineStyle_DOUBLE_getInstance;
  _.$_$.f1 = DecorationLineStyle_SOLID_getInstance;
  _.$_$.g1 = DecorationLineStyle_WAVY_getInstance;
  _.$_$.h1 = Direction_LTR_getInstance;
  _.$_$.i1 = Direction_RTL_getInstance;
  _.$_$.j1 = HeightMode_ALL_getInstance;
  _.$_$.k1 = HeightMode_DISABLE_ALL_getInstance;
  _.$_$.l1 = HeightMode_DISABLE_FIRST_ASCENT_getInstance;
  _.$_$.m1 = HeightMode_DISABLE_LAST_DESCENT_getInstance;
  _.$_$.n1 = PlaceholderAlignment_ABOVE_BASELINE_getInstance;
  _.$_$.o1 = PlaceholderAlignment_BOTTOM_getInstance;
  _.$_$.p1 = PlaceholderAlignment_MIDDLE_getInstance;
  _.$_$.q1 = PlaceholderAlignment_TOP_getInstance;
  _.$_$.r1 = RectHeightMode_MAX_getInstance;
  _.$_$.s1 = RectHeightMode_STRUT_getInstance;
  _.$_$.t1 = RectWidthMode_TIGHT_getInstance;
  _.$_$.u1 = SVGLengthUnit_PX_getInstance;
  _.$_$.v1 = SVGPreserveAspectRatioAlign_NONE_getInstance;
  _.$_$.w1 = BlendMode_CLEAR_getInstance;
  _.$_$.x1 = BlendMode_COLOR_BURN_getInstance;
  _.$_$.y1 = BlendMode_COLOR_DODGE_getInstance;
  _.$_$.z1 = BlendMode_COLOR_getInstance;
  _.$_$.a2 = BlendMode_DARKEN_getInstance;
  _.$_$.b2 = BlendMode_DIFFERENCE_getInstance;
  _.$_$.c2 = BlendMode_DST_ATOP_getInstance;
  _.$_$.d2 = BlendMode_DST_IN_getInstance;
  _.$_$.e2 = BlendMode_DST_OUT_getInstance;
  _.$_$.f2 = BlendMode_DST_OVER_getInstance;
  _.$_$.g2 = BlendMode_DST_getInstance;
  _.$_$.h2 = BlendMode_EXCLUSION_getInstance;
  _.$_$.i2 = BlendMode_HARD_LIGHT_getInstance;
  _.$_$.j2 = BlendMode_HUE_getInstance;
  _.$_$.k2 = BlendMode_LIGHTEN_getInstance;
  _.$_$.l2 = BlendMode_LUMINOSITY_getInstance;
  _.$_$.m2 = BlendMode_MODULATE_getInstance;
  _.$_$.n2 = BlendMode_MULTIPLY_getInstance;
  _.$_$.o2 = BlendMode_OVERLAY_getInstance;
  _.$_$.p2 = BlendMode_PLUS_getInstance;
  _.$_$.q2 = BlendMode_SATURATION_getInstance;
  _.$_$.r2 = BlendMode_SCREEN_getInstance;
  _.$_$.s2 = BlendMode_SOFT_LIGHT_getInstance;
  _.$_$.t2 = BlendMode_SRC_ATOP_getInstance;
  _.$_$.u2 = BlendMode_SRC_IN_getInstance;
  _.$_$.v2 = BlendMode_SRC_OUT_getInstance;
  _.$_$.w2 = BlendMode_SRC_OVER_getInstance;
  _.$_$.x2 = BlendMode_SRC_getInstance;
  _.$_$.y2 = BlendMode_XOR_getInstance;
  _.$_$.z2 = ClipMode_DIFFERENCE_getInstance;
  _.$_$.a3 = ClipMode_INTERSECT_getInstance;
  _.$_$.b3 = ColorAlphaType_OPAQUE_getInstance;
  _.$_$.c3 = ColorAlphaType_PREMUL_getInstance;
  _.$_$.d3 = ColorType_ALPHA_8_getInstance;
  _.$_$.e3 = ColorType_RGBA_F16_getInstance;
  _.$_$.f3 = ColorType_RGB_565_getInstance;
  _.$_$.g3 = EncodedImageFormat_JPEG_getInstance;
  _.$_$.h3 = EncodedImageFormat_PNG_getInstance;
  _.$_$.i3 = FilterMode_LINEAR_getInstance;
  _.$_$.j3 = FilterMode_NEAREST_getInstance;
  _.$_$.k3 = FilterTileMode_CLAMP_getInstance;
  _.$_$.l3 = FilterTileMode_DECAL_getInstance;
  _.$_$.m3 = FilterTileMode_MIRROR_getInstance;
  _.$_$.n3 = FilterTileMode_REPEAT_getInstance;
  _.$_$.o3 = FontEdging_ALIAS_getInstance;
  _.$_$.p3 = FontEdging_ANTI_ALIAS_getInstance;
  _.$_$.q3 = FontEdging_SUBPIXEL_ANTI_ALIAS_getInstance;
  _.$_$.r3 = FontHinting_FULL_getInstance;
  _.$_$.s3 = FontHinting_NONE_getInstance;
  _.$_$.t3 = FontHinting_NORMAL_getInstance;
  _.$_$.u3 = FontHinting_SLIGHT_getInstance;
  _.$_$.v3 = FontSlant_ITALIC_getInstance;
  _.$_$.w3 = FontSlant_UPRIGHT_getInstance;
  _.$_$.x3 = MipmapMode_NEAREST_getInstance;
  _.$_$.y3 = MipmapMode_NONE_getInstance;
  _.$_$.z3 = PaintMode_FILL_getInstance;
  _.$_$.a4 = PaintMode_STROKE_getInstance;
  _.$_$.b4 = PaintStrokeCap_BUTT_getInstance;
  _.$_$.c4 = PaintStrokeCap_ROUND_getInstance;
  _.$_$.d4 = PaintStrokeCap_SQUARE_getInstance;
  _.$_$.e4 = PaintStrokeJoin_BEVEL_getInstance;
  _.$_$.f4 = PaintStrokeJoin_MITER_getInstance;
  _.$_$.g4 = PaintStrokeJoin_ROUND_getInstance;
  _.$_$.h4 = PathDirection_CLOCKWISE_getInstance;
  _.$_$.i4 = PathDirection_COUNTER_CLOCKWISE_getInstance;
  _.$_$.j4 = PathFillMode_EVEN_ODD_getInstance;
  _.$_$.k4 = PathFillMode_WINDING_getInstance;
  _.$_$.l4 = PathOp_DIFFERENCE_getInstance;
  _.$_$.m4 = PathOp_INTERSECT_getInstance;
  _.$_$.n4 = PathOp_REVERSE_DIFFERENCE_getInstance;
  _.$_$.o4 = PathOp_UNION_getInstance;
  _.$_$.p4 = PathOp_XOR_getInstance;
  _.$_$.q4 = FontCollection_init_$Create$;
  _.$_$.r4 = TextStyle_init_$Create$;
  _.$_$.s4 = TypefaceFontProviderWithFallback_init_$Create$;
  _.$_$.t4 = SVGDOM_init_$Create$;
  _.$_$.u4 = SVGPreserveAspectRatio_init_$Create$_0;
  _.$_$.v4 = Bitmap_init_$Create$;
  _.$_$.w4 = Canvas_init_$Create$;
  _.$_$.x4 = Font_init_$Create$_0;
  _.$_$.y4 = FontStyle_init_$Create$;
  _.$_$.z4 = FontVariation_init_$Create$;
  _.$_$.a5 = Paint_init_$Create$;
  _.$_$.b5 = Path_init_$Create$;
  _.$_$.c5 = PathBuilder_init_$Create$;
  _.$_$.d5 = PathBuilder_init_$Create$_0;
  _.$_$.e5 = PathMeasure_init_$Create$;
  _.$_$.f5 = PictureRecorder_init_$Create$;
  _.$_$.g5 = RTreeFactory_init_$Create$;
  _.$_$.h5 = RenderNode_init_$Create$;
  _.$_$.i5 = RenderNodeContext_init_$Create$;
  _.$_$.j5 = DecorationStyle;
  _.$_$.k5 = LineMetrics;
  _.$_$.l5 = ParagraphBuilder;
  _.$_$.m5 = ParagraphStyle;
  _.$_$.n5 = PlaceholderStyle;
  _.$_$.o5 = Shadow;
  _.$_$.p5 = TextBox;
  _.$_$.q5 = TextIndent;
  _.$_$.r5 = SVGLength;
  _.$_$.s5 = Bitmap;
  _.$_$.t5 = ColorInfo;
  _.$_$.u5 = CubicResampler;
  _.$_$.v5 = FilterMipmap;
  _.$_$.w5 = FontMgrWithFallback;
  _.$_$.x5 = GradientStyle;
  _.$_$.y5 = ImageInfo;
  _.$_$.z5 = Matrix33;
  _.$_$.a6 = Matrix44;
  _.$_$.b6 = Point3;
  _.$_$.c6 = Point;
  _.$_$.d6 = Rect;
  _.$_$.e6 = onWasmReady;
  _.$_$.f6 = SkiaLayer;
  _.$_$.g6 = SkikoRenderDelegate;
  _.$_$.h6 = currentNanoTime;
  _.$_$.i6 = get_currentSystemTheme;
  _.$_$.j6 = get_hostOs;
  //endregion
  return _;
}));

//# sourceMappingURL=skiko-kjs.js.map
